import { api } from './baseApi';
export type Maybe<T> = T;
export type InputMaybe<T> = T;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  Date: any;
  DateTime: any;
  Decimal: any;
  EmailAddress: any;
  JSON: any;
  JSONArray: any;
  JSONObject: any;
  PhoneNumber: any;
  Time: any;
  UUID: any;
};

export type AclRole = {
  __typename?: 'AclRole';
  id?: Maybe<Scalars['UUID']>;
  key?: Maybe<Scalars['String']>;
  lvl?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export enum AclRoleKey {
  Admin = 'ADMIN',
  Doctor = 'DOCTOR',
  Manager = 'MANAGER',
  MonitoringCenter = 'MONITORING_CENTER',
  Nurse = 'NURSE',
  SurveillanceCenter = 'SURVEILLANCE_CENTER',
  Therapist = 'THERAPIST'
}

export type AclRoleResult = {
  __typename?: 'AclRoleResult';
  data?: Maybe<Array<Maybe<AclRole>>>;
  meta?: Maybe<PageInfo>;
};

export type Action = {
  __typename?: 'Action';
  extra?: Maybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type ActivateUserSubscriptionByRedeemCode = {
  admin?: InputMaybe<Scalars['String']>;
  redeemCode: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type AddLaboratoryRequisitionToPatientInput = {
  laboratoryRequisitionResultId: Scalars['UUID'];
};

export type Address = {
  __typename?: 'Address';
  accommodationZone?: Maybe<Scalars['String']>;
  apartmentNumber?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['EmailAddress']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  departmentNumber?: Maybe<Scalars['String']>;
  descriptiveNumber?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  formattedFullAddress?: Maybe<Scalars['String']>;
  formattedShortAddress?: Maybe<Scalars['String']>;
  fullAddress?: Maybe<Scalars['String']>;
  governName?: Maybe<Scalars['String']>;
  governType?: Maybe<Scalars['String']>;
  guideNumber?: Maybe<Scalars['String']>;
  houseType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  identificationNumber?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  kilometer?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  manzana?: Maybe<Scalars['String']>;
  parish?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  province?: Maybe<Scalars['String']>;
  reference?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  shortAddress?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  street2?: Maybe<Scalars['String']>;
  streetType?: Maybe<Scalars['String']>;
  taxIdentificationNumber?: Maybe<Scalars['String']>;
  terytCode?: Maybe<Scalars['String']>;
  type?: Maybe<AddressType>;
  ubigeo?: Maybe<Scalars['String']>;
  zoneName?: Maybe<Scalars['String']>;
  zoneType?: Maybe<Scalars['String']>;
};

export type AddressInput = {
  accommodationZone?: InputMaybe<Scalars['String']>;
  apartmentNumber?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  departmentNumber?: InputMaybe<Scalars['String']>;
  descriptiveNumber?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  formattedFullAddress?: InputMaybe<Scalars['String']>;
  formattedShortAddress?: InputMaybe<Scalars['String']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  governName?: InputMaybe<Scalars['String']>;
  governType?: InputMaybe<Scalars['String']>;
  guideNumber?: InputMaybe<Scalars['String']>;
  houseType?: InputMaybe<Scalars['String']>;
  kilometer?: InputMaybe<Scalars['String']>;
  lot?: InputMaybe<Scalars['String']>;
  manzana?: InputMaybe<Scalars['String']>;
  parish?: InputMaybe<Scalars['String']>;
  postCode?: InputMaybe<Scalars['String']>;
  province?: InputMaybe<Scalars['String']>;
  reference?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  shortAddress?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  streetType?: InputMaybe<Scalars['String']>;
  ubigeo?: InputMaybe<Scalars['String']>;
  zoneName?: InputMaybe<Scalars['String']>;
  zoneType?: InputMaybe<Scalars['String']>;
};

export enum AddressType {
  Billing = 'BILLING',
  Contact = 'CONTACT'
}

export type AssignCaseToMeInput = {
  caseId: Scalars['UUID'];
  message?: InputMaybe<Scalars['String']>;
};

export type AssignLaboratoryResultMiseInput = {
  laboratoryResultMiseId: Scalars['UUID'];
};

export type AuditLog = {
  __typename?: 'AuditLog';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['Int'];
  targetEntityId?: Maybe<Scalars['String']>;
  targetEntityType?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type AuditLogsResult = {
  __typename?: 'AuditLogsResult';
  data?: Maybe<Array<Maybe<AuditLog>>>;
  meta?: Maybe<PageInfo>;
};

export type AvailableDoctor = {
  __typename?: 'AvailableDoctor';
  city?: Maybe<Scalars['String']>;
  clkId?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  salutationAfter?: Maybe<Scalars['String']>;
  salutationBefore?: Maybe<Scalars['String']>;
};

export type AvailableDoctorsResult = {
  __typename?: 'AvailableDoctorsResult';
  data?: Maybe<Array<Maybe<AvailableDoctor>>>;
  meta?: Maybe<PageInfo>;
};

export type Badge = {
  __typename?: 'Badge';
  backgroundColor?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type BioScanHistoriesResult = {
  __typename?: 'BioScanHistoriesResult';
  data?: Maybe<Array<Maybe<BioScanHistory>>>;
  meta?: Maybe<PageInfo>;
};

export type BioScanHistory = {
  __typename?: 'BioScanHistory';
  age?: Maybe<Scalars['String']>;
  breathingRateConfidence?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  gender?: Maybe<Scalars['String']>;
  heartRateConfidence?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['UUID']>;
  items?: Maybe<Array<Maybe<HealthDataItem>>>;
  weight?: Maybe<Scalars['String']>;
};

export type BulkUserHealthCategoryPermissionInput = {
  items?: InputMaybe<Array<InputMaybe<UserHealthCategoryPermissionInput>>>;
};

export type Calendar = {
  __typename?: 'Calendar';
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  meetingType: Array<MeetingType>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<CalendarSettings>;
  type: CalendarType;
  workplace: Workplace;
  workplaceId: Scalars['UUID'];
};

export type CalendarEventsWhereInput = {
  calendarId: Scalars['UUID'];
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type CalendarSettings = {
  __typename?: 'CalendarSettings';
  icon?: Maybe<Scalars['String']>;
  menuText?: Maybe<Scalars['String']>;
};

export enum CalendarType {
  Custom = 'CUSTOM',
  Default = 'DEFAULT'
}

export type CalendarWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type CalendarsResult = {
  __typename?: 'CalendarsResult';
  data: Array<Calendar>;
  meta?: Maybe<PageInfo>;
};

export type CancelDrMaxReservationInput = {
  reservationId: Scalars['String'];
};

export type CancelDrMaxReservationResult = {
  __typename?: 'CancelDrMaxReservationResult';
  message?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type CancelP1MedicalRequestInput = {
  id: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
};

export type CancelP1PrescriptionInput = {
  id: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
};

export type CareClaim = {
  __typename?: 'CareClaim';
  canDelete?: Maybe<Scalars['Boolean']>;
  createdAt: Scalars['DateTime'];
  createdBy: User;
  createdById: Scalars['UUID'];
  document: Document;
  documentId: Scalars['UUID'];
  documentType?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  insuranceCompany?: Maybe<TermItem>;
  insuranceCompanyId?: Maybe<Scalars['UUID']>;
  medicalProcedure: MedicalProcedure;
  medicalProcedureId: Scalars['UUID'];
  registered?: Maybe<Scalars['DateTime']>;
};

export type CareClaimDeleteBulkWhereInput = {
  ids: Array<Scalars['UUID']>;
};

export type CareClaimPersistBulkWhereInput = {
  documentId: Scalars['UUID'];
};

export type CareClaimWhereInput = {
  createdById?: InputMaybe<Scalars['UUID']>;
  medicalProcedureFulltext?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['String']>;
};

export type CareClaimWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type CareClaimsResult = {
  __typename?: 'CareClaimsResult';
  data?: Maybe<Array<Maybe<CareClaim>>>;
  meta?: Maybe<PageInfo>;
};

export type Case = {
  __typename?: 'Case';
  caseChatPreview?: Maybe<Scalars['Boolean']>;
  caseEntries?: Maybe<Array<Maybe<CaseEntry>>>;
  caseStatus?: Maybe<Scalars['JSONObject']>;
  caseStatusValue?: Maybe<CaseStatus>;
  caseType?: Maybe<CaseType>;
  caseTypeId?: Maybe<Scalars['UUID']>;
  child?: Maybe<User>;
  childId?: Maybe<Scalars['UUID']>;
  code?: Maybe<Scalars['String']>;
  contactSpecialist?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  descriptionExtra?: Maybe<Scalars['JSONObject']>;
  diagnosis?: Maybe<Scalars['String']>;
  doctor?: Maybe<User>;
  doctorId?: Maybe<Scalars['UUID']>;
  doctorSurvey?: Maybe<CaseDoctorSurvey>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  isAssigned?: Maybe<Scalars['Boolean']>;
  isChatActive?: Maybe<Scalars['Boolean']>;
  isImmediate?: Maybe<Scalars['JSONObject']>;
  isMeddi?: Maybe<Scalars['Boolean']>;
  isMyCase?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  isSpecialist?: Maybe<Scalars['Boolean']>;
  isSupport?: Maybe<Scalars['Boolean']>;
  lastCaseEntry?: Maybe<CaseEntry>;
  lastNote?: Maybe<Note>;
  medicalReport?: Maybe<MedicalReport>;
  medicalReports?: Maybe<Array<Maybe<MedicalReport>>>;
  medicationLasted?: Maybe<Array<Maybe<Scalars['JSONObject']>>>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  patient?: Maybe<User>;
  patientDescription?: Maybe<Scalars['String']>;
  patientId?: Maybe<Scalars['UUID']>;
  patientParent?: Maybe<User>;
  paymentMethod?: Maybe<Scalars['String']>;
  priority?: Maybe<TermItem>;
  priorityId?: Maybe<Scalars['UUID']>;
  reassignedFrom?: Maybe<WorkplaceMember>;
  solveTo?: Maybe<Scalars['DateTime']>;
  solved?: Maybe<Scalars['Boolean']>;
  solvedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  titleShort?: Maybe<Scalars['String']>;
  totalUnreadCaseEntries?: Maybe<Scalars['Int']>;
  transportMethod?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  visibleAt?: Maybe<Scalars['DateTime']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type CaseMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
};

export type CaseContact = {
  __typename?: 'CaseContact';
  iconUrl?: Maybe<Scalars['String']>;
  textRow1?: Maybe<Scalars['String']>;
  textRow2?: Maybe<Scalars['String']>;
  textRow3?: Maybe<Scalars['String']>;
  type?: Maybe<CaseContactType>;
  userId?: Maybe<Scalars['String']>;
  workplaceId?: Maybe<Scalars['String']>;
  workplaceMemberId?: Maybe<Scalars['String']>;
  workplaceMemberUserRelation?: Maybe<UserRelation>;
};


export type CaseContactWorkplaceMemberUserRelationArgs = {
  type?: InputMaybe<UserRelationType>;
};

export enum CaseContactType {
  Workplace = 'WORKPLACE',
  WorkplaceMember = 'WORKPLACE_MEMBER'
}

export type CaseContactsResult = {
  __typename?: 'CaseContactsResult';
  data?: Maybe<Array<Maybe<CaseContact>>>;
  meta?: Maybe<PageInfo>;
};

export enum CaseCreateDay {
  Before_1 = 'BEFORE_1',
  Before_3 = 'BEFORE_3',
  Before_7 = 'BEFORE_7',
  DateRange = 'DATE_RANGE'
}

export type CaseDoctor = {
  __typename?: 'CaseDoctor';
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  userRelation?: Maybe<UserRelation>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type CaseDoctorSurvey = {
  __typename?: 'CaseDoctorSurvey';
  show: Scalars['Boolean'];
  wizardKey?: Maybe<Scalars['String']>;
};

export type CaseDoctorsResult = {
  __typename?: 'CaseDoctorsResult';
  data?: Maybe<Array<Maybe<CaseDoctor>>>;
  meta?: Maybe<PageInfo>;
};

export type CaseEntriesResult = {
  __typename?: 'CaseEntriesResult';
  data?: Maybe<Array<Maybe<CaseEntry>>>;
  meta?: Maybe<PageInfo>;
};

export type CaseEntry = {
  __typename?: 'CaseEntry';
  avResult?: Maybe<Scalars['String']>;
  case?: Maybe<Case>;
  caseEntryMembers?: Maybe<Array<Maybe<CaseEntryMember>>>;
  caseId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSONObject']>;
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['Int']>;
  inDocumentation?: Maybe<Scalars['Boolean']>;
  message?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  sender?: Maybe<User>;
  senderId?: Maybe<Scalars['UUID']>;
  thumb?: Maybe<Scalars['Boolean']>;
  time?: Maybe<Scalars['DateTime']>;
  type?: Maybe<Scalars['String']>;
};

export type CaseEntryMember = {
  __typename?: 'CaseEntryMember';
  caseEntry?: Maybe<CaseEntry>;
  caseEntryId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  seen?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum CaseSolvedMonth {
  Before_1 = 'BEFORE_1',
  Before_3 = 'BEFORE_3'
}

export enum CaseStatus {
  InProgress = 'IN_PROGRESS',
  New = 'NEW'
}

export type CaseType = {
  __typename?: 'CaseType';
  backgroundColor?: Maybe<Scalars['String']>;
  canBookOnSite?: Maybe<Scalars['Boolean']>;
  canBookOnline?: Maybe<Scalars['Boolean']>;
  canOrderImmediate?: Maybe<Scalars['Boolean']>;
  caseTypeItems?: Maybe<Array<Maybe<CaseTypeItem>>>;
  categoryTypeId?: Maybe<Scalars['UUID']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  descriptionKey?: Maybe<Scalars['String']>;
  eventCancelPaymentInterval?: Maybe<Scalars['Int']>;
  eventCancelWithPayment?: Maybe<Scalars['Boolean']>;
  eventInterval?: Maybe<Scalars['Int']>;
  fullPath?: Maybe<Scalars['String']>;
  hiddenForPatient?: Maybe<Scalars['Boolean']>;
  iconUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  isEditable?: Maybe<Scalars['Boolean']>;
  isSystem?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  labelKey?: Maybe<Scalars['String']>;
  module?: Maybe<Scalars['String']>;
  notificationBook?: Maybe<Scalars['Boolean']>;
  notificationCase?: Maybe<Scalars['Boolean']>;
  parentCaseTypeId?: Maybe<Scalars['UUID']>;
  price?: Maybe<Price>;
  priceId?: Maybe<Scalars['UUID']>;
  rank?: Maybe<Scalars['Int']>;
  rootCaseType?: Maybe<CaseType>;
  type?: Maybe<Scalars['String']>;
};

export type CaseTypeItem = {
  __typename?: 'CaseTypeItem';
  caseType?: Maybe<CaseType>;
  caseTypeId?: Maybe<Scalars['UUID']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  parentCaseTypeItemId?: Maybe<Scalars['UUID']>;
  position?: Maybe<Scalars['Int']>;
  rank?: Maybe<Scalars['Int']>;
  settings?: Maybe<Scalars['JSONObject']>;
  subtype?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum CaseTypeType {
  CaseType = 'CASE_TYPE',
  Folder = 'FOLDER'
}

export type CasesResult = {
  __typename?: 'CasesResult';
  data?: Maybe<Array<Maybe<Case>>>;
  meta?: Maybe<PageInfo>;
};

export type Certificate = {
  __typename?: 'Certificate';
  expires?: Maybe<Scalars['DateTime']>;
  fileId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  isExpired?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['UUID']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type CertificatesResult = {
  __typename?: 'CertificatesResult';
  data?: Maybe<Array<Maybe<Certificate>>>;
  meta?: Maybe<PageInfo>;
};

export type ChangePaymentMethodUrl = {
  __typename?: 'ChangePaymentMethodUrl';
  url?: Maybe<Scalars['String']>;
};

export type ChargeStatus = {
  __typename?: 'ChargeStatus';
  message?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ChargeSubscriptionInput = {
  paymentMethod?: InputMaybe<Scalars['String']>;
  userSubscriptionId?: InputMaybe<Scalars['String']>;
};

export type Conversation = {
  __typename?: 'Conversation';
  conversationMembers: Array<ConversationMember>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  lastMessage?: Maybe<Message>;
  messages?: Maybe<Array<Maybe<Message>>>;
  myUnreadMessages?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  singleRecipient?: Maybe<ConversationMember>;
  totalRecipients?: Maybe<Scalars['Int']>;
  type?: Maybe<ConversationType>;
};


export type ConversationConversationMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type ConversationMessagesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export enum ConversationFolderEnum {
  Inbox = 'INBOX',
  Sent = 'SENT'
}

export type ConversationMember = {
  __typename?: 'ConversationMember';
  conversation: Conversation;
  conversationId: Scalars['UUID'];
  id: Scalars['UUID'];
  user: User;
  userId: Scalars['UUID'];
};

export type ConversationMemberResult = {
  __typename?: 'ConversationMemberResult';
  data?: Maybe<Array<Maybe<ConversationMember>>>;
  meta?: Maybe<PageInfo>;
};

export enum ConversationType {
  HealthPlan = 'HEALTH_PLAN',
  Normal = 'NORMAL',
  Notification = 'NOTIFICATION',
  WorkflowChatbot = 'WORKFLOW_CHATBOT'
}

export type ConversationsResult = {
  __typename?: 'ConversationsResult';
  data?: Maybe<Array<Maybe<Conversation>>>;
  meta?: Maybe<PageInfo>;
};

export type CreateCareClaimInput = {
  canDelete?: InputMaybe<Scalars['Boolean']>;
  documentId: Scalars['UUID'];
  medicalProcedureId: Scalars['UUID'];
  patientId: Scalars['String'];
};

export enum CreateCaseTarget {
  Workplace = 'WORKPLACE',
  WorkplaceMember = 'WORKPLACE_MEMBER'
}

export type CreateCustomCalendarInput = {
  calendarTermId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateDrMaxPrescriptionReservationInput = {
  drmaxPickupPlaceId: Scalars['UUID'];
  prescriptionId: Scalars['UUID'];
  userId?: InputMaybe<Scalars['UUID']>;
};

export type CreateEventInput = {
  dateFrom: Scalars['DateTime'];
  dateTo: Scalars['DateTime'];
  eventMembers?: InputMaybe<Array<InputMaybe<CreateEventMemberInput>>>;
  type: EventType;
};

export type CreateEventMemberInput = {
  user?: InputMaybe<CreateEventMemberUserInput>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type CreateEventMemberUserInput = {
  birthNumber?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['EmailAddress']>;
  contactPhoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  firstName?: InputMaybe<Scalars['String']>;
  insuranceCompanyTermItemId?: InputMaybe<Scalars['UUID']>;
  lastName?: InputMaybe<Scalars['String']>;
};

export type CreateGroupInput = {
  name: Scalars['String'];
  shouldAddAllUsers?: InputMaybe<Scalars['Boolean']>;
  userIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type CreateGroupMemberInput = {
  groupId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type CreateGroupMembersInput = {
  groupId: Scalars['UUID'];
  userIds: Array<Scalars['UUID']>;
};

export type CreateHealthPlanInput = {
  active: Scalars['Boolean'];
  code: Scalars['String'];
  initialQuestionnaireCode?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  settings?: InputMaybe<Scalars['JSONObject']>;
};

export type CreateHealthPlanUserFromDataInput = {
  addToPatientECard?: InputMaybe<Scalars['Boolean']>;
  healthPlanId: Scalars['UUID'];
  ingestion?: InputMaybe<Scalars['JSONArray']>;
  questionnaire?: InputMaybe<Scalars['JSONObject']>;
  userId: Scalars['UUID'];
};

export type CreateHealthPlanUserInput = {
  healthPlanId: Scalars['UUID'];
  questionnaireResultId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
};

export type CreateHealthPlanWorkplaceInput = {
  healthPlanId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type CreateInsuranceCompanyBatchInput = {
  careClaimIds: Array<Scalars['UUID']>;
  char: Scalars['String'];
  dtyp: Scalars['String'];
  insuranceCompanyBranchCode: Scalars['String'];
  insuranceCompanyCode: Scalars['String'];
  periodMonth: Scalars['String'];
  periodYear: Scalars['Int'];
};

export type CreateInsuranceReportExportFiles = {
  insuranceCompanyCode: Scalars['String'];
  month: Scalars['Int'];
  rootWorkplaceId: Scalars['UUID'];
  type?: InputMaybe<InsuranceReportType>;
  year: Scalars['Int'];
};

export type CreateInsuranceReportInput = {
  birthNumber?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  diagnosis?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  documentId?: InputMaybe<Scalars['UUID']>;
  extra?: InputMaybe<Scalars['JSON']>;
  insuranceId: Scalars['UUID'];
  operationId: Scalars['UUID'];
  patientId: Scalars['UUID'];
  points?: InputMaybe<Scalars['Int']>;
  reportedAt?: InputMaybe<Scalars['DateTime']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateIplpTemplateInput = {
  dosage?: InputMaybe<Scalars['String']>;
  manual?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateLaboratoryInput = {
  address?: InputMaybe<AddressInput>;
  code: Scalars['String'];
  icl?: InputMaybe<Scalars['String']>;
  ico?: InputMaybe<Scalars['String']>;
  icp?: InputMaybe<Scalars['String']>;
  icz?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CreateLaboratoryRequisitionTemplate = {
  data: Scalars['JSON'];
  doctorId?: InputMaybe<Scalars['UUID']>;
  laboratoryRequisitionId: Scalars['UUID'];
  name: Scalars['String'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateLaboratoryRequisitionWorkplaceInput = {
  laboratoryRequisitionId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateLaboratoryWizardInput = {
  laboratoryId: Scalars['UUID'];
  type?: InputMaybe<LaboratoryWizardType>;
  wizardId: Scalars['UUID'];
};

export type CreateLaboratoryWorkplaceInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
  laboratoryId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateMedicalExaminationInput = {
  patientId: Scalars['UUID'];
  type: MedicalExaminationType;
};

export type CreateMedicalHistoryTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateNoteInput = {
  caseId?: InputMaybe<Scalars['UUID']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  text: Scalars['String'];
};

export type CreateOperationReportInput = {
  code: Scalars['String'];
  extra?: InputMaybe<Scalars['JSON']>;
  insuranceId: Scalars['UUID'];
  ncziCode: Scalars['String'];
  points: Scalars['Int'];
  pricePerPoint?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
  workplaceId: Scalars['UUID'];
};

export type CreateOrUpdateQuestionnaireResultMemberInput = {
  hidden?: InputMaybe<Scalars['Boolean']>;
  questionnaireResultId: Scalars['UUID'];
  seen?: InputMaybe<Scalars['Boolean']>;
};

export type CreateP1MedicalRequestInput = {
  medicalFacilityId: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
  patientId: Scalars['UUID'];
  primaryDiagnose: Scalars['UUID'];
  procedureId?: InputMaybe<Scalars['UUID']>;
  requestTypeId: Scalars['UUID'];
  secondaryDiagnoses?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type CreateP1PrescriptionInput = {
  patientId: Scalars['UUID'];
  prescriptionMedicaments?: InputMaybe<Array<InputMaybe<CreateP1PrescriptionMedicamentsInput>>>;
};

export type CreateP1PrescriptionMedicamentsInput = {
  amountOfPackages: Scalars['Int'];
  applicationDescription?: InputMaybe<Scalars['String']>;
  applicationFrequency?: InputMaybe<Scalars['Int']>;
  applicationFrequencyAmount?: InputMaybe<Scalars['Int']>;
  dosageCount: Scalars['Float'];
  dosageInterval: Scalars['Int'];
  id: Scalars['UUID'];
  medicamentChange: Scalars['Boolean'];
  paymentCoverage: Scalars['String'];
  recipeRepeat?: InputMaybe<Scalars['Int']>;
  validFrom?: InputMaybe<Scalars['Date']>;
};

export type CreateP1PrescriptionResponse = {
  __typename?: 'CreateP1PrescriptionResponse';
  taskId?: Maybe<Scalars['String']>;
};

export type CreatePhraseInput = {
  name?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['Int']>;
  type: PhraseType;
  value: Scalars['String'];
};

export type CreatePriceInput = {
  currency?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Decimal']>;
  priceWithVat?: InputMaybe<Scalars['Decimal']>;
  vatRate?: InputMaybe<Scalars['Float']>;
};

export type CreateProfileInput = {
  birthNumber?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['EmailAddress']>;
  contactPhoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  firstName?: InputMaybe<Scalars['String']>;
  insuranceCompanyTermItemId?: InputMaybe<Scalars['UUID']>;
  lastName?: InputMaybe<Scalars['String']>;
  salutationAfter?: InputMaybe<Scalars['String']>;
  salutationBefore?: InputMaybe<Scalars['String']>;
};

export type CreateRatingInput = {
  caseId?: InputMaybe<Scalars['UUID']>;
  stars?: InputMaybe<Scalars['Float']>;
  text?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<RatingType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type CreateServiceScheduleInput = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  type: ServiceScheduleType;
};

export type CreateServiceScheduleItemInput = {
  canBook?: InputMaybe<Scalars['Boolean']>;
  canBookOnSite?: InputMaybe<Scalars['Boolean']>;
  canBookOnline?: InputMaybe<Scalars['Boolean']>;
  canOrderImmediate?: InputMaybe<Scalars['Boolean']>;
  days: Array<InputMaybe<DayShortEnum>>;
  interval?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<CreatePriceInput>;
  repeatInterval?: InputMaybe<RepeatIntervalEnum>;
  repeatTo?: InputMaybe<Scalars['Date']>;
  servicesScheduleId: Scalars['UUID'];
  timeFrom: Scalars['Time'];
  timeTo: Scalars['Time'];
  workplaceCaseTypeId?: InputMaybe<Scalars['UUID']>;
};

export type CreateSubscriptionGroup = {
  key: Scalars['String'];
};

export type CreateSubscriptionInput = {
  buyable?: InputMaybe<Scalars['Boolean']>;
  code: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  descriptionItems?: InputMaybe<Scalars['String']>;
  descriptionShort?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  items?: InputMaybe<Array<InputMaybe<CreateSubscriptionItemInput>>>;
  name: Scalars['String'];
  nameAdmin?: InputMaybe<Scalars['String']>;
  partner?: InputMaybe<Scalars['Int']>;
  periods?: InputMaybe<Array<InputMaybe<CreateSubscriptionPeriodInput>>>;
  redeemCodeRequired?: InputMaybe<Scalars['Boolean']>;
  theme?: InputMaybe<ThemeEnum>;
};

export type CreateSubscriptionItemInput = {
  extra?: InputMaybe<Scalars['JSONObject']>;
  type: SubscriptionItemType;
};

export type CreateSubscriptionPeriodInput = {
  period?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<CreatePriceInput>;
  type: SubscriptionPeriodType;
  value?: InputMaybe<Scalars['String']>;
};

export type CreateSubscriptionRedeemCodeInput = {
  code: Scalars['String'];
  subscriptionCode?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['UUID']>;
  subscriptionPeriodId?: InputMaybe<Scalars['UUID']>;
};

export type CreateTokenInput = {
  type: TokenType;
};

export type CreateToothInput = {
  dentitionId: Scalars['UUID'];
  number: Scalars['Int'];
  pathology: ToothPathologyInput;
};

export type CreateUserInput = {
  email?: InputMaybe<Scalars['EmailAddress']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<CreateProfileInput>;
};

export type CreateUserMedicationLastedInput = {
  data?: InputMaybe<Scalars['JSON']>;
  prescriptionId?: InputMaybe<Scalars['UUID']>;
  prescriptionMedicamentData?: InputMaybe<Scalars['JSON']>;
  prescriptionMedicamentId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateUserSubscriptionMemberInput = {
  userId?: InputMaybe<Scalars['UUID']>;
  userSubscriptionId: Scalars['UUID'];
};

export type CreateWizardResultInput = {
  userId?: InputMaybe<Scalars['UUID']>;
  wizardId: Scalars['UUID'];
  wizardResultItems?: InputMaybe<Array<CreateWizardResultItemInput>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type CreateWizardResultItemInput = {
  key: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['JSONObject']>;
};

export type CreateWorkplaceAbsenceInput = {
  allowContactInAbsence?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  start: Scalars['DateTime'];
  workplaceIds: Array<InputMaybe<Scalars['UUID']>>;
};

export type CreateWorkplaceMedicalProcedure = {
  medicalProcedureId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type CreateWorkplaceMemberAbsenceInput = {
  allowContactInAbsence?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  end: Scalars['DateTime'];
  fullday?: InputMaybe<Scalars['Boolean']>;
  start: Scalars['DateTime'];
  workplaceMemberIds: Array<InputMaybe<Scalars['UUID']>>;
};

export type CreateWorkplacePresetInput = {
  memberType: WorkplacePresetMemberType;
  name: Scalars['String'];
  type: WorkplacePresetType;
};

export type CreateZusSickLeaveInput = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  patientId: Scalars['UUID'];
};

export type DashboardLayoutItem = {
  __typename?: 'DashboardLayoutItem';
  background?: Maybe<Scalars['JSONObject']>;
  badge?: Maybe<Scalars['JSONObject']>;
  children?: Maybe<Array<Maybe<DashboardLayoutItem>>>;
  extra?: Maybe<Scalars['JSONObject']>;
  settings?: Maybe<Scalars['JSONObject']>;
  template?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  titleParts?: Maybe<Array<Maybe<Scalars['String']>>>;
  type?: Maybe<Scalars['String']>;
};

export type DashboardTile = {
  __typename?: 'DashboardTile';
  action?: Maybe<Action>;
  badge?: Maybe<Scalars['JSONObject']>;
  button?: Maybe<Scalars['JSONObject']>;
  buttonText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleUpper?: Maybe<Scalars['JSONObject']>;
  type?: Maybe<Scalars['String']>;
  upperTitle?: Maybe<Scalars['String']>;
};

export type DateFilter = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export enum DayShortEnum {
  Fri = 'FRI',
  Mon = 'MON',
  Sat = 'SAT',
  Sun = 'SUN',
  Thu = 'THU',
  Tue = 'TUE',
  Wed = 'WED'
}

export type DeleteDocumentationFolderInput = {
  transferDocumentationFolderId?: InputMaybe<Scalars['UUID']>;
};

export type DeleteLaboratoryRequisitionWorkplaceInput = {
  id?: InputMaybe<Scalars['UUID']>;
  laboratoryRequisitionId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type DeleteTokenInput = {
  id: Scalars['Int'];
};

export type DeleteWizardResultInput = {
  id: Scalars['UUID'];
};

export type DeleteWorkplaceMedicalProcedure = {
  id: Scalars['UUID'];
};

export type DeleteWorkplaceMemberInput = {
  dateOfDeath?: InputMaybe<Scalars['Date']>;
  id?: InputMaybe<Scalars['UUID']>;
  reason?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type Dentition = {
  __typename?: 'Dentition';
  createdBy: User;
  createdById: Scalars['UUID'];
  id: Scalars['UUID'];
  teeth?: Maybe<Array<Tooth>>;
  user: User;
};

export type DentitionWhereInput = {
  userId: Scalars['UUID'];
};

export type Document = {
  __typename?: 'Document';
  cancelledAt?: Maybe<Scalars['DateTime']>;
  cancelledBy?: Maybe<User>;
  cancelledById?: Maybe<Scalars['UUID']>;
  cancelledByName?: Maybe<Scalars['String']>;
  careClaimIds?: Maybe<Array<Maybe<Scalars['UUID']>>>;
  careClaims?: Maybe<Array<Maybe<CareClaim>>>;
  content?: Maybe<DocumentItem>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  documentationFile?: Maybe<DocumentationFile>;
  file?: Maybe<File>;
  id: Scalars['UUID'];
  isCancelable?: Maybe<Scalars['Boolean']>;
  item?: Maybe<DocumentItem>;
  items?: Maybe<Array<Maybe<DocumentItem>>>;
  parentVersionDocument?: Maybe<Document>;
  parentVersionDocumentId?: Maybe<Scalars['UUID']>;
  previousVersionDocument?: Maybe<Document>;
  previousVersionDocumentId?: Maybe<Scalars['UUID']>;
  subType?: Maybe<DocumentSubType>;
  sync?: Maybe<SyncStatus>;
  title?: Maybe<DocumentItem>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<User>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type DocumentItemArgs = {
  type?: InputMaybe<Scalars['String']>;
};


export type DocumentItemsArgs = {
  types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type DocumentItem = {
  __typename?: 'DocumentItem';
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  type?: Maybe<Scalars['String']>;
};

export type DocumentLog = {
  __typename?: 'DocumentLog';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  document?: Maybe<Document>;
  documentId: Scalars['UUID'];
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  message?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type DocumentLogsResult = {
  __typename?: 'DocumentLogsResult';
  data?: Maybe<Array<DocumentLog>>;
  meta?: Maybe<PageInfo>;
};

export type DocumentLogsWhereInput = {
  createdById?: InputMaybe<Scalars['UUID']>;
  documentId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
};

export enum DocumentSubType {
  Hol = 'HOL',
  Ptdpn = 'PTDPN',
  Rdpn1 = 'RDPN1',
  Rdpn3 = 'RDPN3',
  Update = 'UPDATE'
}

export type DocumentTransferInput = {
  documentIds: Array<Scalars['UUID']>;
  documentName?: InputMaybe<Scalars['String']>;
  grouped?: InputMaybe<Scalars['Boolean']>;
  saveAsPDF?: InputMaybe<Scalars['Boolean']>;
  targetFolder: Scalars['UUID'];
  targetUserId?: InputMaybe<Scalars['UUID']>;
};

export enum DocumentType {
  Dekurz = 'DEKURZ',
  DekurzDraft = 'DEKURZ_DRAFT',
  DekurzDraftVersion = 'DEKURZ_DRAFT_VERSION',
  DekurzTemplate = 'DEKURZ_TEMPLATE',
  MedicalHistory = 'MEDICAL_HISTORY',
  MedicalReport = 'MEDICAL_REPORT',
  MedicalRequestForm = 'MEDICAL_REQUEST_FORM',
  MedicalRequestP1 = 'MEDICAL_REQUEST_P1',
  SickLeave = 'SICK_LEAVE'
}

export type DocumentWhereInput = {
  id?: InputMaybe<Scalars['UUID']>;
  subType?: InputMaybe<DocumentSubType>;
  type?: InputMaybe<DocumentType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type DocumentationFile = {
  __typename?: 'DocumentationFile';
  avResult?: Maybe<Scalars['String']>;
  avResultExpectedTimeToComplete?: Maybe<Scalars['Int']>;
  avResultText?: Maybe<Scalars['String']>;
  canBeShared?: Maybe<Scalars['Boolean']>;
  canBeSigned?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdByName?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  file?: Maybe<File>;
  fileGroupId?: Maybe<Scalars['String']>;
  fileTransfers?: Maybe<Meta>;
  fileUrl?: Maybe<Scalars['String']>;
  folder?: Maybe<DocumentationFolder>;
  folderId?: Maybe<Scalars['UUID']>;
  groupFiles?: Maybe<Array<Maybe<DocumentationFile>>>;
  groupFilesCount?: Maybe<Scalars['Int']>;
  hasThumb?: Maybe<Scalars['Boolean']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isEditable?: Maybe<Scalars['Boolean']>;
  isNew?: Maybe<Scalars['Boolean']>;
  isSeen?: Maybe<Scalars['Boolean']>;
  isSeenMarkedBy?: Maybe<User>;
  isSeenMarkedById?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  sourceCase?: Maybe<Case>;
  sourceCaseId?: Maybe<Scalars['UUID']>;
  thumbUrl?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  virtualUser?: Maybe<User>;
  virtualUserId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type DocumentationFileGroupFilesArgs = {
  onlyPatientFiles?: InputMaybe<Scalars['Boolean']>;
};

export type DocumentationFileWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type DocumentationFilesResult = {
  __typename?: 'DocumentationFilesResult';
  data: Array<DocumentationFile>;
  meta?: Maybe<PageInfo>;
};

export type DocumentationFolder = {
  __typename?: 'DocumentationFolder';
  accessType?: Maybe<Scalars['String']>;
  canCreateFile?: Maybe<Scalars['Boolean']>;
  canSearchFile?: Maybe<Scalars['Boolean']>;
  canSwitchView?: Maybe<Scalars['Boolean']>;
  filesCount?: Maybe<Scalars['Int']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isEditable?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  parentDocumentationFolder?: Maybe<DocumentationFolder>;
  parentDocumentationFolderId?: Maybe<Scalars['UUID']>;
  permissionUsers?: Maybe<Array<Maybe<DocumentationFolderUser>>>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type DocumentationFolderUser = {
  __typename?: 'DocumentationFolderUser';
  folder?: Maybe<DocumentationFolder>;
  folderId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type DocumentationFolderWhereInput = {
  id?: InputMaybe<Scalars['UUID']>;
};

export type DocumentationFoldersResult = {
  __typename?: 'DocumentationFoldersResult';
  data: Array<DocumentationFolder>;
  meta?: Maybe<PageInfo>;
};

export type DocumentsResult = {
  __typename?: 'DocumentsResult';
  data?: Maybe<Array<Document>>;
  meta?: Maybe<PageInfo>;
};

export type DocumentsWhereInput = {
  subTypes?: InputMaybe<Array<DocumentSubType>>;
  types?: InputMaybe<Array<DocumentType>>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type DoneEventInput = {
  eventId?: InputMaybe<Scalars['UUID']>;
};

export type DoveraCheckItem = {
  __typename?: 'DoveraCheckItem';
  birthNumber: Scalars['String'];
};

export type DrMaxOpeningHour = {
  __typename?: 'DrMaxOpeningHour';
  from?: Maybe<Scalars['DateTime']>;
  note?: Maybe<Scalars['String']>;
  open?: Maybe<Scalars['Boolean']>;
  to?: Maybe<Scalars['DateTime']>;
};

export type DrMaxOpeningHourItem = {
  __typename?: 'DrMaxOpeningHourItem';
  date?: Maybe<Scalars['DateTime']>;
  hours?: Maybe<Array<Maybe<DrMaxOpeningHour>>>;
  nonstop?: Maybe<Scalars['Boolean']>;
  open?: Maybe<Scalars['Boolean']>;
};

export type DrMaxPickupPlace = {
  __typename?: 'DrMaxPickupPlace';
  distance?: Maybe<Scalars['Float']>;
  distanceFormatted?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  isOpen?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  openingHours?: Maybe<Array<Maybe<DrMaxOpeningHourItem>>>;
  productsInStock?: Maybe<Array<Maybe<DrMaxProductsInStock>>>;
};

export type DrMaxPickupPlacesResult = {
  __typename?: 'DrMaxPickupPlacesResult';
  data?: Maybe<Array<Maybe<DrMaxPickupPlace>>>;
  meta?: Maybe<PageInfo>;
};

export type DrMaxPrescriptionMedicament = {
  __typename?: 'DrMaxPrescriptionMedicament';
  formattedApproximatePrice?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  inStock?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};


export type DrMaxPrescriptionMedicamentFormattedApproximatePriceArgs = {
  drmaxPickupPlaceId?: InputMaybe<Scalars['UUID']>;
};


export type DrMaxPrescriptionMedicamentInStockArgs = {
  drmaxPickupPlaceId?: InputMaybe<Scalars['UUID']>;
};

export type DrMaxPrescriptionMedicamentsResult = {
  __typename?: 'DrMaxPrescriptionMedicamentsResult';
  data?: Maybe<Array<Maybe<DrMaxPrescriptionMedicament>>>;
  meta?: Maybe<PageInfo>;
};

export type DrMaxPrescriptionReservation = {
  __typename?: 'DrMaxPrescriptionReservation';
  incrementId?: Maybe<Scalars['String']>;
};

export type DrMaxProductsInStock = {
  __typename?: 'DrMaxProductsInStock';
  inStock?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
};

export type EducationMaterial = {
  __typename?: 'EducationMaterial';
  category?: Maybe<Scalars['String']>;
  educationMaterialFolder?: Maybe<EducationMaterialFolder>;
  educationMaterialFolderId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  module?: Maybe<EducationMaterialModule>;
  name?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  seen?: Maybe<Scalars['Boolean']>;
  seenAt?: Maybe<Scalars['DateTime']>;
  send?: Maybe<Scalars['Boolean']>;
  sendAt?: Maybe<Scalars['DateTime']>;
  subtype?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};


export type EducationMaterialSeenArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};


export type EducationMaterialSeenAtArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};


export type EducationMaterialSendArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};


export type EducationMaterialSendAtArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};

export type EducationMaterialFolder = {
  __typename?: 'EducationMaterialFolder';
  educationMaterials?: Maybe<Array<Maybe<EducationMaterial>>>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
};


export type EducationMaterialFolderEducationMaterialsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
};

export type EducationMaterialFoldersResult = {
  __typename?: 'EducationMaterialFoldersResult';
  data?: Maybe<Array<Maybe<EducationMaterialFolder>>>;
  meta?: Maybe<PageInfo>;
};

export enum EducationMaterialModule {
  Baby = 'BABY',
  Diabetes = 'DIABETES',
  Therapist = 'THERAPIST'
}

export type EducationMaterialsResult = {
  __typename?: 'EducationMaterialsResult';
  data?: Maybe<Array<Maybe<EducationMaterial>>>;
  meta?: Maybe<PageInfo>;
};

export type ElectronicSignatureInput = {
  addToPatientECard?: InputMaybe<Scalars['Boolean']>;
  electronicSignature?: InputMaybe<Scalars['Boolean']>;
  electronicSignatureTimestamp?: InputMaybe<Scalars['Boolean']>;
  targetFolderId?: InputMaybe<Scalars['UUID']>;
};

export type EndHealthPlanUserInput = {
  healthPlanUserId: Scalars['UUID'];
  questionnaireResultId?: InputMaybe<Scalars['UUID']>;
};

export type Event = {
  __typename?: 'Event';
  address?: Maybe<Address>;
  addressDescription?: Maybe<Scalars['String']>;
  calendar?: Maybe<Calendar>;
  calendarId?: Maybe<Scalars['ID']>;
  canManage?: Maybe<Scalars['Boolean']>;
  canceledBy?: Maybe<User>;
  case?: Maybe<Case>;
  caseId?: Maybe<Scalars['UUID']>;
  caseType?: Maybe<CaseType>;
  createdBy?: Maybe<User>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  doctor?: Maybe<User>;
  eventAttachments?: Maybe<Array<Maybe<EventAttachment>>>;
  eventMembers?: Maybe<Array<Maybe<EventMember>>>;
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isDoctor?: Maybe<Scalars['Boolean']>;
  layout?: Maybe<Scalars['JSONObject']>;
  meetingType?: Maybe<MeetingType>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  note?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  priceId?: Maybe<Scalars['UUID']>;
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  tagsTermItems?: Maybe<Array<Maybe<TermItem>>>;
  title?: Maybe<Scalars['String']>;
  titleFormatted?: Maybe<EventTitle>;
  type?: Maybe<Scalars['String']>;
};


export type EventMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
};

export type EventAttachment = {
  __typename?: 'EventAttachment';
  createdAt: Scalars['DateTime'];
  event?: Maybe<Event>;
  eventId: Scalars['UUID'];
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type: EventAttachmentType;
  value?: Maybe<Scalars['JSONObject']>;
};

export enum EventAttachmentType {
  Button = 'BUTTON',
  Checkbox = 'CHECKBOX',
  CheckboxList = 'CHECKBOX_LIST',
  Condition = 'CONDITION',
  DocumentationFile = 'DOCUMENTATION_FILE',
  DocumentationUpload = 'DOCUMENTATION_UPLOAD',
  EducationMaterial = 'EDUCATION_MATERIAL',
  File = 'FILE',
  Item = 'ITEM',
  Medication = 'MEDICATION',
  OnCaseCreate = 'ON_CASE_CREATE',
  Questionnaire = 'QUESTIONNAIRE',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA',
  Textfield = 'TEXTFIELD',
  Upload = 'UPLOAD'
}

export type EventMember = {
  __typename?: 'EventMember';
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  role?: Maybe<Scalars['Int']>;
  state?: Maybe<EventMemberState>;
  status?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']>;
  visible?: Maybe<Scalars['Boolean']>;
};

export enum EventMemberState {
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  NotSent = 'NOT_SENT',
  Rejected = 'REJECTED',
  Removed = 'REMOVED',
  Sent = 'SENT'
}

export type EventTitle = {
  __typename?: 'EventTitle';
  parts: Array<Scalars['String']>;
  text: Scalars['String'];
};

export enum EventType {
  Absence = 'ABSENCE',
  Block = 'BLOCK',
  Default = 'DEFAULT',
  Reservation = 'RESERVATION'
}

export type EventsResult = {
  __typename?: 'EventsResult';
  data?: Maybe<Array<Maybe<Event>>>;
  meta?: Maybe<PageInfo>;
};

export type EventsWhereInput = {
  approaching?: InputMaybe<Scalars['Boolean']>;
  cancelledEvent?: InputMaybe<Scalars['Boolean']>;
  cancelledEventByDoctor?: InputMaybe<Scalars['Boolean']>;
  cancelledEventByPatient?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['DateTime']>;
  eventMemberId?: InputMaybe<Scalars['UUID']>;
  eventMemberIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  familyView?: InputMaybe<Scalars['Boolean']>;
  future?: InputMaybe<Scalars['Boolean']>;
  metaKey?: InputMaybe<Scalars['String']>;
  metaKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  start?: InputMaybe<Scalars['DateTime']>;
  types?: InputMaybe<Array<InputMaybe<EventType>>>;
  userId?: InputMaybe<Scalars['UUID']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  visible?: InputMaybe<Scalars['Boolean']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type ExportLog = {
  __typename?: 'ExportLog';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  extra?: Maybe<Scalars['JSON']>;
  fileId?: Maybe<Scalars['UUID']>;
  format?: Maybe<ExportLogFormat>;
  id?: Maybe<Scalars['UUID']>;
  status?: Maybe<ExportLogStatus>;
  type?: Maybe<ExportLogType>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export enum ExportLogFormat {
  Isdoc = 'ISDOC',
  Pdf = 'PDF',
  Pohoda = 'POHODA'
}

export enum ExportLogStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum ExportLogType {
  Documentation = 'DOCUMENTATION',
  Invoicing = 'INVOICING'
}

export type ExportLogsResult = {
  __typename?: 'ExportLogsResult';
  data: Array<Maybe<ExportLog>>;
  meta: PageInfo;
};

export type ExportLogsWhereInput = {
  createdById?: InputMaybe<Scalars['UUID']>;
  format?: InputMaybe<ExportLogFormat>;
  status?: InputMaybe<ExportLogStatus>;
  type?: InputMaybe<ExportLogType>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type FamilyMember = {
  __typename?: 'FamilyMember';
  canBeDeleted: Scalars['Boolean'];
  canBeShared: Scalars['Boolean'];
  id: Scalars['Int'];
  isAdmin: Scalars['Boolean'];
  role: FamilyMemberRole;
  user: User;
  userId: Scalars['UUID'];
};

export type FamilyMemberRelationInput = {
  relatedUserId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export enum FamilyMemberRole {
  Adult = 'ADULT',
  Child = 'CHILD',
  Invitation = 'INVITATION',
  Me = 'ME',
  Partner = 'PARTNER'
}

export type FamilyMemberWhereInput = {
  id?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type FamilyMembersResult = {
  __typename?: 'FamilyMembersResult';
  data?: Maybe<Array<Maybe<FamilyMember>>>;
  meta?: Maybe<PageInfo>;
};

export type File = {
  __typename?: 'File';
  avResult?: Maybe<Scalars['Int']>;
  avResultText?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  extension?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  processing?: Maybe<Scalars['Boolean']>;
  signed?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['String']>;
};

export enum Gender {
  Female = 'FEMALE',
  Male = 'MALE'
}

export type GenerateDocumentPdfWithDateInput = {
  documentId: Scalars['UUID'];
  printDate: Scalars['DateTime'];
};

export type GenerateSubscriptionRedeemCodeAlphabetInput = {
  charactersCount?: InputMaybe<Scalars['Int']>;
  code: Scalars['String'];
  count: Scalars['Int'];
  subscriptionCode?: InputMaybe<Scalars['String']>;
  subscriptionId: Scalars['UUID'];
  subscriptionPeriodId?: InputMaybe<Scalars['UUID']>;
};

export type GenerateSubscriptionRedeemCodeAlphabetResult = {
  __typename?: 'GenerateSubscriptionRedeemCodeAlphabetResult';
  unsuccessfulCount?: Maybe<Scalars['Int']>;
};

export type GenerateSubscriptionRedeemCodeInput = {
  code: Scalars['String'];
  count: Scalars['Int'];
  numbersCount?: InputMaybe<Scalars['Int']>;
  subscriptionCode?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['UUID']>;
  subscriptionPeriodId?: InputMaybe<Scalars['UUID']>;
};

export type Group = {
  __typename?: 'Group';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdByLog?: Maybe<AuditLog>;
  description?: Maybe<Scalars['String']>;
  groupMembers?: Maybe<GroupMembersResult>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  totalMembers?: Maybe<Scalars['Int']>;
  updatedByLog?: Maybe<AuditLog>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type GroupGroupMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type GroupMember = {
  __typename?: 'GroupMember';
  group?: Maybe<Group>;
  groupId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type GroupMemberWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type GroupMembersResult = {
  __typename?: 'GroupMembersResult';
  data?: Maybe<Array<Maybe<GroupMember>>>;
  meta?: Maybe<PageInfo>;
};

export type GroupWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type GroupsResult = {
  __typename?: 'GroupsResult';
  data?: Maybe<Array<Maybe<Group>>>;
  meta?: Maybe<PageInfo>;
};

export type HealthCard = {
  __typename?: 'HealthCard';
  allergies?: Maybe<Scalars['String']>;
  allergiesOther?: Maybe<Scalars['String']>;
  anamnesisFamily?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Int']>;
  id: Scalars['Int'];
  job?: Maybe<Scalars['String']>;
  operations?: Maybe<Scalars['String']>;
  sickness?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  weight?: Maybe<Scalars['Int']>;
};

export type HealthDataDashboardCategory = {
  __typename?: 'HealthDataDashboardCategory';
  extra?: Maybe<Scalars['JSONObject']>;
  iconUrl?: Maybe<Scalars['String']>;
  key: Scalars['String'];
  title: Scalars['String'];
  trend?: Maybe<HealthDataDashboardCategoryTrend>;
  type?: Maybe<HealthDataDashboardCategoryType>;
  value: Scalars['String'];
};

export enum HealthDataDashboardCategoryTrend {
  Down = 'DOWN',
  None = 'NONE',
  Up = 'UP'
}

export enum HealthDataDashboardCategoryType {
  BioScan = 'BIO_SCAN',
  Category = 'CATEGORY'
}

export type HealthDataItem = {
  __typename?: 'HealthDataItem';
  key?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  meta?: Maybe<Array<Maybe<HealthDataItemMeta>>>;
  time?: Maybe<Scalars['DateTime']>;
  unit?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type HealthDataItemMeta = {
  __typename?: 'HealthDataItemMeta';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type HealthDataResult = {
  __typename?: 'HealthDataResult';
  data?: Maybe<Array<Maybe<HealthDataItem>>>;
  meta?: Maybe<PageInfo>;
};

export type HealthPlan = {
  __typename?: 'HealthPlan';
  active?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  doctorInitialQuestionnaireCode?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  initialQuestionnaireCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  public?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<Scalars['JSONObject']>;
  structure?: Maybe<HealthPlanStructure>;
  totalMonths?: Maybe<Scalars['Int']>;
};

export type HealthPlanBabyPregnancy = {
  __typename?: 'HealthPlanBabyPregnancy';
  dateOfDelivery?: Maybe<Scalars['Date']>;
  gestationalAgeFUM?: Maybe<Scalars['String']>;
};

export enum HealthPlanCodeEnum {
  Diabetes = 'DIABETES',
  Kdar = 'KDAR',
  Meddibaby = 'MEDDIBABY',
  Obesity = 'OBESITY',
  ObesityTherapist = 'OBESITY_THERAPIST',
  Oncology = 'ONCOLOGY',
  Palliative = 'PALLIATIVE',
  Therapist = 'THERAPIST'
}

export type HealthPlanPeriod = {
  __typename?: 'HealthPlanPeriod';
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  sale?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['String']>;
};

export type HealthPlanStructure = {
  __typename?: 'HealthPlanStructure';
  name: Scalars['String'];
  settings?: Maybe<Scalars['JSONObject']>;
  steps?: Maybe<Array<Maybe<HealthPlanStructureStep>>>;
};

export type HealthPlanStructureStep = {
  __typename?: 'HealthPlanStructureStep';
  key: Scalars['String'];
  name: Scalars['String'];
  settings?: Maybe<Scalars['JSONObject']>;
  type?: Maybe<HealthPlanStructureStepTypeEnum>;
};

export enum HealthPlanStructureStepTypeEnum {
  EducationMaterials = 'EDUCATION_MATERIALS',
  Form = 'FORM',
  Questionnaires = 'QUESTIONNAIRES',
  Requirements = 'REQUIREMENTS'
}

export type HealthPlanUser = {
  __typename?: 'HealthPlanUser';
  activatedAt?: Maybe<Scalars['DateTime']>;
  activeFrom?: Maybe<Scalars['DateTime']>;
  activeMonth?: Maybe<Scalars['Int']>;
  activeTo?: Maybe<Scalars['DateTime']>;
  doctor?: Maybe<User>;
  doctorId?: Maybe<Scalars['UUID']>;
  endAt?: Maybe<Scalars['DateTime']>;
  hasEnded?: Maybe<Scalars['Boolean']>;
  healthPlan?: Maybe<HealthPlan>;
  healthPlanId?: Maybe<Scalars['UUID']>;
  healthPlanUserBaby?: Maybe<HealthPlanUserBaby>;
  id: Scalars['UUID'];
  initialQuestionnaireResult?: Maybe<QuestionnaireResult>;
  initialQuestionnaireResultId?: Maybe<Scalars['UUID']>;
  isActive?: Maybe<Scalars['Boolean']>;
  offerContent?: Maybe<Scalars['String']>;
  periods?: Maybe<Array<Maybe<HealthPlanPeriod>>>;
  plannedActiveFrom?: Maybe<Scalars['DateTime']>;
  price?: Maybe<Price>;
  priceSale?: Maybe<Price>;
  pricing?: Maybe<HealthPlanUserPricing>;
  ready?: Maybe<Scalars['Boolean']>;
  settings?: Maybe<HealthPlanUserSettings>;
  status?: Maybe<HealthPlanUserItem>;
  statusText?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type HealthPlanUserPriceSaleArgs = {
  period: HealthPlanUserPricePeriod;
};

export type HealthPlanUserBaby = {
  __typename?: 'HealthPlanUserBaby';
  dateOfBirth?: Maybe<Scalars['DateTime']>;
  gestionalAge?: Maybe<Scalars['String']>;
};

export type HealthPlanUserItem = {
  __typename?: 'HealthPlanUserItem';
  extra?: Maybe<Scalars['JSON']>;
  healthPlanUser?: Maybe<HealthPlanUser>;
  healthPlanUserId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  subtype?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type HealthPlanUserItemResult = {
  __typename?: 'HealthPlanUserItemResult';
  data?: Maybe<Array<Maybe<HealthPlanUserItem>>>;
  meta?: Maybe<PageInfo>;
};

export type HealthPlanUserItemWhereInput = {
  healthPlanUserId: Scalars['UUID'];
  subtype?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type HealthPlanUserPaymentInput = {
  activateHealthPlan?: InputMaybe<Scalars['Boolean']>;
  amount: Scalars['Decimal'];
  currency: Scalars['String'];
  healthPlanUserId: Scalars['UUID'];
  paymentMethod: HealthPlanUserPricingPaymentMethod;
  paymentPeriod: HealthPlanUserPricePeriod;
};

export enum HealthPlanUserPricePeriod {
  HalfYear = 'HALF_YEAR',
  Month = 'MONTH',
  Year = 'YEAR'
}

export type HealthPlanUserPricing = {
  __typename?: 'HealthPlanUserPricing';
  creditPerDay?: Maybe<Scalars['Float']>;
  nextPayment?: Maybe<Price>;
  nextPaymentAt?: Maybe<Scalars['DateTime']>;
  payNow?: Maybe<Price>;
  paymentMethod?: Maybe<HealthPlanUserPricingPaymentMethod>;
  remainsToPay?: Maybe<Price>;
  totalPrice?: Maybe<Price>;
};

export enum HealthPlanUserPricingPaymentMethod {
  Card = 'CARD',
  Cash = 'CASH'
}

export type HealthPlanUserSettings = {
  __typename?: 'HealthPlanUserSettings';
  continueToPayment?: Maybe<Scalars['String']>;
  healthPlanContains?: Maybe<Scalars['String']>;
  healthPlanPreparedByDoctor?: Maybe<Scalars['String']>;
  hello?: Maybe<Scalars['String']>;
  howYouWannaPay?: Maybe<Scalars['String']>;
  priceContains?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  topBarTitle?: Maybe<Scalars['String']>;
};

export type HealthPlanUsersResult = {
  __typename?: 'HealthPlanUsersResult';
  data?: Maybe<Array<Maybe<HealthPlanUser>>>;
  meta?: Maybe<PageInfo>;
};

export type HealthPlanWorkplace = {
  __typename?: 'HealthPlanWorkplace';
  healthPlanId: Scalars['UUID'];
  id: Scalars['UUID'];
  settings?: Maybe<Scalars['JSONObject']>;
  workplaceId: Scalars['UUID'];
};

export type HealthPlanWorkplaceWhereInput = {
  healthPlanId: Scalars['UUID'];
};

export type HealthPlanWorkplaceWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type HealthPlansResult = {
  __typename?: 'HealthPlansResult';
  data?: Maybe<Array<Maybe<HealthPlan>>>;
  meta?: Maybe<PageInfo>;
};

export type HiddenWorkplaceMetaInput = {
  userId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type HideSeenLaboratoryResultsInput = {
  all?: InputMaybe<Scalars['Boolean']>;
  isSeen: Scalars['Boolean'];
  laboratoryResultIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type HideSeenQuestionnaireResult = {
  __typename?: 'HideSeenQuestionnaireResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type ImportMedicalProceduresByFieldOfCareInput = {
  workplaceId: Scalars['UUID'];
};

export type InsuranceBatch = {
  __typename?: 'InsuranceBatch';
  batchType?: Maybe<InsuranceReportType>;
  createdAt: Scalars['DateTime'];
  doctor?: Maybe<User>;
  exportFile?: Maybe<DocumentationFile>;
  exportFileId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  insuranceCompanyCode?: Maybe<Scalars['String']>;
  insuranceCompanyTerm?: Maybe<TermItem>;
  items?: Maybe<Array<Maybe<InsuranceReportBatch>>>;
  logs?: Maybe<Array<Maybe<Scalars['String']>>>;
  needCorrection?: Maybe<Scalars['Boolean']>;
  periodMonth: Scalars['Int'];
  periodYear: Scalars['Int'];
  sequenceNumber: Scalars['Int'];
  totalNumber: Scalars['Int'];
  type?: Maybe<Scalars['String']>;
  workplace?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
};

export type InsuranceBatchsResult = {
  __typename?: 'InsuranceBatchsResult';
  data: Array<InsuranceBatch>;
  meta?: Maybe<PageInfo>;
};

export type InsuranceCompaniesWhereInput = {
  excludeNotReimbursing?: InputMaybe<Scalars['Boolean']>;
};

export type InsuranceCompanyBatch = {
  __typename?: 'InsuranceCompanyBatch';
  char: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  dcid: Scalars['String'];
  dtyp: Scalars['String'];
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  insuranceCompanyCode: Scalars['String'];
  periodMonth: Scalars['String'];
  periodYear: Scalars['Int'];
  workplace?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
};

export type InsuranceCompanyBatchResult = {
  __typename?: 'InsuranceCompanyBatchResult';
  data: Array<InsuranceCompanyBatch>;
  meta?: Maybe<PageInfo>;
};

export type InsuranceExport = {
  __typename?: 'InsuranceExport';
  exportFile: DocumentationFile;
  id: Scalars['UUID'];
  insuranceCompanyCode: Scalars['String'];
  insuranceCompanyTerm?: Maybe<TermItem>;
  needCorrection: Scalars['Boolean'];
  periodMonth: Scalars['Int'];
  periodYear: Scalars['Int'];
  totalNumber: Scalars['Int'];
  workplace: Workplace;
  workplaceId: Scalars['UUID'];
};

export type InsuranceExportsResult = {
  __typename?: 'InsuranceExportsResult';
  data: Array<InsuranceExport>;
  meta?: Maybe<PageInfo>;
};

export type InsuranceMetaInput = {
  companyName?: InputMaybe<Scalars['String']>;
  hasInsurance: Scalars['Boolean'];
  type?: InputMaybe<Scalars['String']>;
};

export type InsuranceOperation = {
  __typename?: 'InsuranceOperation';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  insurance?: Maybe<TermItem>;
  insuranceId?: Maybe<Scalars['UUID']>;
  ncziCode?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Int']>;
  pricePerPoint?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type InsuranceOperationResult = {
  __typename?: 'InsuranceOperationResult';
  data?: Maybe<Array<Maybe<InsuranceOperation>>>;
  meta?: Maybe<PageInfo>;
};

export type InsuranceOperationsWhereInput = {
  insuranceId?: InputMaybe<Scalars['UUID']>;
  ncziCode?: InputMaybe<Scalars['String']>;
  workplaceId: Scalars['UUID'];
};

export type InsuranceReport = {
  __typename?: 'InsuranceReport';
  birthNumber?: Maybe<Scalars['String']>;
  count?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  diagnosis?: Maybe<Scalars['String']>;
  doctor?: Maybe<User>;
  doctorId?: Maybe<Scalars['UUID']>;
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['UUID']>;
  extra?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  insurance?: Maybe<TermItem>;
  insuranceId?: Maybe<Scalars['UUID']>;
  note?: Maybe<Scalars['String']>;
  operation?: Maybe<InsuranceOperation>;
  operationId?: Maybe<Scalars['UUID']>;
  patient?: Maybe<User>;
  patientId: Scalars['UUID'];
  points?: Maybe<Scalars['Int']>;
  reportedAt: Scalars['DateTime'];
  state: InsuranceReportState;
  stateError: InsuranceReportStateError;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type InsuranceReportBatch = {
  __typename?: 'InsuranceReportBatch';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  insuranceBatch?: Maybe<InsuranceBatch>;
  insuranceBatchId: Scalars['UUID'];
  insuranceReport?: Maybe<InsuranceReport>;
  insuranceReportId: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export enum InsuranceReportState {
  Cancelled = 'CANCELLED',
  Error = 'ERROR',
  Irreparable = 'IRREPARABLE',
  PartiallyAccepted = 'PARTIALLY_ACCEPTED',
  Rejected = 'REJECTED',
  Reported = 'REPORTED',
  Unreported = 'UNREPORTED'
}

export enum InsuranceReportStateError {
  Error = 'ERROR',
  Ok = 'OK'
}

export enum InsuranceReportType {
  Additional = 'ADDITIONAL',
  Correction = 'CORRECTION',
  New = 'NEW'
}

export type InsuranceReportsResult = {
  __typename?: 'InsuranceReportsResult';
  data?: Maybe<Array<Maybe<InsuranceReport>>>;
  meta?: Maybe<PageInfo>;
};

export type InsuranceReportsWhereInput = {
  doctorId?: InputMaybe<Scalars['UUID']>;
  documentId?: InputMaybe<Scalars['UUID']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  state?: InputMaybe<InsuranceReportState>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  id?: Maybe<Scalars['UUID']>;
  number?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type Iot = {
  __typename?: 'Iot';
  extra?: Maybe<Scalars['JSONObject']>;
  icon?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  iotUser?: Maybe<IotUser>;
  name?: Maybe<Scalars['String']>;
  topped?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
};


export type IotIotUserArgs = {
  userId?: InputMaybe<Scalars['UUID']>;
};

export type IotUser = {
  __typename?: 'IotUser';
  active?: Maybe<Scalars['Boolean']>;
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  ingestionUrl?: Maybe<Scalars['String']>;
  iot?: Maybe<Iot>;
  iotId?: Maybe<Scalars['UUID']>;
  synchronizationNeeded?: Maybe<Scalars['Boolean']>;
  synchronizedAt?: Maybe<Scalars['DateTime']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type IotsResult = {
  __typename?: 'IotsResult';
  data?: Maybe<Array<Maybe<Iot>>>;
  meta?: Maybe<PageInfo>;
};

export type IplpTemplate = {
  __typename?: 'IplpTemplate';
  createdAt: Scalars['DateTime'];
  dosage?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  manual?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type IplpTemplatesResult = {
  __typename?: 'IplpTemplatesResult';
  data?: Maybe<Array<Maybe<IplpTemplate>>>;
  meta?: Maybe<PageInfo>;
};

export type IplpTemplatesWhereInput = {
  fulltext?: InputMaybe<Scalars['String']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type JobResult = {
  __typename?: 'JobResult';
  jobId: Scalars['UUID'];
};

export type LaboratoriesWhereInput = {
  fulltext?: InputMaybe<Scalars['String']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type Laboratory = {
  __typename?: 'Laboratory';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['UUID']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  icl?: Maybe<Scalars['String']>;
  ico?: Maybe<Scalars['String']>;
  icp?: Maybe<Scalars['String']>;
  icz?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  settings?: Maybe<Scalars['JSONObject']>;
};

export type LaboratoryDataInput = {
  value: Scalars['String'];
  wizardItemId: Scalars['UUID'];
};

export type LaboratoryDocumentInput = {
  date?: InputMaybe<Scalars['Date']>;
  primarySampleType: Scalars['String'];
  sampleTakenBy?: InputMaybe<Scalars['String']>;
  selfPaid: Scalars['Boolean'];
  statim: Scalars['Boolean'];
  statimPhoneNumber?: InputMaybe<Scalars['String']>;
  time?: InputMaybe<Scalars['Time']>;
};

export type LaboratoryDocumentType = {
  __typename?: 'LaboratoryDocumentType';
  primarySampleType?: Maybe<Scalars['String']>;
  selfPaid?: Maybe<Scalars['Boolean']>;
  statim?: Maybe<Scalars['Boolean']>;
};

export type LaboratoryPatientInput = {
  address?: InputMaybe<AddressInput>;
  birthDate: Scalars['Date'];
  contactEmail?: InputMaybe<Scalars['EmailAddress']>;
  contactPhoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  diagnosisTermItemValue: Scalars['String'];
  firstName: Scalars['String'];
  genderTermItemId: Scalars['UUID'];
  insuranceCompanyTermItemId?: InputMaybe<Scalars['UUID']>;
  insuranceNumber: Scalars['String'];
  lastName: Scalars['String'];
};

export type LaboratoryRequisition = {
  __typename?: 'LaboratoryRequisition';
  allowed?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  laboratory: Laboratory;
  laboratoryId: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type LaboratoryRequisitionForm = {
  __typename?: 'LaboratoryRequisitionForm';
  children?: Maybe<Scalars['JSON']>;
  samples?: Maybe<Array<Maybe<LaboratoryRequisitionSample>>>;
  settings?: Maybe<Scalars['JSON']>;
};

export type LaboratoryRequisitionFormPriceInput = {
  data: Array<LaboratoryDataInput>;
  requisitionId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type LaboratoryRequisitionFormResult = {
  __typename?: 'LaboratoryRequisitionFormResult';
  form?: Maybe<LaboratoryRequisitionForm>;
  requisition?: Maybe<LaboratoryRequisition>;
};

export type LaboratoryRequisitionFormWhereInput = {
  id: Scalars['UUID'];
};

export type LaboratoryRequisitionPatient = {
  __typename?: 'LaboratoryRequisitionPatient';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['UUID']>;
  age?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthNumber?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  diagnosis?: Maybe<TermItem>;
  diagnosisTermItemId?: Maybe<Scalars['UUID']>;
  fatherLastName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formattedBirthNumber?: Maybe<Scalars['String']>;
  formattedGender?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderTermItem?: Maybe<TermItem>;
  genderTermItemId?: Maybe<Scalars['UUID']>;
  hasInsurance?: Maybe<Scalars['Boolean']>;
  insuranceCompanyTermItem?: Maybe<TermItem>;
  insuranceCompanyTermItemId?: Maybe<Scalars['UUID']>;
  insuranceNumber?: Maybe<Scalars['String']>;
  languageFormatted?: Maybe<Scalars['String']>;
  languageIso?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  motherLastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nationalityOther?: Maybe<Scalars['String']>;
  nationalityTermItem?: Maybe<TermItem>;
  nationalityTermItemId?: Maybe<Scalars['UUID']>;
  salutation?: Maybe<Scalars['String']>;
  salutationAfter?: Maybe<Scalars['String']>;
  salutationBefore?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type LaboratoryRequisitionResult = {
  __typename?: 'LaboratoryRequisitionResult';
  caseId?: Maybe<Scalars['UUID']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  document?: Maybe<LaboratoryDocumentType>;
  id: Scalars['UUID'];
  laboratoryExaminationRequest?: Maybe<DocumentationFile>;
  laboratoryExaminationRequestId?: Maybe<Scalars['UUID']>;
  laboratoryExaminationRequestPatient?: Maybe<DocumentationFile>;
  laboratoryExaminationRequestPatientId?: Maybe<Scalars['UUID']>;
  patient: LaboratoryRequisitionPatient;
  requisition?: Maybe<LaboratoryRequisition>;
  result?: Maybe<Array<Maybe<LaboratoryResultType>>>;
  user: User;
  workplace: Workplace;
};

export type LaboratoryRequisitionResultWhereInput = {
  id: Scalars['UUID'];
};

export type LaboratoryRequisitionResultsResult = {
  __typename?: 'LaboratoryRequisitionResultsResult';
  data?: Maybe<Array<Maybe<LaboratoryRequisitionResult>>>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryRequisitionResultsWhereInput = {
  requisitionId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type LaboratoryRequisitionSample = {
  __typename?: 'LaboratoryRequisitionSample';
  key: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type LaboratoryRequisitionTemplate = {
  __typename?: 'LaboratoryRequisitionTemplate';
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['JSON']>;
  doctor?: Maybe<User>;
  doctorId: Scalars['UUID'];
  id: Scalars['UUID'];
  laboratoryRequisition?: Maybe<LaboratoryRequisition>;
  laboratoryRequisitionId: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  workplace?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
};

export type LaboratoryRequisitionTemplateWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type LaboratoryRequisitionTemplatesResult = {
  __typename?: 'LaboratoryRequisitionTemplatesResult';
  data: Array<LaboratoryRequisitionTemplate>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryRequisitionTemplatesWhereInput = {
  doctorId?: InputMaybe<Scalars['UUID']>;
  laboratoryRequisitionId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type LaboratoryRequisitionWorkplace = {
  __typename?: 'LaboratoryRequisitionWorkplace';
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById: Scalars['UUID'];
  id: Scalars['UUID'];
  laboratoryRequisition?: Maybe<LaboratoryRequisition>;
  laboratoryRequisitionId: Scalars['UUID'];
  workplace?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
};

export type LaboratoryRequisitionsResult = {
  __typename?: 'LaboratoryRequisitionsResult';
  data: Array<LaboratoryRequisition>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryRequisitionsWhereInput = {
  laboratoryId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type LaboratoryResult = {
  __typename?: 'LaboratoryResult';
  data?: Maybe<Array<Maybe<Laboratory>>>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryResultItem = {
  __typename?: 'LaboratoryResultItem';
  acceptedAt?: Maybe<Scalars['DateTime']>;
  acceptedBy?: Maybe<Scalars['String']>;
  chart?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  evaluation?: Maybe<LaboratoryResultItemEvaluation>;
  id: Scalars['UUID'];
  laboratoryResult?: Maybe<LaboratoryResultResult>;
  lowerReferenceValue?: Maybe<Scalars['Float']>;
  name?: Maybe<Scalars['String']>;
  processedAt?: Maybe<Scalars['DateTime']>;
  processedBy?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
  upperReferenceValue?: Maybe<Scalars['Float']>;
};

export type LaboratoryResultItemEvaluation = {
  __typename?: 'LaboratoryResultItemEvaluation';
  color?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type LaboratoryResultMise = {
  __typename?: 'LaboratoryResultMise';
  createdAt: Scalars['DateTime'];
  doctor?: Maybe<User>;
  doctorId?: Maybe<Scalars['UUID']>;
  file?: Maybe<DocumentationFile>;
  fileId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  laboratoryResult?: Maybe<LaboratoryResultResult>;
  laboratoryResultId: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  noteAt?: Maybe<Scalars['DateTime']>;
  solveTo: Scalars['DateTime'];
  status: LaboratoryResultMiseStatus;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export enum LaboratoryResultMiseStatus {
  Assigned = 'ASSIGNED',
  Done = 'DONE',
  New = 'NEW'
}

export type LaboratoryResultMiseWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type LaboratoryResultResult = {
  __typename?: 'LaboratoryResultResult';
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  isSeen?: Maybe<Scalars['Boolean']>;
  isSeenMarkedBy?: Maybe<User>;
  isSeenMarkedById?: Maybe<Scalars['UUID']>;
  laboratory?: Maybe<Laboratory>;
  laboratoryId?: Maybe<Scalars['UUID']>;
  laboratoryResultItems: Array<LaboratoryResultItem>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type LaboratoryResultType = {
  __typename?: 'LaboratoryResultType';
  value: Scalars['String'];
  wizardItemId: Scalars['UUID'];
};

export type LaboratoryResultWhereInput = {
  id: Scalars['UUID'];
};

export type LaboratoryResultsMise = {
  __typename?: 'LaboratoryResultsMise';
  data: Array<LaboratoryResultMise>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryResultsMiseWhereInput = {
  my?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<LaboratoryResultMiseStatus>;
};

export type LaboratoryResultsResult = {
  __typename?: 'LaboratoryResultsResult';
  data: Array<LaboratoryResultResult>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryResultsWhereInput = {
  laboratoryId?: InputMaybe<Scalars['UUID']>;
  seen?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type LaboratoryWizard = {
  __typename?: 'LaboratoryWizard';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  laboratory?: Maybe<Laboratory>;
  laboratoryId?: Maybe<Scalars['UUID']>;
  type?: Maybe<LaboratoryWizardType>;
  wizard?: Maybe<Wizard>;
  wizardId?: Maybe<Scalars['UUID']>;
};

export enum LaboratoryWizardType {
  Document = 'DOCUMENT',
  MedicalRequest = 'MEDICAL_REQUEST'
}

export type LaboratoryWizardsResult = {
  __typename?: 'LaboratoryWizardsResult';
  data?: Maybe<Array<Maybe<LaboratoryWizard>>>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryWizardsWhereInput = {
  laboratoryId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<LaboratoryWizardType>;
};

export type LaboratoryWorkplace = {
  __typename?: 'LaboratoryWorkplace';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById: Scalars['UUID'];
  data?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  laboratory?: Maybe<Laboratory>;
  laboratoryId: Scalars['UUID'];
  workplace?: Maybe<Workplace>;
  workplaceId: Scalars['UUID'];
};

export type LaboratoryWorkplaceWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type LaboratoryWorkplacesResult = {
  __typename?: 'LaboratoryWorkplacesResult';
  data: Array<LaboratoryWorkplace>;
  meta?: Maybe<PageInfo>;
};

export type LaboratoryWorkplacesWhereInput = {
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type MarkAsSeenUserNotificationsResult = {
  __typename?: 'MarkAsSeenUserNotificationsResult';
  success?: Maybe<Scalars['Boolean']>;
};

export type MeddiAccount = {
  __typename?: 'MeddiAccount';
  balance?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  members?: Maybe<Array<Maybe<MeddiAccountMember>>>;
  type?: Maybe<MeddiAccountType>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type MeddiAccountMember = {
  __typename?: 'MeddiAccountMember';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['UUID']>;
  role?: Maybe<MeddiAccountMemberRole>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum MeddiAccountMemberRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type MeddiAccountResult = {
  __typename?: 'MeddiAccountResult';
  data?: Maybe<Array<Maybe<MeddiAccount>>>;
  meta?: Maybe<PageInfo>;
};

export type MeddiAccountTransactionResult = {
  __typename?: 'MeddiAccountTransactionResult';
  data?: Maybe<Array<Maybe<MeddiTransaction>>>;
  meta?: Maybe<PageInfo>;
};

export type MeddiAccountTransactionsWhereInput = {
  meddiAccountId?: InputMaybe<Scalars['UUID']>;
  meddiAccountType?: InputMaybe<MeddiAccountType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export enum MeddiAccountType {
  Company = 'COMPANY',
  Default = 'DEFAULT'
}

export type MeddiAccountsWhereInput = {
  type?: InputMaybe<MeddiAccountType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type MeddiSettings = {
  __typename?: 'MeddiSettings';
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type MeddiTransaction = {
  __typename?: 'MeddiTransaction';
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  extra?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['UUID']>;
  meddiAccount?: Maybe<MeddiAccount>;
  meddiAccountId?: Maybe<Scalars['UUID']>;
  order?: Maybe<TransactionOrder>;
  orderId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
};

export type MedicalExamination = {
  __typename?: 'MedicalExamination';
  completedAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  createdById: Scalars['UUID'];
  id: Scalars['UUID'];
  patient: User;
  patientId: Scalars['UUID'];
  toothLogs?: Maybe<Array<ToothLog>>;
  type: MedicalExaminationType;
};

export enum MedicalExaminationType {
  DentalTreatmentRestoration = 'DENTAL_TREATMENT_RESTORATION',
  Emergency = 'EMERGENCY',
  Initial = 'INITIAL',
  Preventive = 'PREVENTIVE'
}

export type MedicalExaminationWhereInput = {
  completedAtFrom?: InputMaybe<Scalars['DateTime']>;
  completedAtTo?: InputMaybe<Scalars['DateTime']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  isCompleted?: InputMaybe<Scalars['Boolean']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  toothNumber?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<MedicalExaminationType>;
};

export type MedicalExaminationWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type MedicalExaminationsResult = {
  __typename?: 'MedicalExaminationsResult';
  data: Array<MedicalExamination>;
  meta: PageInfo;
};

export type MedicalHistoryType = {
  __typename?: 'MedicalHistoryType';
  active: Scalars['Boolean'];
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  name: Scalars['String'];
  value: Scalars['String'];
};

export type MedicalHistoryTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type MedicalHistoryTypeResult = {
  __typename?: 'MedicalHistoryTypeResult';
  data?: Maybe<Array<Maybe<MedicalHistoryType>>>;
  meta?: Maybe<PageInfo>;
};

export type MedicalHistoryTypeWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type MedicalProcedure = {
  __typename?: 'MedicalProcedure';
  code: Scalars['String'];
  createdAt: Scalars['DateTime'];
  ctn?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  eventInterval?: Maybe<Scalars['Int']>;
  formattedName: Scalars['String'];
  id: Scalars['UUID'];
  mainFieldOfCare?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ome?: Maybe<Scalars['String']>;
  points?: Maybe<Scalars['Int']>;
  sharedFieldOfCare?: Maybe<Array<Maybe<Scalars['String']>>>;
  version?: Maybe<Scalars['Int']>;
  zum?: Maybe<Scalars['String']>;
};

export type MedicalProcedureResult = {
  __typename?: 'MedicalProcedureResult';
  data?: Maybe<Array<Maybe<MedicalProcedure>>>;
  meta?: Maybe<PageInfo>;
};

export type MedicalProcedureUniqueWhereInput = {
  id: Scalars['UUID'];
};

export type MedicalProceduresWhereInput = {
  code?: InputMaybe<Scalars['String']>;
  fieldOfCare?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  mainFieldOfCare?: InputMaybe<Scalars['Boolean']>;
  sharedFieldOfCare?: InputMaybe<Scalars['Boolean']>;
  version?: InputMaybe<Scalars['Int']>;
};

export type MedicalReport = {
  __typename?: 'MedicalReport';
  case?: Maybe<Case>;
  caseId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  diagnosis?: Maybe<Scalars['String']>;
  document?: Maybe<Document>;
  documentId?: Maybe<Scalars['UUID']>;
  fileId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  printed?: Maybe<Scalars['Boolean']>;
  treatment?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  workplaceId?: Maybe<Scalars['String']>;
};

export type MedicalRequestForm = {
  __typename?: 'MedicalRequestForm';
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  wizardKey?: Maybe<Scalars['String']>;
};

export type MedicalRequestFormsResult = {
  __typename?: 'MedicalRequestFormsResult';
  data?: Maybe<Array<Maybe<MedicalRequestForm>>>;
  meta?: Maybe<PageInfo>;
};

export type Medium = {
  __typename?: 'Medium';
  artwork?: Maybe<Scalars['String']>;
  contentType?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  metadata?: Maybe<MetadataType>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['JSONObject']>;
  url?: Maybe<Scalars['String']>;
};

export enum MeetingType {
  OnSite = 'ON_SITE',
  Telemedicine = 'TELEMEDICINE'
}

export type Message = {
  __typename?: 'Message';
  content?: Maybe<Scalars['JSONObject']>;
  conversation?: Maybe<Conversation>;
  conversationId?: Maybe<Scalars['UUID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  messageAttachments?: Maybe<Array<Maybe<MessageAttachment>>>;
  messageMembers?: Maybe<Array<Maybe<MessageMember>>>;
  myMessageMember?: Maybe<MessageMember>;
  sender?: Maybe<MessageMember>;
  singleRecipient?: Maybe<MessageMember>;
  totalRecipients?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};


export type MessageMessageAttachmentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type MessageMessageMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};

export type MessageAttachment = {
  __typename?: 'MessageAttachment';
  documentationFile?: Maybe<DocumentationFile>;
  documentationFileId?: Maybe<Scalars['UUID']>;
  educationMaterial?: Maybe<EducationMaterial>;
  educationMaterialId?: Maybe<Scalars['UUID']>;
  event?: Maybe<Event>;
  eventId?: Maybe<Scalars['UUID']>;
  extra?: Maybe<Scalars['JSON']>;
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['UUID']>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireId?: Maybe<Scalars['UUID']>;
  type?: Maybe<MessageAttachmentType>;
};

export enum MessageAttachmentType {
  DocumentationFile = 'DOCUMENTATION_FILE',
  EducationMaterial = 'EDUCATION_MATERIAL',
  Event = 'EVENT',
  File = 'FILE',
  Form = 'FORM',
  Questionnaire = 'QUESTIONNAIRE'
}

export type MessageAttachmentsResult = {
  __typename?: 'MessageAttachmentsResult';
  data?: Maybe<Array<Maybe<MessageAttachment>>>;
  meta?: Maybe<PageInfo>;
};

export type MessageMember = {
  __typename?: 'MessageMember';
  id: Scalars['UUID'];
  message?: Maybe<Message>;
  messageId?: Maybe<Scalars['UUID']>;
  seen?: Maybe<Scalars['Boolean']>;
  sender?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type MessageMembersResult = {
  __typename?: 'MessageMembersResult';
  data?: Maybe<Array<Maybe<MessageMember>>>;
  meta?: Maybe<PageInfo>;
};

export type MessagesResult = {
  __typename?: 'MessagesResult';
  data?: Maybe<Array<Maybe<Message>>>;
  meta?: Maybe<PageInfo>;
};

export type Meta = {
  __typename?: 'Meta';
  formattedValue?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type MetaTranslation = {
  __typename?: 'MetaTranslation';
  id?: Maybe<Scalars['UUID']>;
  key?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSON']>;
};

export type MetadataType = {
  __typename?: 'MetadataType';
  album?: Maybe<Scalars['String']>;
  artist?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  genre?: Maybe<Scalars['String']>;
};

export type MetasResult = {
  __typename?: 'MetasResult';
  data?: Maybe<Array<Maybe<WorkplaceCaseType>>>;
  meta?: Maybe<PageInfo>;
};

export type Mutation = {
  __typename?: 'Mutation';
  activateSubscriptionById?: Maybe<MutationResult>;
  activateUserSubscriptionByRedeemCode?: Maybe<UserSubscription>;
  addLaboratoryRequisitionToPatient?: Maybe<DocumentationFile>;
  assignCase?: Maybe<Case>;
  assignCaseToMe?: Maybe<Case>;
  assignLaboratoryResultMise?: Maybe<LaboratoryResultMise>;
  bulkUserHealthCategoryPermission?: Maybe<Array<Maybe<UserHealthCategoryPermission>>>;
  cancelDrMaxReservation?: Maybe<CancelDrMaxReservationResult>;
  cancelP1MedicalRequest?: Maybe<MutationResult>;
  cancelP1Prescription?: Maybe<MutationResult>;
  createCareClaim?: Maybe<CareClaim>;
  createCustomCalendar?: Maybe<Calendar>;
  createDrMaxPrescriptionReservation?: Maybe<DrMaxPrescriptionReservation>;
  createEvent?: Maybe<Event>;
  createGroup: Group;
  createGroupMember: GroupMember;
  createGroupMembers: Array<GroupMember>;
  createHealthPlan?: Maybe<HealthPlan>;
  createHealthPlanUser?: Maybe<HealthPlanUser>;
  createHealthPlanUserFromData?: Maybe<HealthPlanUser>;
  createHealthPlanUserPayment?: Maybe<HealthPlanUser>;
  createHealthPlanWorkplace?: Maybe<HealthPlanWorkplace>;
  createInsuranceCompanyBatch: InsuranceCompanyBatch;
  createInsuranceOperation?: Maybe<InsuranceOperation>;
  createInsuranceReport?: Maybe<InsuranceReport>;
  createInsuranceReportExportFiles?: Maybe<Scalars['UUID']>;
  createIplpTemplate?: Maybe<IplpTemplate>;
  createLaboratory?: Maybe<Laboratory>;
  createLaboratoryRequisitionTemplate?: Maybe<LaboratoryRequisitionTemplate>;
  createLaboratoryRequisitionWorkplace?: Maybe<LaboratoryRequisitionWorkplace>;
  createLaboratoryWizard?: Maybe<LaboratoryWizard>;
  createLaboratoryWorkplace?: Maybe<LaboratoryWorkplace>;
  createMedicalExamination?: Maybe<MedicalExamination>;
  createMedicalHistoryType?: Maybe<MedicalHistoryType>;
  createNote?: Maybe<Note>;
  createOrUpdateQuestionnaireResultMember?: Maybe<QuestionnaireResultMember>;
  createP1MedicalRequest?: Maybe<JobResult>;
  createP1Prescription?: Maybe<JobResult>;
  createPhrase?: Maybe<Phrase>;
  createPlaylist?: Maybe<Playlist>;
  createPlaylistMedium?: Maybe<PlaylistMedium>;
  createRating?: Maybe<Rating>;
  createServiceSchedule?: Maybe<ServiceSchedule>;
  createServiceScheduleItem?: Maybe<MutationResult>;
  createSubscription?: Maybe<Subscription>;
  createSubscriptionGroup?: Maybe<SubscriptionGroup>;
  createSubscriptionRedeemCode?: Maybe<SubscriptionRedeemCode>;
  createToken?: Maybe<Token>;
  createUserMedicationLasted?: Maybe<Array<Maybe<UserMedicationLasted>>>;
  createUserMetaTranslation?: Maybe<User>;
  createUserSubscriptionMember?: Maybe<UserSubscriptionMember>;
  createWizardResult?: Maybe<WizardResult>;
  createWorkplaceAbsence?: Maybe<EventsResult>;
  createWorkplaceMedicalProcedure?: Maybe<WorkplaceMedicalProcedure>;
  createWorkplaceMedicalProcedures: Array<MutationResult>;
  createWorkplaceMemberAbsence?: Maybe<EventsResult>;
  createWorkplacePreset?: Maybe<WorkplacePreset>;
  createZusSickLeave?: Maybe<MutationResult>;
  deleteCareClaim?: Maybe<MutationResult>;
  deleteDocumentationFolder?: Maybe<MutationResult>;
  deleteGroup: MutationResult;
  deleteGroupMember: MutationResult;
  deleteHealthPlanWorkplace?: Maybe<HealthPlanWorkplace>;
  deleteHiddenWorkplace?: Maybe<Meta>;
  deleteInsuranceOperation?: Maybe<MutationResult>;
  deleteInsuranceReport?: Maybe<MutationResult>;
  deleteIplpTemplate?: Maybe<MutationResult>;
  deleteLaboratoryRequisitionTemplate?: Maybe<MutationResult>;
  deleteLaboratoryRequisitionWorkplace?: Maybe<Scalars['UUID']>;
  deleteLaboratoryWorkplace?: Maybe<MutationResult>;
  deleteMedicalHistoryType?: Maybe<MutationResult>;
  deletePhrase?: Maybe<MutationResult>;
  deleteServiceSchedule?: Maybe<MutationResult>;
  deleteServiceScheduleItem?: Maybe<MutationResult>;
  deleteToken?: Maybe<Token>;
  deleteToothLog?: Maybe<MutationResult>;
  deleteUserMedicationLasted?: Maybe<MutationResult>;
  deleteWizardResult?: Maybe<MutationResult>;
  deleteWorkplace?: Maybe<MutationResult>;
  deleteWorkplaceMedicalProcedure?: Maybe<MutationResult>;
  deleteWorkplaceMember?: Maybe<MutationResult>;
  doneEvent?: Maybe<Event>;
  endHealthPlanUser?: Maybe<HealthPlanUser>;
  familyMemberRelation?: Maybe<FamilyMember>;
  generateDocumentPDFWithDate?: Maybe<DocumentationFile>;
  generateSubscriptionRedeemCodes?: Maybe<Array<Maybe<SubscriptionRedeemCode>>>;
  generateSubscriptionRedeemCodesAlphabet?: Maybe<GenerateSubscriptionRedeemCodeAlphabetResult>;
  hideMembersWorkplace?: Maybe<Meta>;
  hideSeenLaboratoryResults?: Maybe<Array<Maybe<LaboratoryResultResult>>>;
  hideSeenQuestionnaireResults?: Maybe<HideSeenQuestionnaireResult>;
  importMedicalProceduresByFieldOfCare?: Maybe<MutationResult>;
  markAsSeenUserNotifications?: Maybe<MarkAsSeenUserNotificationsResult>;
  orderSubscription?: Maybe<SubscriptionOrder>;
  persistCareClaimsBulk?: Maybe<MutationResult>;
  priorityCase?: Maybe<Case>;
  purchaseProduct?: Maybe<ProductOrder>;
  reAssignCase?: Maybe<Case>;
  reactivateExpiredSubscription?: Maybe<SubscriptionOrder>;
  readDashboardMessage?: Maybe<Message>;
  removeUserSubscriptionMember?: Maybe<UserSubscriptionMember>;
  requestPaymentHealthPlanUser?: Maybe<HealthPlanUser>;
  resetTooth?: Maybe<MutationResult>;
  saveLaboratoryRequisitionResult?: Maybe<LaboratoryRequisitionResult>;
  saveNcziDoveraResult?: Maybe<MutationResult>;
  saveUserFilter?: Maybe<Meta>;
  sendLaboratoryResultMise?: Maybe<LaboratoryResultMise>;
  setUserNotificationSetting?: Maybe<UserNotificationSetting>;
  submitQuestionnaireResult?: Maybe<QuestionnaireResult>;
  submitWizard?: Maybe<SubmitWizardResult>;
  subscriptionChangePaymentMethod?: Maybe<ChangePaymentMethodUrl>;
  transferDocument?: Maybe<MutationResult>;
  transferDocuments?: Maybe<MutationResult>;
  tryChargeExpiredSubscription?: Maybe<ChargeStatus>;
  unassignLaboratoryResultMise?: Maybe<LaboratoryResultMise>;
  updateCareClaim?: Maybe<MutationResult>;
  updateDocumentationFolder?: Maybe<DocumentationFolder>;
  updateGroup: Group;
  updateHealthPlanWorkplace?: Maybe<MutationResult>;
  updateInsuranceReport?: Maybe<InsuranceReport>;
  updateIplpTemplate?: Maybe<IplpTemplate>;
  updateLaboratoryRequisitionTemplate?: Maybe<LaboratoryRequisitionTemplate>;
  updateLaboratoryWorkplace?: Maybe<LaboratoryWorkplace>;
  updateMe?: Maybe<User>;
  updateMedicalExamination?: Maybe<MutationResult>;
  updateMedicalHistoryType?: Maybe<MedicalHistoryType>;
  updateNote?: Maybe<Note>;
  updatePhrase?: Maybe<Phrase>;
  updateServiceSchedule?: Maybe<MutationResult>;
  updateServiceScheduleItem?: Maybe<MutationResult>;
  updateTooth?: Maybe<MutationResult>;
  updateToothBulk?: Maybe<MutationResult>;
  updateUserConsent?: Maybe<UserConsent>;
  updateUserMedicationLasted?: Maybe<UserMedicationLasted>;
  updateWorkplace?: Maybe<Workplace>;
  updateWorkplaceMedicalProcedure?: Maybe<WorkplaceMedicalProcedure>;
  updateWorkplaceMembers?: Maybe<Array<Maybe<WorkplaceMember>>>;
  userSubscriptionCancel?: Maybe<MutationResult>;
  workplacePatientDocumentationFilesMarkAsSeen?: Maybe<MutationResult>;
};


export type MutationActivateSubscriptionByIdArgs = {
  input: SubscriptionActivateByIdInput;
};


export type MutationActivateUserSubscriptionByRedeemCodeArgs = {
  input?: InputMaybe<ActivateUserSubscriptionByRedeemCode>;
};


export type MutationAddLaboratoryRequisitionToPatientArgs = {
  input: AddLaboratoryRequisitionToPatientInput;
};


export type MutationAssignCaseArgs = {
  input?: InputMaybe<ReAssignCaseInput>;
};


export type MutationAssignCaseToMeArgs = {
  input?: InputMaybe<AssignCaseToMeInput>;
};


export type MutationAssignLaboratoryResultMiseArgs = {
  input: AssignLaboratoryResultMiseInput;
};


export type MutationBulkUserHealthCategoryPermissionArgs = {
  input?: InputMaybe<BulkUserHealthCategoryPermissionInput>;
};


export type MutationCancelDrMaxReservationArgs = {
  input?: InputMaybe<CancelDrMaxReservationInput>;
};


export type MutationCancelP1MedicalRequestArgs = {
  input: CancelP1MedicalRequestInput;
};


export type MutationCancelP1PrescriptionArgs = {
  input: CancelP1PrescriptionInput;
};


export type MutationCreateCareClaimArgs = {
  input: CreateCareClaimInput;
};


export type MutationCreateCustomCalendarArgs = {
  input: CreateCustomCalendarInput;
};


export type MutationCreateDrMaxPrescriptionReservationArgs = {
  input?: InputMaybe<CreateDrMaxPrescriptionReservationInput>;
};


export type MutationCreateEventArgs = {
  input?: InputMaybe<CreateEventInput>;
};


export type MutationCreateGroupArgs = {
  input: CreateGroupInput;
};


export type MutationCreateGroupMemberArgs = {
  input: CreateGroupMemberInput;
};


export type MutationCreateGroupMembersArgs = {
  input: CreateGroupMembersInput;
};


export type MutationCreateHealthPlanArgs = {
  input?: InputMaybe<CreateHealthPlanInput>;
};


export type MutationCreateHealthPlanUserArgs = {
  input?: InputMaybe<CreateHealthPlanUserInput>;
};


export type MutationCreateHealthPlanUserFromDataArgs = {
  input?: InputMaybe<CreateHealthPlanUserFromDataInput>;
};


export type MutationCreateHealthPlanUserPaymentArgs = {
  input?: InputMaybe<HealthPlanUserPaymentInput>;
};


export type MutationCreateHealthPlanWorkplaceArgs = {
  input?: InputMaybe<CreateHealthPlanWorkplaceInput>;
};


export type MutationCreateInsuranceCompanyBatchArgs = {
  input: CreateInsuranceCompanyBatchInput;
};


export type MutationCreateInsuranceOperationArgs = {
  input?: InputMaybe<CreateOperationReportInput>;
};


export type MutationCreateInsuranceReportArgs = {
  input?: InputMaybe<CreateInsuranceReportInput>;
};


export type MutationCreateInsuranceReportExportFilesArgs = {
  input: CreateInsuranceReportExportFiles;
};


export type MutationCreateIplpTemplateArgs = {
  input: CreateIplpTemplateInput;
};


export type MutationCreateLaboratoryArgs = {
  input?: InputMaybe<CreateLaboratoryInput>;
};


export type MutationCreateLaboratoryRequisitionTemplateArgs = {
  input: CreateLaboratoryRequisitionTemplate;
};


export type MutationCreateLaboratoryRequisitionWorkplaceArgs = {
  input: CreateLaboratoryRequisitionWorkplaceInput;
};


export type MutationCreateLaboratoryWizardArgs = {
  input?: InputMaybe<CreateLaboratoryWizardInput>;
};


export type MutationCreateLaboratoryWorkplaceArgs = {
  input: CreateLaboratoryWorkplaceInput;
};


export type MutationCreateMedicalExaminationArgs = {
  input: CreateMedicalExaminationInput;
};


export type MutationCreateMedicalHistoryTypeArgs = {
  input: CreateMedicalHistoryTypeInput;
};


export type MutationCreateNoteArgs = {
  input?: InputMaybe<CreateNoteInput>;
};


export type MutationCreateOrUpdateQuestionnaireResultMemberArgs = {
  input?: InputMaybe<CreateOrUpdateQuestionnaireResultMemberInput>;
};


export type MutationCreateP1MedicalRequestArgs = {
  input: CreateP1MedicalRequestInput;
};


export type MutationCreateP1PrescriptionArgs = {
  input: CreateP1PrescriptionInput;
};


export type MutationCreatePhraseArgs = {
  input: CreatePhraseInput;
};


export type MutationCreatePlaylistArgs = {
  input?: InputMaybe<PlaylistInput>;
};


export type MutationCreatePlaylistMediumArgs = {
  input?: InputMaybe<PlaylistMediumInput>;
};


export type MutationCreateRatingArgs = {
  input?: InputMaybe<CreateRatingInput>;
};


export type MutationCreateServiceScheduleArgs = {
  input: CreateServiceScheduleInput;
};


export type MutationCreateServiceScheduleItemArgs = {
  input: CreateServiceScheduleItemInput;
};


export type MutationCreateSubscriptionArgs = {
  input?: InputMaybe<CreateSubscriptionInput>;
};


export type MutationCreateSubscriptionGroupArgs = {
  input?: InputMaybe<CreateSubscriptionGroup>;
};


export type MutationCreateSubscriptionRedeemCodeArgs = {
  input?: InputMaybe<CreateSubscriptionRedeemCodeInput>;
};


export type MutationCreateTokenArgs = {
  input?: InputMaybe<CreateTokenInput>;
};


export type MutationCreateUserMedicationLastedArgs = {
  input: CreateUserMedicationLastedInput;
};


export type MutationCreateUserMetaTranslationArgs = {
  input?: InputMaybe<Array<InputMaybe<UserMetaTranslationInput>>>;
};


export type MutationCreateUserSubscriptionMemberArgs = {
  input?: InputMaybe<CreateUserSubscriptionMemberInput>;
};


export type MutationCreateWizardResultArgs = {
  input: CreateWizardResultInput;
};


export type MutationCreateWorkplaceAbsenceArgs = {
  input?: InputMaybe<CreateWorkplaceAbsenceInput>;
};


export type MutationCreateWorkplaceMedicalProcedureArgs = {
  input: CreateWorkplaceMedicalProcedure;
};


export type MutationCreateWorkplaceMedicalProceduresArgs = {
  input: Array<CreateWorkplaceMedicalProcedure>;
};


export type MutationCreateWorkplaceMemberAbsenceArgs = {
  input?: InputMaybe<CreateWorkplaceMemberAbsenceInput>;
};


export type MutationCreateWorkplacePresetArgs = {
  input?: InputMaybe<CreateWorkplacePresetInput>;
};


export type MutationCreateZusSickLeaveArgs = {
  input: CreateZusSickLeaveInput;
};


export type MutationDeleteCareClaimArgs = {
  where: CareClaimWhereUniqueInput;
};


export type MutationDeleteDocumentationFolderArgs = {
  data?: InputMaybe<DeleteDocumentationFolderInput>;
  where?: InputMaybe<DocumentationFolderWhereInput>;
};


export type MutationDeleteGroupArgs = {
  where: GroupWhereUniqueInput;
};


export type MutationDeleteGroupMemberArgs = {
  where: GroupMemberWhereUniqueInput;
};


export type MutationDeleteHealthPlanWorkplaceArgs = {
  input?: InputMaybe<RemoveHealthPlanWorkplaceInput>;
};


export type MutationDeleteHiddenWorkplaceArgs = {
  input?: InputMaybe<HiddenWorkplaceMetaInput>;
};


export type MutationDeleteInsuranceOperationArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteInsuranceReportArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteIplpTemplateArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteLaboratoryRequisitionTemplateArgs = {
  where: LaboratoryRequisitionTemplateWhereUniqueInput;
};


export type MutationDeleteLaboratoryRequisitionWorkplaceArgs = {
  input: DeleteLaboratoryRequisitionWorkplaceInput;
};


export type MutationDeleteLaboratoryWorkplaceArgs = {
  where: LaboratoryWorkplaceWhereUniqueInput;
};


export type MutationDeleteMedicalHistoryTypeArgs = {
  where: MedicalHistoryTypeWhereUniqueInput;
};


export type MutationDeletePhraseArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteServiceScheduleArgs = {
  where: ServiceScheduleWhereInput;
};


export type MutationDeleteServiceScheduleItemArgs = {
  where: ServiceScheduleItemWhereInput;
};


export type MutationDeleteTokenArgs = {
  input?: InputMaybe<DeleteTokenInput>;
};


export type MutationDeleteToothLogArgs = {
  where: ToothLogUniqueWhereInput;
};


export type MutationDeleteUserMedicationLastedArgs = {
  id: Scalars['UUID'];
};


export type MutationDeleteWizardResultArgs = {
  input: DeleteWizardResultInput;
};


export type MutationDeleteWorkplaceArgs = {
  where: WorkplaceWhereUniqueInput;
};


export type MutationDeleteWorkplaceMedicalProcedureArgs = {
  input: DeleteWorkplaceMedicalProcedure;
};


export type MutationDeleteWorkplaceMemberArgs = {
  input?: InputMaybe<DeleteWorkplaceMemberInput>;
};


export type MutationDoneEventArgs = {
  input?: InputMaybe<DoneEventInput>;
};


export type MutationEndHealthPlanUserArgs = {
  input?: InputMaybe<EndHealthPlanUserInput>;
};


export type MutationFamilyMemberRelationArgs = {
  input?: InputMaybe<FamilyMemberRelationInput>;
};


export type MutationGenerateDocumentPdfWithDateArgs = {
  input: GenerateDocumentPdfWithDateInput;
};


export type MutationGenerateSubscriptionRedeemCodesArgs = {
  input?: InputMaybe<GenerateSubscriptionRedeemCodeInput>;
};


export type MutationGenerateSubscriptionRedeemCodesAlphabetArgs = {
  input?: InputMaybe<GenerateSubscriptionRedeemCodeAlphabetInput>;
};


export type MutationHideMembersWorkplaceArgs = {
  input?: InputMaybe<HiddenWorkplaceMetaInput>;
};


export type MutationHideSeenLaboratoryResultsArgs = {
  input: HideSeenLaboratoryResultsInput;
};


export type MutationImportMedicalProceduresByFieldOfCareArgs = {
  input?: InputMaybe<ImportMedicalProceduresByFieldOfCareInput>;
};


export type MutationOrderSubscriptionArgs = {
  input?: InputMaybe<OrderSubscriptionInput>;
};


export type MutationPersistCareClaimsBulkArgs = {
  input: PersistCareClaimInput;
  where: CareClaimPersistBulkWhereInput;
};


export type MutationPriorityCaseArgs = {
  input?: InputMaybe<PriorityCaseInput>;
};


export type MutationPurchaseProductArgs = {
  input?: InputMaybe<PurchaseProductInput>;
};


export type MutationReAssignCaseArgs = {
  input?: InputMaybe<ReAssignCaseInput>;
};


export type MutationReactivateExpiredSubscriptionArgs = {
  input?: InputMaybe<ReactivateSubscriptionInput>;
};


export type MutationReadDashboardMessageArgs = {
  input?: InputMaybe<ReadDashboardMessageInput>;
};


export type MutationRemoveUserSubscriptionMemberArgs = {
  input?: InputMaybe<RemoveUserSubscriptionMemberInput>;
};


export type MutationRequestPaymentHealthPlanUserArgs = {
  input?: InputMaybe<RequestPaymentHealthPlanUserInput>;
};


export type MutationResetToothArgs = {
  input: ResetToothInput;
  where: ToothWhereUniqueInput;
};


export type MutationSaveLaboratoryRequisitionResultArgs = {
  input: SaveLaboratoryRequisitionResultInput;
};


export type MutationSaveNcziDoveraResultArgs = {
  input: SaveNcziDoveraResultInput;
};


export type MutationSaveUserFilterArgs = {
  input?: InputMaybe<UserFilterInput>;
};


export type MutationSendLaboratoryResultMiseArgs = {
  input: SendLaboratoryResultMiseInput;
};


export type MutationSetUserNotificationSettingArgs = {
  input: SetUserNotificationSettingInput;
};


export type MutationSubmitQuestionnaireResultArgs = {
  input?: InputMaybe<SubmitQuestionnaireResultInput>;
};


export type MutationSubmitWizardArgs = {
  input: WizardResultInput;
};


export type MutationSubscriptionChangePaymentMethodArgs = {
  input?: InputMaybe<SubscriptionChangePaymentMethodInput>;
};


export type MutationTransferDocumentArgs = {
  input: DocumentTransferInput;
};


export type MutationTransferDocumentsArgs = {
  input: Array<DocumentTransferInput>;
};


export type MutationTryChargeExpiredSubscriptionArgs = {
  input?: InputMaybe<ChargeSubscriptionInput>;
};


export type MutationUnassignLaboratoryResultMiseArgs = {
  input: UnassignLaboratoryResultMiseInput;
};


export type MutationUpdateCareClaimArgs = {
  input: UpdateCareClaimInput;
  where: CareClaimWhereUniqueInput;
};


export type MutationUpdateDocumentationFolderArgs = {
  data?: InputMaybe<UpdateDocumentationFolderInput>;
  where?: InputMaybe<DocumentationFolderWhereInput>;
};


export type MutationUpdateGroupArgs = {
  input: UpdateGroupInput;
  where: GroupWhereUniqueInput;
};


export type MutationUpdateHealthPlanWorkplaceArgs = {
  input: UpdateHealthPlanWorkplaceInput;
  where: HealthPlanWorkplaceWhereUniqueInput;
};


export type MutationUpdateInsuranceReportArgs = {
  id: Scalars['UUID'];
  input: UpdateInsuranceReportInput;
};


export type MutationUpdateIplpTemplateArgs = {
  input: UpdateIplpTemplateInput;
  where: UpdateIplpWhereUniqueInput;
};


export type MutationUpdateLaboratoryRequisitionTemplateArgs = {
  input: UpdateLaboratoryRequisitionTemplate;
  where: LaboratoryRequisitionTemplateWhereUniqueInput;
};


export type MutationUpdateLaboratoryWorkplaceArgs = {
  input: UpdateLaboratoryWorkplaceInput;
  where: LaboratoryWorkplaceWhereUniqueInput;
};


export type MutationUpdateMeArgs = {
  data: UpdateMeInput;
};


export type MutationUpdateMedicalExaminationArgs = {
  input: UpdateMedicalExaminationInput;
  where: MedicalExaminationWhereUniqueInput;
};


export type MutationUpdateMedicalHistoryTypeArgs = {
  input: UpdateMedicalHistoryTypeInput;
  where: MedicalHistoryTypeWhereUniqueInput;
};


export type MutationUpdateNoteArgs = {
  input?: InputMaybe<UpdateNoteInput>;
};


export type MutationUpdatePhraseArgs = {
  input: UpdatePhraseInput;
  where: PhrasesWhereUnique;
};


export type MutationUpdateServiceScheduleArgs = {
  input: UpdateServiceScheduleInput;
  where: ServiceScheduleWhereInput;
};


export type MutationUpdateServiceScheduleItemArgs = {
  input: UpdateServiceScheduleItemInput;
  where: ServiceScheduleItemWhereInput;
};


export type MutationUpdateToothArgs = {
  input: UpdateToothInput;
  where: ToothWhereUniqueInput;
};


export type MutationUpdateToothBulkArgs = {
  input: UpdateToothInput;
  where: ToothUpdateBulkWhereUniqueInput;
};


export type MutationUpdateUserConsentArgs = {
  data?: InputMaybe<UpdateUserConsentInput>;
  where?: InputMaybe<UserConsentsWhereInput>;
};


export type MutationUpdateUserMedicationLastedArgs = {
  data?: InputMaybe<UpdateUserMedicationLastedDataInput>;
  where?: InputMaybe<UpdateUserMedicationLastedWhereInput>;
};


export type MutationUpdateWorkplaceArgs = {
  data: UpdateWorkplaceInput;
  where: WorkplaceWhereUniqueInput;
};


export type MutationUpdateWorkplaceMedicalProcedureArgs = {
  data: UpdateWorkplaceMedicalProcedureInput;
  where: WorkplaceMedicalProcedureWhereUniqueInput;
};


export type MutationUpdateWorkplaceMembersArgs = {
  input?: InputMaybe<UpdateWorkplaceMembersInput>;
};


export type MutationUserSubscriptionCancelArgs = {
  input?: InputMaybe<UserSubscriptionCancelInput>;
};

export type MutationResult = {
  __typename?: 'MutationResult';
  status?: Maybe<Scalars['Boolean']>;
};

export type MyEventsWhereInput = {
  approaching?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type MyFamily = {
  __typename?: 'MyFamily';
  familyMembers?: Maybe<Array<Maybe<MyFamilyMember>>>;
  id: Scalars['UUID'];
};

export type MyFamilyMember = {
  __typename?: 'MyFamilyMember';
  familyId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  role?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type MyFamilyMembersResult = {
  __typename?: 'MyFamilyMembersResult';
  data?: Maybe<Array<Maybe<MyFamilyMember>>>;
  meta?: Maybe<PageInfo>;
};

export type MyPhrasesWhereInput = {
  type?: InputMaybe<PhraseType>;
};

export type MyWorkplacesWhereInput = {
  type?: InputMaybe<Array<InputMaybe<WorkplaceType>>>;
};

export type NcziCodingScheme = {
  __typename?: 'NcziCodingScheme';
  oid: Scalars['String'];
};

export type NcziCodingSchemeVersioned = {
  __typename?: 'NcziCodingSchemeVersioned';
  oid: Scalars['String'];
  version: Scalars['String'];
};

export type NcziDiagnosisItem = {
  __typename?: 'NcziDiagnosisItem';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  enum: NcziEnum;
  name: Scalars['String'];
  ncziCode: Scalars['String'];
  params?: Maybe<Scalars['JSON']>;
};

export type NcziDiagnosisItemsResult = {
  __typename?: 'NcziDiagnosisItemsResult';
  data?: Maybe<Array<Maybe<NcziDiagnosisItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziDoveraListResult = {
  __typename?: 'NcziDoveraListResult';
  data?: Maybe<Array<Maybe<DoveraCheckItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziEnum = {
  __typename?: 'NcziEnum';
  extraAttr?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  oid: Scalars['String'];
  type: Scalars['String'];
  version: Scalars['String'];
};

export type NcziEnumItem = {
  __typename?: 'NcziEnumItem';
  abbreviation?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  enum: NcziEnum;
  name: Scalars['String'];
  params?: Maybe<Scalars['JSON']>;
};

export type NcziEnumItemsByCodeResult = {
  __typename?: 'NcziEnumItemsByCodeResult';
  enum?: Maybe<NcziEnum>;
  enumItems?: Maybe<Array<Maybe<NcziEnumItem>>>;
};

export type NcziEnumItemsResult = {
  __typename?: 'NcziEnumItemsResult';
  data?: Maybe<Array<Maybe<NcziEnumItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziEnumsResult = {
  __typename?: 'NcziEnumsResult';
  data?: Maybe<Array<Maybe<NcziEnum>>>;
};

export type NcziExtension = {
  __typename?: 'NcziExtension';
  name: Scalars['String'];
  oid: Scalars['String'];
  type?: Maybe<Scalars['String']>;
};

export type NcziExtensionItem = {
  __typename?: 'NcziExtensionItem';
  abbreviation?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  extension: NcziExtension;
  name: Scalars['String'];
  params?: Maybe<Scalars['JSON']>;
};

export type NcziExtensionItemsResult = {
  __typename?: 'NcziExtensionItemsResult';
  data?: Maybe<Array<Maybe<NcziExtensionItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziMedicamentItem = {
  __typename?: 'NcziMedicamentItem';
  additionalName: Scalars['String'];
  antibioticsChemotherapy: Scalars['Boolean'];
  atc?: Maybe<NcziReference>;
  code: Scalars['String'];
  form?: Maybe<NcziReference>;
  genericPrescription: Scalars['Boolean'];
  indicationGroup?: Maybe<NcziReference>;
  multiplePrescription: Scalars['Boolean'];
  name: Scalars['String'];
  ncziCode: Scalars['String'];
  opl: Scalars['Boolean'];
  packageSize?: Maybe<NcziQuantity>;
  prescriptionValidity?: Maybe<NcziQuantity>;
  submissionPath?: Maybe<NcziReference>;
  vaccination: Scalars['Boolean'];
};

export type NcziMedicamentItemsResult = {
  __typename?: 'NcziMedicamentItemsResult';
  data?: Maybe<Array<Maybe<NcziMedicamentItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziMessage = {
  __typename?: 'NcziMessage';
  createdAt?: Maybe<Scalars['String']>;
  extraParams?: Maybe<Scalars['JSON']>;
  finished?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  lastState?: Maybe<Scalars['String']>;
  resultCode?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['String']>;
  userId: Scalars['UUID'];
};

export type NcziNExtension = {
  __typename?: 'NcziNExtension';
  code: Scalars['String'];
  scheme: NcziCodingScheme;
  valid?: Maybe<NcziValidity>;
};

export type NcziOupZsItem = {
  __typename?: 'NcziOUPZsItem';
  code: Scalars['String'];
  extension?: Maybe<NcziNExtension>;
  name: Scalars['String'];
  provider?: Maybe<NcziPzsProvider>;
  specialization?: Maybe<Array<Maybe<NcziZPrSpecialization>>>;
};

export type NcziPzsProvider = {
  __typename?: 'NcziPZSProvider';
  code: Scalars['String'];
  extension?: Maybe<NcziNExtension>;
  name: Scalars['String'];
};

export type NcziProductItem = {
  __typename?: 'NcziProductItem';
  additionalName?: Maybe<Scalars['String']>;
  antibioticsChemotherapy?: Maybe<Scalars['Boolean']>;
  atc?: Maybe<NcziReference>;
  atcAddon?: Maybe<Scalars['String']>;
  atcCode?: Maybe<Scalars['String']>;
  atcName?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  ioNeeded?: Maybe<Scalars['Boolean']>;
  ioOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  name: Scalars['String'];
  opl?: Maybe<Scalars['Boolean']>;
  quantityLimit?: Maybe<Array<Maybe<Scalars['String']>>>;
  tailored?: Maybe<Scalars['Boolean']>;
  type: Scalars['String'];
  ventilator?: Maybe<Scalars['Boolean']>;
};

export type NcziProductItemsResult = {
  __typename?: 'NcziProductItemsResult';
  data?: Maybe<Array<Maybe<NcziProductItem>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziQuantity = {
  __typename?: 'NcziQuantity';
  amount?: Maybe<Scalars['String']>;
  unit?: Maybe<NcziReference>;
};

export type NcziQueueResult = {
  __typename?: 'NcziQueueResult';
  data?: Maybe<Array<Maybe<NcziMessage>>>;
  meta?: Maybe<PageInfo>;
};

export type NcziReference = {
  __typename?: 'NcziReference';
  code: Scalars['String'];
  displayName: Scalars['String'];
  scheme: NcziCodingSchemeVersioned;
};

export type NcziValidity = {
  __typename?: 'NcziValidity';
  from?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['String']>;
};

export type NcziZPrSpecialization = {
  __typename?: 'NcziZPrSpecialization';
  ZPrCode: Scalars['String'];
  specialization: NcziReference;
};

export type Note = {
  __typename?: 'Note';
  id?: Maybe<Scalars['UUID']>;
  text?: Maybe<Scalars['String']>;
};

export enum OnlineOrderTarget {
  Workplace = 'WORKPLACE',
  WorkplaceMember = 'WORKPLACE_MEMBER'
}

export type Order = {
  __typename?: 'Order';
  commission?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['UUID']>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  issueDate?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  orderItems?: Maybe<Array<Maybe<OrderItem>>>;
  orderLog?: Maybe<OrderLog>;
  orderLogs?: Maybe<Array<Maybe<OrderLog>>>;
  orderMembers?: Maybe<Array<Maybe<OrderMember>>>;
  paymentMethod?: Maybe<OrderPaymentMethod>;
  price?: Maybe<TransactionPrice>;
  priceInvoicing?: Maybe<Scalars['String']>;
  refunds?: Maybe<Array<Maybe<Invoice>>>;
  status?: Maybe<OrderStatus>;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  subtype?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type OrderLog = {
  __typename?: 'OrderLog';
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type OrderMember = {
  __typename?: 'OrderMember';
  type?: Maybe<OrderMemberType>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum OrderMemberType {
  Issuer = 'Issuer',
  Payer = 'Payer'
}

export enum OrderPaymentMethod {
  Apay = 'APAY',
  Crd = 'CRD',
  Edenred = 'EDENRED',
  Gpay = 'GPAY',
  MeddiCredit = 'MEDDI_CREDIT',
  Paypal = 'PAYPAL',
  Sodexo = 'SODEXO',
  Voucher = 'VOUCHER'
}

export type OrderStatistics = {
  __typename?: 'OrderStatistics';
  currency?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  totalCommission?: Maybe<Scalars['Float']>;
  totalInvoiced?: Maybe<Scalars['Float']>;
};

export type OrderStatisticsResult = {
  __typename?: 'OrderStatisticsResult';
  data?: Maybe<Array<Maybe<OrderStatistics>>>;
};

export type OrderStatisticsWhereInput = {
  from: Scalars['DateTime'];
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  orderMembers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  sendEmpty?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<OrderStatus>;
  to: Scalars['DateTime'];
  workplaceId?: InputMaybe<Scalars['String']>;
};

export type OrderStats = {
  __typename?: 'OrderStats';
  commissionTotal?: Maybe<Scalars['Decimal']>;
  commissionTotalFormatted?: Maybe<Scalars['String']>;
  invoicedTotal?: Maybe<Scalars['Decimal']>;
  invoicedTotalFormatted?: Maybe<Scalars['String']>;
};

export enum OrderStatus {
  Canceled = 'CANCELED',
  Created = 'CREATED',
  Paid = 'PAID',
  Refunded = 'REFUNDED'
}

export type OrderSubscriptionInput = {
  paymentMethod?: InputMaybe<Scalars['String']>;
  subscriptionId?: InputMaybe<Scalars['String']>;
  subscriptionPeriodId?: InputMaybe<Scalars['String']>;
};

export type OrdersFilter = {
  from?: InputMaybe<Scalars['DateTime']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  orderMembers?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<OrderStatus>;
  to?: InputMaybe<Scalars['DateTime']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type OrdersResult = {
  __typename?: 'OrdersResult';
  data?: Maybe<Array<Maybe<Order>>>;
  meta?: Maybe<PageInfo>;
  stats?: Maybe<OrderStats>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  count?: Maybe<Scalars['Int']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  next?: Maybe<Scalars['JSONObject']>;
  page?: Maybe<Scalars['Int']>;
  params?: Maybe<Scalars['JSONObject']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PaginationInput = {
  after?: InputMaybe<Scalars['UUID']>;
  order?: InputMaybe<PaginationInputOrder>;
  page?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};

export type PaginationInputOrder = {
  how?: InputMaybe<PaginationOrderHow>;
  key?: InputMaybe<Scalars['String']>;
};

export enum PaginationOrderHow {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type PatientCalculator = {
  __typename?: 'PatientCalculator';
  description?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  wizardKey: Scalars['String'];
};

export type PatientCalculatorsResult = {
  __typename?: 'PatientCalculatorsResult';
  data?: Maybe<Array<Maybe<PatientCalculator>>>;
  meta?: Maybe<PageInfo>;
};

export type PaySubscriptionInput = {
  subscriptionId?: InputMaybe<Scalars['String']>;
  subscriptionPeriodId?: InputMaybe<Scalars['String']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  icon?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PersistCareClaimCareClaimInput = {
  documentId: Scalars['UUID'];
  id?: InputMaybe<Scalars['UUID']>;
  medicalProcedureId: Scalars['UUID'];
  patientId: Scalars['UUID'];
};

export type PersistCareClaimInput = {
  careClaims: Array<PersistCareClaimCareClaimInput>;
};

export type Phrase = {
  __typename?: 'Phrase';
  id?: Maybe<Scalars['UUID']>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  name?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
  type?: Maybe<PhraseType>;
  userId?: Maybe<Scalars['UUID']>;
  value?: Maybe<Scalars['String']>;
};


export type PhraseMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
};

export enum PhraseType {
  Chat = 'CHAT',
  Discourse = 'DISCOURSE',
  LaboratoryResult = 'LABORATORY_RESULT'
}

export type PhrasesResult = {
  __typename?: 'PhrasesResult';
  data: Array<Maybe<Phrase>>;
  meta: PageInfo;
};

export type PhrasesWhereUnique = {
  id: Scalars['UUID'];
};

export type Playlist = {
  __typename?: 'Playlist';
  code?: Maybe<PlaylistCode>;
  id: Scalars['UUID'];
  mediums?: Maybe<Array<Maybe<Medium>>>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<PlaylistType>;
};

export enum PlaylistCode {
  Medditation = 'MEDDITATION'
}

export type PlaylistInput = {
  code: PlaylistCode;
  name: Scalars['String'];
  type: PlaylistType;
};

export type PlaylistMedium = {
  __typename?: 'PlaylistMedium';
  id: Scalars['UUID'];
  mediumId?: Maybe<Scalars['UUID']>;
  playlistId?: Maybe<Scalars['UUID']>;
};

export type PlaylistMediumInput = {
  mediumId: Scalars['UUID'];
  playlistId: Scalars['UUID'];
};

export enum PlaylistType {
  Default = 'DEFAULT'
}

export type PlaylistsResult = {
  __typename?: 'PlaylistsResult';
  data?: Maybe<Array<Maybe<Playlist>>>;
  meta?: Maybe<PageInfo>;
};

export type Post = {
  __typename?: 'Post';
  body?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['Int'];
  imageUrl?: Maybe<Scalars['String']>;
  isNew?: Maybe<Scalars['Boolean']>;
  link?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PostsResult = {
  __typename?: 'PostsResult';
  data?: Maybe<Array<Maybe<Post>>>;
  meta?: Maybe<PageInfo>;
};

export type Prescription = {
  __typename?: 'Prescription';
  canBeReserved?: Maybe<Scalars['Boolean']>;
  canDrmax?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  cancelledBy?: Maybe<User>;
  cancelledById?: Maybe<Scalars['UUID']>;
  cancelledByName?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  createdByName?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['JSONObject']>;
  documentationFile?: Maybe<DocumentationFile>;
  drMaxPickupPlace?: Maybe<DrMaxPickupPlace>;
  id: Scalars['UUID'];
  international?: Maybe<Scalars['Boolean']>;
  internationalPdfFile?: Maybe<DocumentationFile>;
  internationalPdfFileId?: Maybe<Scalars['UUID']>;
  isCancelable?: Maybe<Scalars['Boolean']>;
  isCancelled?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<PrescriptionItem>>>;
  pdfFile?: Maybe<DocumentationFile>;
  pdfFileId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  validUntil?: Maybe<Scalars['DateTime']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type PrescriptionItem = {
  __typename?: 'PrescriptionItem';
  childPrescriptionItems?: Maybe<Array<Maybe<PrescriptionItem>>>;
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['UUID'];
  parentPrescriptionItem?: Maybe<PrescriptionItem>;
  parentPrescriptionItemId?: Maybe<Scalars['UUID']>;
  prescription?: Maybe<Prescription>;
  prescriptionId?: Maybe<Scalars['UUID']>;
  prescriptionMedicament?: Maybe<PrescriptionMedicament>;
  prescriptionMedicamentId?: Maybe<Scalars['UUID']>;
  quantity?: Maybe<Scalars['Decimal']>;
};

export type PrescriptionItemsResult = {
  __typename?: 'PrescriptionItemsResult';
  data?: Maybe<Array<Maybe<PrescriptionItem>>>;
  meta?: Maybe<PageInfo>;
};

export type PrescriptionMedicament = {
  __typename?: 'PrescriptionMedicament';
  addition?: Maybe<Scalars['String']>;
  atc?: Maybe<Scalars['String']>;
  authorizationNumber?: Maybe<Scalars['String']>;
  availabilityCategory?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  dispensing?: Maybe<Scalars['String']>;
  dispensingTermItem?: Maybe<TermItem>;
  doping?: Maybe<Scalars['String']>;
  dopingTermItem?: Maybe<TermItem>;
  form?: Maybe<Scalars['String']>;
  gtin?: Maybe<Scalars['String']>;
  hasIndicationLimitations?: Maybe<Scalars['Boolean']>;
  hasLimitations?: Maybe<Scalars['Boolean']>;
  hasSpecialityLimitations?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['UUID']>;
  indicationLimitations?: Maybe<Scalars['String']>;
  internationalName?: Maybe<Scalars['String']>;
  lim?: Maybe<Scalars['String']>;
  limTermItem?: Maybe<TermItem>;
  marketingAuthorizationHolder?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  packageCount?: Maybe<Scalars['String']>;
  packageDivisible?: Maybe<Scalars['Boolean']>;
  packageType?: Maybe<Scalars['String']>;
  packaging?: Maybe<Scalars['String']>;
  packagingCapacity?: Maybe<Scalars['String']>;
  packagingCapacityUnit?: Maybe<Scalars['String']>;
  priceExtraFormatted?: Maybe<Scalars['String']>;
  priceInsuranceCompanyRawFormatted?: Maybe<Scalars['String']>;
  priceRawFormatted?: Maybe<Scalars['String']>;
  procedureType?: Maybe<Scalars['String']>;
  rationalPrescription?: Maybe<Scalars['String']>;
  routeOfAdministration?: Maybe<Scalars['String']>;
  specialityLimitationTermItems?: Maybe<Array<Maybe<TermItem>>>;
  specialityLimitations?: Maybe<Scalars['String']>;
  statusType?: Maybe<Scalars['String']>;
  strength?: Maybe<Scalars['String']>;
};

export type PrescriptionMedicamentsResult = {
  __typename?: 'PrescriptionMedicamentsResult';
  data?: Maybe<Array<Maybe<PrescriptionMedicament>>>;
  meta?: Maybe<PageInfo>;
};

export enum PrescriptionType {
  Default = 'DEFAULT',
  Sukl = 'SUKL'
}

export type PrescriptionsResult = {
  __typename?: 'PrescriptionsResult';
  data?: Maybe<Array<Maybe<Prescription>>>;
  meta?: Maybe<PageInfo>;
};

export type Price = {
  __typename?: 'Price';
  currency: Scalars['String'];
  formattedPrice?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Decimal']>;
  priceWithVat?: Maybe<Scalars['Decimal']>;
  priceWithVatRaw?: Maybe<Scalars['String']>;
  vatRate: Scalars['Float'];
};

export type PriceDiscount = {
  __typename?: 'PriceDiscount';
  absoluteDiscountFormatted?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  relativeDiscount?: Maybe<Scalars['Decimal']>;
};

export type PriceFloat = {
  __typename?: 'PriceFloat';
  currency: Scalars['String'];
  formattedPrice?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  price?: Maybe<Scalars['Float']>;
  priceWithVat?: Maybe<Scalars['Float']>;
  priceWithVatRaw?: Maybe<Scalars['String']>;
  vatRate: Scalars['Float'];
};

export type PriorityCaseInput = {
  caseId: Scalars['UUID'];
  priorityId?: InputMaybe<Scalars['UUID']>;
};

export type Product = {
  __typename?: 'Product';
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['JSON']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  formattedPrice?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  price?: Maybe<ProductPrice>;
  productGroup?: Maybe<Scalars['String']>;
  purchaseButton?: Maybe<ProductPurchaseButton>;
  rank?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type ProductItem = {
  __typename?: 'ProductItem';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  productId: Scalars['UUID'];
  quantity?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type ProductOrder = {
  __typename?: 'ProductOrder';
  id: Scalars['UUID'];
  number?: Maybe<Scalars['Int']>;
  orderId?: Maybe<Scalars['UUID']>;
  orderItems?: Maybe<Array<Maybe<ProductOrderItem>>>;
  price?: Maybe<ProductOrderPrice>;
  redirectUrl?: Maybe<Scalars['String']>;
};

export type ProductOrderItem = {
  __typename?: 'ProductOrderItem';
  code?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
};

export type ProductOrderPrice = {
  __typename?: 'ProductOrderPrice';
  currency?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  price?: Maybe<Scalars['Float']>;
  pricePiece?: Maybe<Scalars['Int']>;
  priceWithVat?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Int']>;
  vatRate?: Maybe<Scalars['Float']>;
};

export type ProductPrice = {
  __typename?: 'ProductPrice';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currency?: Maybe<Scalars['String']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  pricePieceWithVat?: Maybe<Scalars['Float']>;
  productId: Scalars['UUID'];
  vatRate?: Maybe<Scalars['Float']>;
};

export type ProductPurchaseButton = {
  __typename?: 'ProductPurchaseButton';
  description?: Maybe<Scalars['String']>;
  theme?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type Profile = {
  __typename?: 'Profile';
  address?: Maybe<Address>;
  addressId?: Maybe<Scalars['UUID']>;
  age?: Maybe<Scalars['String']>;
  birthDate?: Maybe<Scalars['String']>;
  birthNumber?: Maybe<Scalars['String']>;
  capitationRegistrationAt?: Maybe<Scalars['DateTime']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  fatherLastName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  formattedBirthNumber?: Maybe<Scalars['String']>;
  formattedGender?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  genderTermItem?: Maybe<TermItem>;
  genderTermItemId?: Maybe<Scalars['UUID']>;
  hasInsurance?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  insuranceCompanyTermItem?: Maybe<TermItem>;
  insuranceCompanyTermItemId?: Maybe<Scalars['UUID']>;
  insuranceNumber?: Maybe<Scalars['String']>;
  languageFormatted?: Maybe<Scalars['String']>;
  languageIso?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  motherLastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nationalityOther?: Maybe<Scalars['String']>;
  nationalityTermItem?: Maybe<TermItem>;
  nationalityTermItemId?: Maybe<Scalars['UUID']>;
  salutation?: Maybe<Scalars['String']>;
  salutationAfter?: Maybe<Scalars['String']>;
  salutationBefore?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
};

export type PurchaseProductInput = {
  paymentMethod: Scalars['String'];
  productCode: Scalars['String'];
};

export type Query = {
  __typename?: 'Query';
  activeCases?: Maybe<CasesResult>;
  auditLogs?: Maybe<AuditLogsResult>;
  availableDoctors?: Maybe<AvailableDoctorsResult>;
  bioScanHistories?: Maybe<BioScanHistoriesResult>;
  calendar?: Maybe<Calendar>;
  calendarEvents?: Maybe<EventsResult>;
  careClaim?: Maybe<CareClaim>;
  careClaims?: Maybe<CareClaimsResult>;
  case?: Maybe<Case>;
  caseDoctors?: Maybe<CaseDoctorsResult>;
  caseEntries?: Maybe<CaseEntriesResult>;
  cases?: Maybe<CasesResult>;
  casesAssigned?: Maybe<CasesResult>;
  certificates?: Maybe<CertificatesResult>;
  conversation?: Maybe<Conversation>;
  conversations?: Maybe<ConversationsResult>;
  dashboardLayout?: Maybe<Array<Maybe<DashboardLayoutItem>>>;
  dashboardMessage?: Maybe<Message>;
  dashboardMessages?: Maybe<Array<Maybe<Message>>>;
  dashboardTiles?: Maybe<Array<Maybe<DashboardTile>>>;
  dentitionByUserId?: Maybe<Dentition>;
  doctors?: Maybe<UsersResult>;
  document?: Maybe<Document>;
  documentLogs?: Maybe<DocumentLogsResult>;
  documentVersions?: Maybe<DocumentsResult>;
  documentationFile?: Maybe<DocumentationFile>;
  documentationFiles?: Maybe<DocumentationFilesResult>;
  documentationFolder?: Maybe<DocumentationFolder>;
  documentationFolders?: Maybe<DocumentationFoldersResult>;
  documents?: Maybe<DocumentsResult>;
  drmaxPickupPlaces?: Maybe<DrMaxPickupPlacesResult>;
  drmaxPrescriptionMedicaments?: Maybe<DrMaxPrescriptionMedicamentsResult>;
  educationMaterial?: Maybe<EducationMaterial>;
  educationMaterialFolders?: Maybe<EducationMaterialFoldersResult>;
  educationMaterials?: Maybe<EducationMaterialsResult>;
  event?: Maybe<Event>;
  events?: Maybe<EventsResult>;
  exportLogs?: Maybe<ExportLogsResult>;
  familyMember?: Maybe<FamilyMember>;
  familyMemberShareList?: Maybe<FamilyMembersResult>;
  familyMembers?: Maybe<FamilyMembersResult>;
  familyMembersAvailableForCaseCreate?: Maybe<UsersResult>;
  filterCaseContacts?: Maybe<CaseContactsResult>;
  group?: Maybe<Group>;
  groupMembers?: Maybe<GroupMembersResult>;
  groups?: Maybe<GroupsResult>;
  healthData?: Maybe<HealthDataResult>;
  healthDataDashboardCategories?: Maybe<Array<Maybe<HealthDataDashboardCategory>>>;
  healthDataLastValues?: Maybe<HealthDataResult>;
  healthPlan?: Maybe<HealthPlan>;
  healthPlanBabyPregnancy?: Maybe<HealthPlanBabyPregnancy>;
  healthPlanUser?: Maybe<HealthPlanUser>;
  healthPlanUserItem?: Maybe<HealthPlanUserItem>;
  healthPlanUserItems?: Maybe<HealthPlanUserItemResult>;
  healthPlanUsers?: Maybe<HealthPlanUsersResult>;
  healthPlanWorkplaceByHealthPlanId?: Maybe<HealthPlanWorkplace>;
  healthPlans?: Maybe<HealthPlansResult>;
  insuranceCompanies?: Maybe<TermItemsResult>;
  insuranceCompanyBatches?: Maybe<InsuranceCompanyBatchResult>;
  insuranceOperation?: Maybe<InsuranceOperation>;
  insuranceOperations?: Maybe<InsuranceOperationResult>;
  insuranceReport?: Maybe<InsuranceReport>;
  insuranceReports?: Maybe<InsuranceReportsResult>;
  iots?: Maybe<IotsResult>;
  iplpTemplates?: Maybe<IplpTemplatesResult>;
  laboratories?: Maybe<LaboratoryResult>;
  laboratory?: Maybe<Laboratory>;
  laboratoryRequisitionForm?: Maybe<LaboratoryRequisitionFormResult>;
  laboratoryRequisitionFormPrice?: Maybe<Price>;
  laboratoryRequisitionResult?: Maybe<LaboratoryRequisitionResult>;
  laboratoryRequisitionResults?: Maybe<LaboratoryRequisitionResultsResult>;
  laboratoryRequisitionTemplates?: Maybe<LaboratoryRequisitionTemplatesResult>;
  laboratoryRequisitions?: Maybe<LaboratoryRequisitionsResult>;
  laboratoryResult?: Maybe<LaboratoryResultResult>;
  laboratoryResultMise?: Maybe<LaboratoryResultMise>;
  laboratoryResults?: Maybe<LaboratoryResultsResult>;
  laboratoryResultsMise?: Maybe<LaboratoryResultsMise>;
  laboratoryWizards?: Maybe<LaboratoryWizardsResult>;
  laboratoryWorkplaces?: Maybe<LaboratoryWorkplacesResult>;
  me?: Maybe<User>;
  meddiAccount?: Maybe<MeddiAccount>;
  meddiAccountTransactions?: Maybe<MeddiAccountTransactionResult>;
  meddiAccounts?: Maybe<MeddiAccountResult>;
  medicalExamination?: Maybe<MedicalExamination>;
  medicalExaminations?: Maybe<MedicalExaminationsResult>;
  medicalHistoryType?: Maybe<MedicalHistoryTypeResult>;
  medicalProcedure?: Maybe<MedicalProcedure>;
  medicalProcedures?: Maybe<MedicalProcedureResult>;
  medicalRequestForm?: Maybe<MedicalRequestForm>;
  medicalRequestForms?: Maybe<MedicalRequestFormsResult>;
  message?: Maybe<Message>;
  messageMembers?: Maybe<Array<Maybe<MessageMembersResult>>>;
  messages?: Maybe<MessagesResult>;
  messagesByConversation?: Maybe<MessagesResult>;
  meta?: Maybe<Meta>;
  metaMy?: Maybe<Meta>;
  metas?: Maybe<MetasResult>;
  monitoringCentreCases?: Maybe<CasesResult>;
  myActiveCases?: Maybe<CasesResult>;
  myActiveSubscriptions?: Maybe<UserSubscriptionsResult>;
  myEvents?: Maybe<EventsResult>;
  myFamily?: Maybe<MyFamily>;
  myFamilyMembers?: Maybe<MyFamilyMembersResult>;
  myPhrases?: Maybe<PhrasesResult>;
  myWorkplaces?: Maybe<WorkplacesResult>;
  ncziDoveraList?: Maybe<NcziDoveraListResult>;
  ncziEnumItem?: Maybe<NcziEnumItem>;
  ncziEnumItemByAbbr?: Maybe<NcziEnumItem>;
  ncziEnumItems?: Maybe<NcziEnumItemsByCodeResult>;
  ncziExtensionItem?: Maybe<NcziExtensionItem>;
  ncziExtensionItemByAbbr?: Maybe<NcziExtensionItem>;
  ncziListDiagnosis?: Maybe<NcziDiagnosisItemsResult>;
  ncziListEnumItems?: Maybe<NcziEnumItemsResult>;
  ncziListEnums?: Maybe<NcziEnumsResult>;
  ncziListExtensionItems?: Maybe<NcziExtensionItemsResult>;
  ncziListMedicamentItems?: Maybe<NcziMedicamentItemsResult>;
  ncziListProductItems?: Maybe<NcziProductItemsResult>;
  ncziListQueue?: Maybe<NcziQueueResult>;
  ncziMedicamentItem?: Maybe<NcziMedicamentItem>;
  ncziOUPZsByCode?: Maybe<Array<Maybe<NcziOupZsItem>>>;
  ncziOUPZsByPZSCode?: Maybe<Array<Maybe<NcziOupZsItem>>>;
  ncziProductItem?: Maybe<NcziProductItem>;
  notifications?: Maybe<MessagesResult>;
  nurseCases?: Maybe<CasesResult>;
  orderStatistics?: Maybe<OrderStatisticsResult>;
  orders?: Maybe<OrdersResult>;
  patient?: Maybe<User>;
  patientCalculators?: Maybe<PatientCalculatorsResult>;
  patients?: Maybe<UsersResult>;
  playlist?: Maybe<Playlist>;
  playlists?: Maybe<PlaylistsResult>;
  posts?: Maybe<PostsResult>;
  prescription?: Maybe<Prescription>;
  prescriptionItems?: Maybe<PrescriptionItemsResult>;
  prescriptionMedicament?: Maybe<PrescriptionMedicament>;
  prescriptionMedicaments?: Maybe<PrescriptionMedicamentsResult>;
  prescriptions?: Maybe<PrescriptionsResult>;
  product?: Maybe<Product>;
  products?: Maybe<Array<Maybe<Product>>>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireResultItems?: Maybe<QuestionnaireResultItemsResult>;
  questionnaireResults?: Maybe<QuestionnaireResultsResult>;
  questionnaireSchedule?: Maybe<QuestionnaireSchedule>;
  questionnaireSchedules?: Maybe<QuestionnaireSchedulesResult>;
  questionnaires?: Maybe<QuestionnairesResult>;
  rating?: Maybe<Rating>;
  ratings?: Maybe<RatingsResult>;
  rootWorkplaceDoctors?: Maybe<WorkplaceMembersResult>;
  rootWorkplacesPatient?: Maybe<WorkplaceMembersResult>;
  searchableDoctors?: Maybe<UsersResult>;
  serviceSchedules?: Maybe<ServiceSchedulesResult>;
  subscription?: Maybe<Subscription>;
  subscriptionOffers?: Maybe<SubscriptionOffersResult>;
  subscriptionPaymentMethods?: Maybe<Array<Maybe<PaymentMethod>>>;
  subscriptions?: Maybe<SubscriptionsResult>;
  termItem?: Maybe<TermItem>;
  termItemByValue?: Maybe<TermItem>;
  termItems?: Maybe<TermItemsResult>;
  terms?: Maybe<TermsResult>;
  token?: Maybe<Token>;
  tokens?: Maybe<TokensResult>;
  tooth?: Maybe<Tooth>;
  toothLogs?: Maybe<ToothLogsResult>;
  transmiseList?: Maybe<TransmiseListResult>;
  user?: Maybe<User>;
  userConsents?: Maybe<UserConsentsResult>;
  userDekurzes?: Maybe<UserDekurzesResult>;
  userFilter?: Maybe<Meta>;
  userHealthCategories?: Maybe<UserHealthCategoriesResult>;
  userHealthCategoryPermissions?: Maybe<UserHealthCategoryPermissionsResult>;
  userMedicationLasted?: Maybe<UserMedicationLastedResult>;
  userNotice?: Maybe<UserNotice>;
  userNotificationSettings?: Maybe<UserNotificationSettingsResult>;
  users?: Maybe<UsersResult>;
  wizard?: Maybe<Wizard>;
  wizardItem?: Maybe<WizardItem>;
  wizardItems?: Maybe<WizardItemsResult>;
  wizardResult?: Maybe<WizardResult>;
  wizardResultItems?: Maybe<WizardResultItemsResult>;
  wizardResults?: Maybe<WizardResultsResult>;
  wizardTree?: Maybe<Array<Maybe<WizardItem>>>;
  wizards?: Maybe<WizardsResult>;
  workplace?: Maybe<Workplace>;
  workplaceAclRoles?: Maybe<AclRoleResult>;
  workplaceAddress?: Maybe<Address>;
  workplaceCalendar?: Maybe<CalendarsResult>;
  workplaceCaseType?: Maybe<WorkplaceCaseType>;
  workplaceCaseTypes?: Maybe<WorkplaceCaseTypesResult>;
  workplaceCaseTypesDoctor?: Maybe<WorkplaceCaseTypesResult>;
  workplaceCases?: Maybe<CasesResult>;
  workplaceCasesArchived?: Maybe<CasesResult>;
  workplaceCertificates?: Maybe<WorkplaceCertificatesResult>;
  workplaceCustomCalendar?: Maybe<CalendarsResult>;
  workplaceDoctors?: Maybe<WorkplaceMembersResult>;
  workplaceEvents?: Maybe<EventsResult>;
  workplaceGroups?: Maybe<GroupsResult>;
  workplaceHealthPlans?: Maybe<HealthPlansResult>;
  workplaceInsuranceBatchs?: Maybe<InsuranceBatchsResult>;
  workplaceInsuranceExports?: Maybe<InsuranceExportsResult>;
  workplaceMedicalProcedure?: Maybe<WorkplaceMedicalProcedure>;
  workplaceMedicalProcedures?: Maybe<WorkplaceMedicalProcedureResult>;
  workplaceMember?: Maybe<WorkplaceMember>;
  workplaceMembers?: Maybe<WorkplaceMembersResult>;
  workplacePatientDocumentationFiles?: Maybe<DocumentationFilesResult>;
  workplacePatientPending?: Maybe<WorkplaceMembersResult>;
  workplacePatients?: Maybe<WorkplaceMembersResult>;
  workplacePresets?: Maybe<WorkplacePresetsResult>;
  workplaces?: Maybe<WorkplacesResult>;
};


export type QueryActiveCasesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
};


export type QueryAuditLogsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  targetEntityId?: InputMaybe<Scalars['String']>;
  targetEntityType?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryAvailableDoctorsArgs = {
  nurse: Scalars['Boolean'];
  pagination?: InputMaybe<PaginationInput>;
  pattern: Scalars['String'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryBioScanHistoriesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCalendarArgs = {
  where: CalendarWhereUniqueInput;
};


export type QueryCalendarEventsArgs = {
  where: CalendarEventsWhereInput;
};


export type QueryCareClaimArgs = {
  where: CareClaimWhereUniqueInput;
};


export type QueryCareClaimsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<CareClaimWhereInput>;
};


export type QueryCaseArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryCaseDoctorsArgs = {
  caseTypeCode?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryCaseEntriesArgs = {
  caseId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryCasesArgs = {
  caseStatusValue?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  doctorIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCasesAssignedArgs = {
  caseStatusValue?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  doctor?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  doctorIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
  patient?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryCertificatesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryConversationArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryConversationsArgs = {
  folder?: InputMaybe<ConversationFolderEnum>;
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<Scalars['String']>;
  types?: InputMaybe<Array<InputMaybe<ConversationType>>>;
};


export type QueryDashboardMessageArgs = {
  userId: Scalars['UUID'];
};


export type QueryDentitionByUserIdArgs = {
  where: DentitionWhereInput;
};


export type QueryDoctorsArgs = {
  excludeRoleKey?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  includeNurses?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  roleKey?: InputMaybe<Scalars['String']>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryDocumentArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<DocumentType>;
  userId?: InputMaybe<Scalars['UUID']>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type QueryDocumentLogsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<DocumentLogsWhereInput>;
};


export type QueryDocumentVersionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<DocumentWhereInput>;
};


export type QueryDocumentationFileArgs = {
  where: DocumentationFileWhereUniqueInput;
};


export type QueryDocumentationFilesArgs = {
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  folderId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  grouped?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  unprocessed?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryDocumentationFolderArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryDocumentationFoldersArgs = {
  folderId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryDocumentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  types?: InputMaybe<Array<InputMaybe<DocumentType>>>;
  userId?: InputMaybe<Scalars['UUID']>;
  where?: InputMaybe<DocumentsWhereInput>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryDrmaxPickupPlacesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  prescriptionId?: InputMaybe<Scalars['UUID']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryDrmaxPrescriptionMedicamentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  pharmacyId?: InputMaybe<Scalars['Int']>;
  prescriptionId: Scalars['UUID'];
};


export type QueryEducationMaterialArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryEducationMaterialFoldersArgs = {
  module?: InputMaybe<EducationMaterialModule>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryEducationMaterialsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  module?: InputMaybe<EducationMaterialModule>;
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryEventArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryEventsArgs = {
  approaching?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['DateTime']>;
  eventMemberId?: InputMaybe<Scalars['UUID']>;
  eventMemberIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  familyView?: InputMaybe<Scalars['Boolean']>;
  future?: InputMaybe<Scalars['Boolean']>;
  metaKey?: InputMaybe<Scalars['String']>;
  metaKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pagination?: InputMaybe<PaginationInput>;
  start?: InputMaybe<Scalars['DateTime']>;
  types?: InputMaybe<Array<InputMaybe<EventType>>>;
  userId?: InputMaybe<Scalars['UUID']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  visible?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<EventsWhereInput>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryExportLogsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: ExportLogsWhereInput;
};


export type QueryFamilyMemberArgs = {
  where?: InputMaybe<FamilyMemberWhereInput>;
};


export type QueryFamilyMemberShareListArgs = {
  childId?: InputMaybe<Scalars['UUID']>;
};


export type QueryFamilyMembersArgs = {
  pagination?: InputMaybe<PaginationInput>;
  role?: InputMaybe<FamilyMemberRole>;
};


export type QueryFamilyMembersAvailableForCaseCreateArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryFilterCaseContactsArgs = {
  caseTypeCode?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryGroupArgs = {
  id: Scalars['UUID'];
};


export type QueryGroupMembersArgs = {
  groupId: Scalars['UUID'];
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryGroupsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryHealthDataArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  groupId?: InputMaybe<Scalars['String']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pagination?: InputMaybe<PaginationInput>;
  to?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryHealthDataLastValuesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryHealthPlanArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryHealthPlanBabyPregnancyArgs = {
  patientId: Scalars['UUID'];
};


export type QueryHealthPlanUserArgs = {
  healthPlanCode?: InputMaybe<Scalars['String']>;
  healthPlanId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryHealthPlanUserItemArgs = {
  healthPlanUserId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  subtype?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryHealthPlanUserItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<HealthPlanUserItemWhereInput>;
};


export type QueryHealthPlanUsersArgs = {
  doctorId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  healthPlanCode?: InputMaybe<HealthPlanCodeEnum>;
  pagination?: InputMaybe<PaginationInput>;
  tag?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryHealthPlanWorkplaceByHealthPlanIdArgs = {
  where: HealthPlanWorkplaceWhereInput;
};


export type QueryHealthPlansArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryInsuranceCompaniesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<InsuranceCompaniesWhereInput>;
};


export type QueryInsuranceCompanyBatchesArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryInsuranceOperationArgs = {
  id: Scalars['UUID'];
};


export type QueryInsuranceOperationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: InsuranceOperationsWhereInput;
};


export type QueryInsuranceReportArgs = {
  id: Scalars['UUID'];
};


export type QueryInsuranceReportsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: InsuranceReportsWhereInput;
};


export type QueryIotsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryIplpTemplatesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: IplpTemplatesWhereInput;
};


export type QueryLaboratoriesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<LaboratoriesWhereInput>;
};


export type QueryLaboratoryArgs = {
  id: Scalars['UUID'];
};


export type QueryLaboratoryRequisitionFormArgs = {
  where: LaboratoryRequisitionFormWhereInput;
};


export type QueryLaboratoryRequisitionFormPriceArgs = {
  input: LaboratoryRequisitionFormPriceInput;
};


export type QueryLaboratoryRequisitionResultArgs = {
  where: LaboratoryRequisitionResultWhereInput;
};


export type QueryLaboratoryRequisitionResultsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: LaboratoryRequisitionResultsWhereInput;
};


export type QueryLaboratoryRequisitionTemplatesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: LaboratoryRequisitionTemplatesWhereInput;
};


export type QueryLaboratoryRequisitionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: LaboratoryRequisitionsWhereInput;
};


export type QueryLaboratoryResultArgs = {
  where: LaboratoryResultWhereInput;
};


export type QueryLaboratoryResultMiseArgs = {
  where: LaboratoryResultMiseWhereUniqueInput;
};


export type QueryLaboratoryResultsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: LaboratoryResultsWhereInput;
};


export type QueryLaboratoryResultsMiseArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: LaboratoryResultsMiseWhereInput;
};


export type QueryLaboratoryWizardsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<LaboratoryWizardsWhereInput>;
};


export type QueryLaboratoryWorkplacesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: LaboratoryWorkplacesWhereInput;
};


export type QueryMeddiAccountArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryMeddiAccountTransactionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MeddiAccountTransactionsWhereInput>;
};


export type QueryMeddiAccountsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MeddiAccountsWhereInput>;
};


export type QueryMedicalExaminationArgs = {
  where?: InputMaybe<MedicalExaminationWhereUniqueInput>;
};


export type QueryMedicalExaminationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MedicalExaminationWhereInput>;
};


export type QueryMedicalHistoryTypeArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MedicalHistoryTypeInput>;
};


export type QueryMedicalProcedureArgs = {
  where: MedicalProcedureUniqueWhereInput;
};


export type QueryMedicalProceduresArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: MedicalProceduresWhereInput;
};


export type QueryMedicalRequestFormArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryMedicalRequestFormsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryMessageArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryMessageMembersArgs = {
  messageId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMessagesArgs = {
  conversationId?: InputMaybe<Scalars['UUID']>;
  conversationType?: InputMaybe<ConversationType>;
  folder?: InputMaybe<ConversationFolderEnum>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMessagesByConversationArgs = {
  conversationType?: InputMaybe<ConversationType>;
  folder?: InputMaybe<ConversationFolderEnum>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMetaMyArgs = {
  key: Scalars['String'];
};


export type QueryMetasArgs = {
  key?: InputMaybe<Scalars['String']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  pagination?: InputMaybe<PaginationInput>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMonitoringCentreCasesArgs = {
  attendingDoctorId?: InputMaybe<Scalars['UUID']>;
  caseStatusValue?: InputMaybe<Scalars['String']>;
  caseTypeCode?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<CaseCreateDay>;
  createdAtRange?: InputMaybe<DateFilter>;
  date?: InputMaybe<Scalars['Date']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  parentCaseTypeId?: InputMaybe<Scalars['UUID']>;
  patient?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  priorityId?: InputMaybe<Scalars['UUID']>;
  solved?: InputMaybe<Scalars['Boolean']>;
  solvedAtRange?: InputMaybe<DateFilter>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryMyActiveCasesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryMyActiveSubscriptionsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<SubscriptionType>;
};


export type QueryMyEventsArgs = {
  approaching?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['DateTime']>;
  pagination?: InputMaybe<PaginationInput>;
  start?: InputMaybe<Scalars['DateTime']>;
  where?: InputMaybe<MyEventsWhereInput>;
};


export type QueryMyPhrasesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<MyPhrasesWhereInput>;
};


export type QueryMyWorkplacesArgs = {
  where?: InputMaybe<MyWorkplacesWhereInput>;
};


export type QueryNcziDoveraListArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNcziEnumItemArgs = {
  code: Scalars['String'];
  oid: Scalars['String'];
};


export type QueryNcziEnumItemByAbbrArgs = {
  abbr: Scalars['String'];
  oid: Scalars['String'];
};


export type QueryNcziEnumItemsArgs = {
  code: Array<Scalars['String']>;
  oid: Scalars['String'];
};


export type QueryNcziExtensionItemArgs = {
  code: Scalars['String'];
  oid: Scalars['String'];
};


export type QueryNcziExtensionItemByAbbrArgs = {
  abbr: Scalars['String'];
  oid: Scalars['String'];
};


export type QueryNcziListDiagnosisArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNcziListEnumItemsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  oid: Scalars['String'];
  pagination?: InputMaybe<PaginationInput>;
  version?: InputMaybe<Scalars['String']>;
  withParams?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNcziListExtensionItemsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  oid: Scalars['String'];
  pagination?: InputMaybe<PaginationInput>;
  vaccination?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNcziListMedicamentItemsArgs = {
  antibioticsChemotherapy?: InputMaybe<Scalars['Boolean']>;
  fulltext?: InputMaybe<Scalars['String']>;
  genericPrescription?: InputMaybe<Scalars['Boolean']>;
  multiplePrescription?: InputMaybe<Scalars['Boolean']>;
  opl?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  vaccination?: InputMaybe<Scalars['Boolean']>;
};


export type QueryNcziListProductItemsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNcziListQueueArgs = {
  userId: Scalars['String'];
};


export type QueryNcziMedicamentItemArgs = {
  code: Scalars['String'];
};


export type QueryNcziOupZsByCodeArgs = {
  code: Scalars['String'];
};


export type QueryNcziOupZsByPzsCodeArgs = {
  pzsCode: Scalars['String'];
};


export type QueryNcziProductItemArgs = {
  code: Scalars['String'];
};


export type QueryNotificationsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryNurseCasesArgs = {
  caseStatusValue?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  created?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  doctor?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  patient?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryOrderStatisticsArgs = {
  where?: InputMaybe<OrderStatisticsWhereInput>;
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<OrdersFilter>;
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPatientArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryPatientCalculatorsArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryPatientsArgs = {
  doctor?: InputMaybe<Scalars['String']>;
  fulltext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  name?: InputMaybe<Scalars['String']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryPlaylistArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryPlaylistsArgs = {
  code?: InputMaybe<PlaylistCode>;
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<PlaylistType>;
};


export type QueryPostsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<Scalars['String']>;
};


export type QueryPrescriptionArgs = {
  id: Scalars['UUID'];
};


export type QueryPrescriptionItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  prescriptionId?: InputMaybe<Scalars['UUID']>;
};


export type QueryPrescriptionMedicamentArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};


export type QueryPrescriptionMedicamentsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  tradeable?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPrescriptionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryProductArgs = {
  code: Scalars['String'];
};


export type QueryProductsArgs = {
  productGroup: Scalars['String'];
};


export type QueryQuestionnaireArgs = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  userSubscriptionId?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuestionnaireResultItemsArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']>;
  dateTo?: InputMaybe<Scalars['DateTime']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  questionKey?: InputMaybe<Scalars['String']>;
  questionKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionnaireCode?: InputMaybe<Scalars['String']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  questionnaireResultId?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuestionnaireResultsArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  doctorIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  excludeQuestionnaireCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  fulltext?: InputMaybe<Scalars['String']>;
  hideMemberHidden?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  module?: InputMaybe<QuestionnaireModule>;
  onlyPatient?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  questionnaire?: InputMaybe<Scalars['String']>;
  questionnaireCode?: InputMaybe<Scalars['String']>;
  questionnaireCodes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  result?: InputMaybe<QuestionnaireResultResult>;
  scheduledById?: InputMaybe<Scalars['UUID']>;
  scheduledByIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  seen?: InputMaybe<Scalars['Boolean']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryQuestionnaireScheduleArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuestionnaireSchedulesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  parentQuestionnaireCode?: InputMaybe<Scalars['String']>;
  parentQuestionnaireScheduleId?: InputMaybe<Scalars['UUID']>;
  questionnaire?: InputMaybe<Scalars['String']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryQuestionnairesArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  module?: InputMaybe<QuestionnaireModule>;
  parentQuestionnaireId?: InputMaybe<Scalars['UUID']>;
  showHidden?: InputMaybe<Scalars['Boolean']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryRatingArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryRatingsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<RatingsWhereInput>;
};


export type QueryRootWorkplaceDoctorsArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  includeNurses?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryRootWorkplacesPatientArgs = {
  originalId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QuerySearchableDoctorsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: SearchableDoctorsWhereInput;
};


export type QueryServiceSchedulesArgs = {
  from?: InputMaybe<Scalars['DateTime']>;
  includeOccurrences?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  to?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<ServiceScheduleType>;
  types?: InputMaybe<Array<InputMaybe<ServiceScheduleType>>>;
  where?: InputMaybe<ServiceSchedulesWhereInput>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QuerySubscriptionArgs = {
  id?: InputMaybe<Scalars['ID']>;
  redeemCode?: InputMaybe<Scalars['String']>;
  subscriptionOfferId?: InputMaybe<Scalars['UUID']>;
};


export type QuerySubscriptionOffersArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QuerySubscriptionPaymentMethodsArgs = {
  subscriptionOrder?: InputMaybe<PaySubscriptionInput>;
};


export type QuerySubscriptionsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTermItemArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryTermItemByValueArgs = {
  termType: Scalars['String'];
  value: Scalars['String'];
};


export type QueryTermItemsArgs = {
  filter?: InputMaybe<TermItemsFilter>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  termType?: InputMaybe<Scalars['String']>;
};


export type QueryTermsArgs = {
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryTokenArgs = {
  id?: InputMaybe<Scalars['Int']>;
};


export type QueryTokensArgs = {
  pagination?: InputMaybe<PaginationInput>;
  type?: InputMaybe<TokenType>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryToothArgs = {
  where: ToothWhereInput;
};


export type QueryToothLogsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: ToothLogWhereInput;
};


export type QueryTransmiseListArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: TransmiseListWhereInput;
};


export type QueryUserArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryUserConsentsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<UserConsentsWhereInput>;
};


export type QueryUserDekurzesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryUserFilterArgs = {
  key: Scalars['String'];
};


export type QueryUserHealthCategoriesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryUserHealthCategoryPermissionsArgs = {
  healthCategoryId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  permissionId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};


export type QueryUserMedicationLastedArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: UserMedicationLastedWhereInput;
};


export type QueryUserNotificationSettingsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: UserNotificationSettingsWhereInput;
};


export type QueryUsersArgs = {
  fulltext?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['UUID']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryWizardArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryWizardItemArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryWizardItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  wizardKey?: InputMaybe<Scalars['String']>;
};


export type QueryWizardResultArgs = {
  where?: InputMaybe<WizardResultWhereInput>;
};


export type QueryWizardResultItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WizardResultItemsWhereInput>;
};


export type QueryWizardResultsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WizardResultsWhereInput>;
};


export type QueryWizardTreeArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  key?: InputMaybe<Scalars['String']>;
};


export type QueryWizardsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryWorkplaceArgs = {
  id?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplaceAclRolesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WorkplaceAclRoleWhereInput>;
};


export type QueryWorkplaceAddressArgs = {
  where?: InputMaybe<WorkplaceAddressWhereInput>;
};


export type QueryWorkplaceCalendarArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: WorkplaceCalendarWhereInput;
};


export type QueryWorkplaceCaseTypeArgs = {
  caseTypeCode?: InputMaybe<Scalars['String']>;
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  id?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplaceCaseTypesArgs = {
  caseTypeTypes?: InputMaybe<Array<InputMaybe<CaseTypeType>>>;
  fulltext?: InputMaybe<Scalars['String']>;
  hiddenForPatient?: InputMaybe<Scalars['Boolean']>;
  onlyRootCaseTypes?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  parentCaseTypeId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplaceCaseTypesDoctorArgs = {
  caseTypeTypes?: InputMaybe<Array<InputMaybe<CaseTypeType>>>;
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WorkplaceCaseTypesDoctorWhereInput>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplaceCasesArgs = {
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  createdAt?: InputMaybe<Scalars['Date']>;
  createdFrom?: InputMaybe<Scalars['DateTime']>;
  createdTo?: InputMaybe<Scalars['DateTime']>;
  doctorNull?: InputMaybe<Scalars['Boolean']>;
  onlyVisible?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  patient?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplaceCasesArchivedArgs = {
  caseTypeId?: InputMaybe<Scalars['UUID']>;
  caseTypeIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  solvedAt?: InputMaybe<CaseSolvedMonth>;
  solvedAtRange?: InputMaybe<DateFilter>;
  take?: InputMaybe<Scalars['Int']>;
};


export type QueryWorkplaceCertificatesArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: WorkplaceCertificatesWhereInput;
};


export type QueryWorkplaceCustomCalendarArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: WorkplaceCustomCalendarWhereInput;
};


export type QueryWorkplaceDoctorsArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  doctorIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  fulltext?: InputMaybe<Scalars['String']>;
  healthPlanCode?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplaceEventsArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  pagination?: InputMaybe<PaginationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<Scalars['DateTime']>;
  take?: InputMaybe<Scalars['Int']>;
  types?: InputMaybe<Array<InputMaybe<EventType>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  where?: InputMaybe<WorkplaceEventsWhereInput>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplaceGroupsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WorkplaceGroupsWhereInput>;
};


export type QueryWorkplaceHealthPlansArgs = {
  pagination?: InputMaybe<PaginationInput>;
};


export type QueryWorkplaceInsuranceBatchsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: WorkplaceInsuranceBatchsWhereInput;
};


export type QueryWorkplaceInsuranceExportsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: WorkplaceInsuranceExportsWhereInput;
};


export type QueryWorkplaceMedicalProcedureArgs = {
  where: WorkplaceMedicalProcedureWhereUniqueInput;
};


export type QueryWorkplaceMedicalProceduresArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where: WorkplaceMedicalProceduresWhereInput;
};


export type QueryWorkplaceMemberArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplaceMembersArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  fulltext?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplacePatientDocumentationFilesArgs = {
  dateFrom?: InputMaybe<Scalars['Date']>;
  dateTo?: InputMaybe<Scalars['Date']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  grouped?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  seen?: InputMaybe<Scalars['Boolean']>;
  unprocessed?: InputMaybe<Scalars['Boolean']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplacePatientPendingArgs = {
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
};


export type QueryWorkplacePatientsArgs = {
  doctor?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  healthPlanIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  insuranceCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  insuranceCompanyName?: InputMaybe<Scalars['String']>;
  insuranceType?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<WorkplacePatientStatus>;
  where?: InputMaybe<WorkplacePatientsWhereInput>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};


export type QueryWorkplacePresetsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WorkplacePresetsWhereInput>;
};


export type QueryWorkplacesArgs = {
  approved?: InputMaybe<Scalars['Boolean']>;
  fulltext?: InputMaybe<Scalars['String']>;
  hideHidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['UUID']>;
  managed?: InputMaybe<Scalars['Boolean']>;
  pagination?: InputMaybe<PaginationInput>;
  patientId?: InputMaybe<Scalars['UUID']>;
  rootWorkplaceId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
};

export type Questionnaire = {
  __typename?: 'Questionnaire';
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  mainQuestionnaireId?: Maybe<Scalars['UUID']>;
  module?: Maybe<QuestionnaireModule>;
  partnerId?: Maybe<Scalars['Int']>;
  questionnaireItems?: Maybe<Array<Maybe<QuestionnaireItem>>>;
  settings?: Maybe<Scalars['JSONObject']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type QuestionnaireItem = {
  __typename?: 'QuestionnaireItem';
  childQuestionnaireItems?: Maybe<Array<Maybe<QuestionnaireItem>>>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key?: Maybe<Scalars['String']>;
  parentQuestionnaireItem?: Maybe<QuestionnaireItem>;
  placeholder?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireId?: Maybe<Scalars['ID']>;
  subtitle?: Maybe<Scalars['String']>;
  subtype?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<QuestionnaireItemType>;
  value?: Maybe<Scalars['String']>;
};

export enum QuestionnaireItemSubtype {
  Checkbox = 'CHECKBOX',
  CheckboxList = 'CHECKBOX_LIST',
  Radio = 'RADIO',
  RadioList = 'RADIO_LIST',
  ScaleList = 'SCALE_LIST',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

export enum QuestionnaireItemType {
  Answer = 'ANSWER',
  Item = 'ITEM',
  OnSelect = 'ON_SELECT',
  OnSubmit = 'ON_SUBMIT',
  Question = 'QUESTION',
  Rule = 'RULE'
}

export enum QuestionnaireModule {
  Diabetes = 'DIABETES',
  Kdar = 'KDAR',
  Meddibaby = 'MEDDIBABY',
  Oncology = 'ONCOLOGY',
  Palliative = 'PALLIATIVE',
  Therapist = 'THERAPIST'
}

export type QuestionnaireResult = {
  __typename?: 'QuestionnaireResult';
  createdAt?: Maybe<Scalars['DateTime']>;
  healthPlan?: Maybe<HealthPlan>;
  healthPlanId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  isHidden?: Maybe<Scalars['Boolean']>;
  isSeen?: Maybe<Scalars['Boolean']>;
  isSeenMarkedBy?: Maybe<User>;
  isSeenMarkedById?: Maybe<Scalars['UUID']>;
  questionnaire?: Maybe<Questionnaire>;
  questionnaireId?: Maybe<Scalars['UUID']>;
  questionnaireResultItems?: Maybe<Array<Maybe<QuestionnaireResultItem>>>;
  result?: Maybe<Scalars['JSONObject']>;
  scheduledBy?: Maybe<User>;
  scheduledById?: Maybe<Scalars['UUID']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type QuestionnaireResultItem = {
  __typename?: 'QuestionnaireResultItem';
  answer?: Maybe<QuestionnaireItem>;
  answerId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  question?: Maybe<QuestionnaireItem>;
  questionId?: Maybe<Scalars['UUID']>;
  questionnaireResult?: Maybe<QuestionnaireResult>;
  questionnaireResultId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
  valueJson?: Maybe<Scalars['JSONObject']>;
};

export type QuestionnaireResultItemsResult = {
  __typename?: 'QuestionnaireResultItemsResult';
  data?: Maybe<Array<Maybe<QuestionnaireResultItem>>>;
  meta?: Maybe<PageInfo>;
};

export type QuestionnaireResultMember = {
  __typename?: 'QuestionnaireResultMember';
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  questionnaireResultId?: Maybe<Scalars['UUID']>;
  seen?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum QuestionnaireResultResult {
  NoRisk = 'NO_RISK',
  NoRiskOfMentalDecompensation = 'NO_RISK_OF_MENTAL_DECOMPENSATION',
  SignificantRisk = 'SIGNIFICANT_RISK',
  SignificantRiskOfMentalDecompensation = 'SIGNIFICANT_RISK_OF_MENTAL_DECOMPENSATION',
  SignificantRiskOfSuicide = 'SIGNIFICANT_RISK_OF_SUICIDE'
}

export type QuestionnaireResultsResult = {
  __typename?: 'QuestionnaireResultsResult';
  data?: Maybe<Array<Maybe<QuestionnaireResult>>>;
  meta?: Maybe<PageInfo>;
};

export type QuestionnaireSchedule = {
  __typename?: 'QuestionnaireSchedule';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  frequencyText?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  questionnaire?: Maybe<Questionnaire>;
  questionnaireId?: Maybe<Scalars['UUID']>;
  questionnaireItem?: Maybe<QuestionnaireItem>;
  repeatHours?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export type QuestionnaireSchedulesResult = {
  __typename?: 'QuestionnaireSchedulesResult';
  data?: Maybe<Array<Maybe<QuestionnaireSchedule>>>;
  meta?: Maybe<PageInfo>;
};

export type QuestionnairesResult = {
  __typename?: 'QuestionnairesResult';
  data?: Maybe<Array<Maybe<Questionnaire>>>;
  meta?: Maybe<PageInfo>;
};

export type Rating = {
  __typename?: 'Rating';
  case?: Maybe<Case>;
  caseId?: Maybe<Scalars['UUID']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  stars?: Maybe<Scalars['Float']>;
  text?: Maybe<Scalars['String']>;
  type?: Maybe<RatingType>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum RatingType {
  Default = 'DEFAULT',
  Stars = 'STARS'
}

export type RatingsResult = {
  __typename?: 'RatingsResult';
  data?: Maybe<Array<Maybe<Rating>>>;
  meta?: Maybe<PageInfo>;
};

export type RatingsWhereInput = {
  type?: InputMaybe<RatingType>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type ReAssignCaseInput = {
  caseId: Scalars['UUID'];
  note?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceMemberId?: InputMaybe<Scalars['UUID']>;
};

export type ReactivateSubscriptionInput = {
  paymentMethod?: InputMaybe<Scalars['String']>;
  userSubscriptionId?: InputMaybe<Scalars['String']>;
};

export type ReadDashboardMessageInput = {
  messageId: Scalars['UUID'];
  userId: Scalars['UUID'];
};

export type RemoveHealthPlanWorkplaceInput = {
  healthPlanId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type RemoveUserSubscriptionMemberInput = {
  id?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  userSubscriptionId?: InputMaybe<Scalars['UUID']>;
};

export enum RepeatIntervalEnum {
  EveryDay = 'EVERY_DAY',
  EveryFortnight = 'EVERY_FORTNIGHT',
  EveryMonth = 'EVERY_MONTH',
  EveryWeek = 'EVERY_WEEK',
  EveryWorkingDay = 'EVERY_WORKING_DAY',
  SpecificDaysInWeek = 'SPECIFIC_DAYS_IN_WEEK'
}

export type RequestPaymentHealthPlanUserInput = {
  healthPlanUserId: Scalars['UUID'];
};

export type ResetToothInput = {
  medicalExaminationId: Scalars['UUID'];
};

export type SaveLaboratoryRequisitionResultInput = {
  addToPatientECard: Scalars['Boolean'];
  data: Array<LaboratoryDataInput>;
  document: LaboratoryDocumentInput;
  electronicSignature?: InputMaybe<ElectronicSignatureInput>;
  patient: LaboratoryPatientInput;
  requisitionId: Scalars['UUID'];
  userId: Scalars['UUID'];
  workplaceId: Scalars['UUID'];
};

export type SaveNcziDoveraResultInput = {
  birthNumber: Scalars['String'];
  verified: Scalars['Boolean'];
};

export type SearchableDoctorsWhereInput = {
  fulltext?: InputMaybe<Scalars['String']>;
  roleKey?: InputMaybe<Scalars['String']>;
};

export type SendLaboratoryResultMiseInput = {
  electronicSignature?: InputMaybe<ElectronicSignatureInput>;
  laboratoryResultMiseId: Scalars['UUID'];
  note: Scalars['String'];
};

export type ServiceSchedule = {
  __typename?: 'ServiceSchedule';
  dateFrom?: Maybe<Scalars['DateTime']>;
  dateTo?: Maybe<Scalars['DateTime']>;
  id: Scalars['UUID'];
  note?: Maybe<Scalars['String']>;
  serviceScheduleItems?: Maybe<Array<Maybe<ServiceScheduleItem>>>;
  type?: Maybe<ServiceScheduleType>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type ServiceScheduleItem = {
  __typename?: 'ServiceScheduleItem';
  canBook?: Maybe<Scalars['Boolean']>;
  canBookOnSite?: Maybe<Scalars['Boolean']>;
  canBookOnline?: Maybe<Scalars['Boolean']>;
  canOrderImmediate?: Maybe<Scalars['Boolean']>;
  day?: Maybe<DayShortEnum>;
  id: Scalars['UUID'];
  interval?: Maybe<Scalars['Int']>;
  occurrences?: Maybe<Array<Maybe<Scalars['DateTime']>>>;
  price?: Maybe<Price>;
  priceId?: Maybe<Scalars['UUID']>;
  repeatInterval?: Maybe<RepeatIntervalEnum>;
  repeatable?: Maybe<Scalars['Boolean']>;
  serviceSchedule?: Maybe<ServiceSchedule>;
  serviceScheduleId?: Maybe<Scalars['UUID']>;
  serviceScheduleItemCaseTypes?: Maybe<Array<Maybe<ServiceScheduleItemCaseType>>>;
  serviceScheduleItemMembers?: Maybe<Array<Maybe<ServiceScheduleItemMember>>>;
  timeFrom?: Maybe<Scalars['Time']>;
  timeTo?: Maybe<Scalars['Time']>;
};


export type ServiceScheduleItemOccurrencesArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
};

export type ServiceScheduleItemCaseType = {
  __typename?: 'ServiceScheduleItemCaseType';
  id?: Maybe<Scalars['UUID']>;
  serviceScheduleItem?: Maybe<ServiceScheduleItem>;
  serviceScheduleItemId?: Maybe<Scalars['UUID']>;
  workplaceCaseType?: Maybe<WorkplaceCaseType>;
  workplaceCaseTypeId?: Maybe<Scalars['UUID']>;
};

export type ServiceScheduleItemMember = {
  __typename?: 'ServiceScheduleItemMember';
  id?: Maybe<Scalars['UUID']>;
  serviceScheduleItem?: Maybe<ServiceScheduleItem>;
  serviceScheduleItemId?: Maybe<Scalars['UUID']>;
  workplaceMember?: Maybe<WorkplaceMember>;
  workplaceMemberId?: Maybe<Scalars['UUID']>;
};

export type ServiceScheduleItemWhereInput = {
  id: Scalars['UUID'];
};

export type ServiceScheduleItemsResult = {
  __typename?: 'ServiceScheduleItemsResult';
  data?: Maybe<Array<Maybe<ServiceScheduleItem>>>;
  meta?: Maybe<PageInfo>;
};

export enum ServiceScheduleType {
  Default = 'DEFAULT',
  OnlineConnect = 'ONLINE_CONNECT',
  OnlineOrder = 'ONLINE_ORDER',
  Shift = 'SHIFT',
  ShiftExtra = 'SHIFT_EXTRA'
}

export type ServiceScheduleWhereInput = {
  id: Scalars['UUID'];
};

export type ServiceSchedulesResult = {
  __typename?: 'ServiceSchedulesResult';
  data?: Maybe<Array<Maybe<ServiceSchedule>>>;
  meta?: Maybe<PageInfo>;
};

export type ServiceSchedulesWhereInput = {
  from?: InputMaybe<Scalars['DateTime']>;
  includeOccurrences?: InputMaybe<Scalars['Boolean']>;
  to?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<ServiceScheduleType>;
  types?: InputMaybe<Array<InputMaybe<ServiceScheduleType>>>;
  workplaceCaseTypeId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type SetUserNotificationSettingInput = {
  sending: Scalars['Boolean'];
  typeTermItemId: Scalars['UUID'];
};

export type SubmitQuestionnaireResultInput = {
  addToPatientECard?: InputMaybe<Scalars['Boolean']>;
  data?: InputMaybe<Scalars['JSONObject']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  ingestion?: InputMaybe<Scalars['JSONArray']>;
  questionnaireCode?: InputMaybe<Scalars['String']>;
  questionnaireId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
  values?: InputMaybe<Array<InputMaybe<SubmitQuestionnaireResultValueInput>>>;
};

export type SubmitQuestionnaireResultValueInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
  valueJson?: InputMaybe<Scalars['JSONObject']>;
};

export type SubmitWizardResult = {
  __typename?: 'SubmitWizardResult';
  id?: Maybe<Scalars['UUID']>;
  jobResult?: Maybe<JobResult>;
};

export type Subscription = {
  __typename?: 'Subscription';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  descriptionItems?: Maybe<Scalars['String']>;
  descriptionShort?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Scalars['String']>;
  featuredLogo?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFamily?: Maybe<Scalars['Boolean']>;
  manageable?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  nameShort?: Maybe<Scalars['String']>;
  redeemCodeRequired?: Maybe<Scalars['Boolean']>;
  subscriptionItems?: Maybe<Array<Maybe<SubscriptionItem>>>;
  subscriptionPeriods?: Maybe<Array<Maybe<SubscriptionPeriod>>>;
  theme?: Maybe<Scalars['String']>;
};

export type SubscriptionActivateByIdInput = {
  userSubscriptionId: Scalars['UUID'];
};

export type SubscriptionChangePaymentMethodInput = {
  paymentMethod: OrderPaymentMethod;
  userSubscriptionId: Scalars['UUID'];
};

export type SubscriptionGroup = {
  __typename?: 'SubscriptionGroup';
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export type SubscriptionItem = {
  __typename?: 'SubscriptionItem';
  extra?: Maybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  type: SubscriptionItemType;
};

export enum SubscriptionItemType {
  Acl = 'ACL',
  ActivateSubscriptionRedeemCode = 'ACTIVATE_SUBSCRIPTION_REDEEM_CODE',
  AddMeddiCredit = 'ADD_MEDDI_CREDIT',
  AdultCount = 'ADULT_COUNT',
  AppSettings = 'APP_SETTINGS',
  AutoSyncFamily = 'AUTO_SYNC_FAMILY',
  BioScanPlus = 'BIO_SCAN_PLUS',
  BioScanPlusToken = 'BIO_SCAN_PLUS_TOKEN',
  BioScanPlusTokenUnlimited = 'BIO_SCAN_PLUS_TOKEN_UNLIMITED',
  BioScanToken = 'BIO_SCAN_TOKEN',
  BioScanTokenRefresh = 'BIO_SCAN_TOKEN_REFRESH',
  BioScanTokenUnlimited = 'BIO_SCAN_TOKEN_UNLIMITED',
  CaseWorkplaceDoctor = 'CASE_WORKPLACE_DOCTOR',
  ChildCount = 'CHILD_COUNT',
  ConnectDoctor = 'CONNECT_DOCTOR',
  CreateCaseImmediatePay = 'CREATE_CASE_IMMEDIATE_PAY',
  CreateCaseImmediatePayToken = 'CREATE_CASE_IMMEDIATE_PAY_TOKEN',
  CreateCaseSale = 'CREATE_CASE_SALE',
  CreateCaseWizard = 'CREATE_CASE_WIZARD',
  CreateRequiredUserAction = 'CREATE_REQUIRED_USER_ACTION',
  CreateWorkplaceMember = 'CREATE_WORKPLACE_MEMBER',
  Description = 'DESCRIPTION',
  EmailVerified = 'EMAIL_VERIFIED',
  FamilyAddChild = 'FAMILY_ADD_CHILD',
  FirstMonthFree = 'FIRST_MONTH_FREE',
  HealthPlanFree = 'HEALTH_PLAN_FREE',
  ImmediatePayCustom = 'IMMEDIATE_PAY_CUSTOM',
  ImmediatePayFreeSubscription = 'IMMEDIATE_PAY_FREE_SUBSCRIPTION',
  IsFamily = 'IS_FAMILY',
  ProductBioscanToken = 'PRODUCT_BIOSCAN_TOKEN',
  ProductBioscanTokenSale = 'PRODUCT_BIOSCAN_TOKEN_SALE',
  RemoveProduct = 'REMOVE_PRODUCT',
  RemoveUserSubscriptions = 'REMOVE_USER_SUBSCRIPTIONS',
  SetPartner = 'SET_PARTNER',
  SkipCanCreateCase = 'SKIP_CAN_CREATE_CASE',
  SubscriptionAvailability = 'SUBSCRIPTION_AVAILABILITY',
  SubscriptionSale = 'SUBSCRIPTION_SALE',
  UserRelationWorkplace = 'USER_RELATION_WORKPLACE',
  WellbeingConnectDoctorToken = 'WELLBEING_CONNECT_DOCTOR_TOKEN',
  WellbeingConnectDoctorUnlimited = 'WELLBEING_CONNECT_DOCTOR_UNLIMITED'
}

export type SubscriptionOffer = {
  __typename?: 'SubscriptionOffer';
  description?: Maybe<Scalars['String']>;
  extra?: Maybe<Scalars['JSONObject']>;
  id?: Maybe<Scalars['UUID']>;
  imageUrl?: Maybe<Scalars['String']>;
  price?: Maybe<Price>;
  priceSale?: Maybe<Price>;
  priceSuffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<SubscriptionOfferType>;
};

export enum SubscriptionOfferType {
  BioScan = 'BIO_SCAN',
  Subscription = 'SUBSCRIPTION'
}

export type SubscriptionOffersResult = {
  __typename?: 'SubscriptionOffersResult';
  data?: Maybe<Array<Maybe<SubscriptionOffer>>>;
  meta?: Maybe<PageInfo>;
};

export type SubscriptionOrder = {
  __typename?: 'SubscriptionOrder';
  redirectUrl?: Maybe<Scalars['String']>;
};

export type SubscriptionPeriod = {
  __typename?: 'SubscriptionPeriod';
  discount?: Maybe<PriceDiscount>;
  id: Scalars['ID'];
  period?: Maybe<Scalars['Int']>;
  price?: Maybe<Price>;
  translations?: Maybe<Scalars['JSONObject']>;
  type: SubscriptionPeriodType;
};

export enum SubscriptionPeriodType {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Sixmonths = 'SIXMONTHS',
  Unlimited = 'UNLIMITED',
  UntilDate = 'UNTIL_DATE',
  Week = 'WEEK',
  Year = 'YEAR'
}

export type SubscriptionRedeemCode = {
  __typename?: 'SubscriptionRedeemCode';
  code?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  subscription?: Maybe<Subscription>;
  subscriptionId?: Maybe<Scalars['UUID']>;
};

export enum SubscriptionType {
  RedeemCode = 'REDEEM_CODE',
  Subscription = 'SUBSCRIPTION'
}

export type SubscriptionsResult = {
  __typename?: 'SubscriptionsResult';
  data?: Maybe<Array<Maybe<Subscription>>>;
  meta?: Maybe<PageInfo>;
};

export type SyncStatus = {
  __typename?: 'SyncStatus';
  createdAt?: Maybe<Scalars['DateTime']>;
  resourceType?: Maybe<Scalars['String']>;
  state?: Maybe<SyncStatusState>;
};

export enum SyncStatusState {
  Error = 'ERROR',
  Finished = 'FINISHED',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN'
}

export type Term = {
  __typename?: 'Term';
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  termItems?: Maybe<Array<Maybe<TermItem>>>;
  type?: Maybe<Scalars['String']>;
};

export type TermItem = {
  __typename?: 'TermItem';
  data?: Maybe<Scalars['JSONObject']>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  term?: Maybe<Term>;
  termId?: Maybe<Scalars['ID']>;
  value?: Maybe<Scalars['String']>;
  value2?: Maybe<Scalars['String']>;
  value3?: Maybe<Scalars['String']>;
};

export type TermItemsFilter = {
  value2?: InputMaybe<Scalars['String']>;
};

export type TermItemsResult = {
  __typename?: 'TermItemsResult';
  data?: Maybe<Array<Maybe<TermItem>>>;
  meta?: Maybe<PageInfo>;
};

export type TermsResult = {
  __typename?: 'TermsResult';
  data?: Maybe<Array<Maybe<Term>>>;
  meta?: Maybe<PageInfo>;
};

export enum ThemeEnum {
  Blue = 'blue',
  Bronze = 'bronze',
  Orange = 'orange'
}

export type Token = {
  __typename?: 'Token';
  createdAt?: Maybe<Scalars['DateTime']>;
  deletedAt?: Maybe<Scalars['DateTime']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<TokenType>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum TokenType {
  Api = 'API',
  EmailVerification = 'EMAIL_VERIFICATION',
  Ingestion = 'INGESTION'
}

export type TokensResult = {
  __typename?: 'TokensResult';
  data?: Maybe<Array<Maybe<Token>>>;
  meta?: Maybe<PageInfo>;
};

export type Tooth = {
  __typename?: 'Tooth';
  dentition: Dentition;
  dentitionId: Scalars['UUID'];
  endodontic?: Maybe<ToothEndodontic>;
  id: Scalars['UUID'];
  jaw: ToothJaw;
  missing: Scalars['Boolean'];
  number: Scalars['Int'];
  pathology: ToothPathology;
  periodontal: ToothPeriodontal;
  restoration?: Maybe<ToothRestoration>;
  side: ToothSide;
  state: ToothState;
  toBeExtracted: Scalars['Boolean'];
  type: ToothType;
};

export enum ToothDecayCavitation {
  Cavitation = 'CAVITATION',
  NoCavitation = 'NO_CAVITATION'
}

export enum ToothDecayLevel {
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  C4 = 'C4'
}

export enum ToothDecayPulp {
  Involved = 'INVOLVED',
  NotInvolved = 'NOT_INVOLVED'
}

export enum ToothDecayStage {
  Dentin = 'DENTIN',
  Enamel = 'ENAMEL'
}

export enum ToothDecayType {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY'
}

export enum ToothDiscolorationType {
  Gray = 'GRAY',
  Red = 'RED',
  Yellow = 'YELLOW'
}

export type ToothEndodontic = {
  __typename?: 'ToothEndodontic';
  cold?: Maybe<ToothEndodonticTest>;
  electric?: Maybe<Scalars['Int']>;
  heat?: Maybe<ToothEndodonticTest>;
  palpation?: Maybe<ToothEndodonticPain>;
  percussion?: Maybe<ToothEndodonticPain>;
};

export type ToothEndodonticInput = {
  cold?: InputMaybe<ToothEndodonticTestInput>;
  electric?: InputMaybe<Scalars['Int']>;
  heat?: InputMaybe<ToothEndodonticTestInput>;
  palpation?: InputMaybe<ToothEndodonticPain>;
  percussion?: InputMaybe<ToothEndodonticPain>;
};

export enum ToothEndodonticPain {
  NotPainful = 'NOT_PAINFUL',
  Painful = 'PAINFUL',
  Unpleasant = 'UNPLEASANT'
}

export type ToothEndodonticTest = {
  __typename?: 'ToothEndodonticTest';
  result?: Maybe<ToothEndodonticTestResult>;
  resultNotApplicable?: Maybe<ToothEndodonticTestResultNotApplicable>;
  resultPositive?: Maybe<ToothEndodonticTestResultPositive>;
};

export type ToothEndodonticTestInput = {
  result: ToothEndodonticTestResult;
  resultNotApplicable?: InputMaybe<ToothEndodonticTestResultNotApplicable>;
  resultPositive?: InputMaybe<ToothEndodonticTestResultPositive>;
};

export enum ToothEndodonticTestResult {
  Negative = 'NEGATIVE',
  NotApplicable = 'NOT_APPLICABLE',
  Positive = 'POSITIVE',
  Uncertain = 'UNCERTAIN'
}

export enum ToothEndodonticTestResultNotApplicable {
  ExistingRootCanalTreatment = 'EXISTING_ROOT_CANAL_TREATMENT',
  PreviouslyInitiatedTherapy = 'PREVIOUSLY_INITIATED_THERAPY'
}

export enum ToothEndodonticTestResultPositive {
  PainLingering = 'PAIN_LINGERING',
  PainStimulus = 'PAIN_STIMULUS',
  Unpleasant = 'UNPLEASANT',
  WithinLimits = 'WITHIN_LIMITS'
}

export enum ToothFracturePosition {
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

export enum ToothFractureType {
  Crown = 'CROWN',
  Root = 'ROOT'
}

export enum ToothFurcation {
  None = 'NONE',
  Stage_1 = 'STAGE_1',
  Stage_2 = 'STAGE_2',
  Stage_3 = 'STAGE_3'
}

export enum ToothJaw {
  Lower = 'LOWER',
  Upper = 'UPPER'
}

export enum ToothLesionType {
  Cement = 'CEMENT',
  Dentin = 'DENTIN'
}

export type ToothLog = {
  __typename?: 'ToothLog';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: User;
  createdById?: Maybe<Scalars['UUID']>;
  data?: Maybe<Scalars['JSON']>;
  id: Scalars['UUID'];
  tooth?: Maybe<Tooth>;
  toothId: Scalars['UUID'];
  type?: Maybe<Scalars['String']>;
};

export type ToothLogUniqueWhereInput = {
  id: Scalars['UUID'];
};

export type ToothLogWhereInput = {
  createdAtFrom?: InputMaybe<Scalars['DateTime']>;
  createdAtTo?: InputMaybe<Scalars['DateTime']>;
  createdById?: InputMaybe<Scalars['UUID']>;
  patientId: Scalars['UUID'];
  toothNumber?: InputMaybe<Scalars['Int']>;
};

export type ToothLogsResult = {
  __typename?: 'ToothLogsResult';
  data?: Maybe<Array<ToothLog>>;
  meta?: Maybe<PageInfo>;
};

export enum ToothMobility {
  Class_1 = 'CLASS_1',
  Class_2 = 'CLASS_2',
  Class_3 = 'CLASS_3',
  None = 'NONE'
}

export type ToothPathology = {
  __typename?: 'ToothPathology';
  apical?: Maybe<ToothPathologyApical>;
  decays?: Maybe<Array<Maybe<ToothPathologyDecay>>>;
  developmentDisorder?: Maybe<ToothPathologyDevelopmentDisorder>;
  discoloration?: Maybe<ToothPathologyDiscoloration>;
  fractures?: Maybe<Array<ToothPathologyFracture>>;
  rootDecay?: Maybe<ToothPathologyRootDecay>;
  toothWear?: Maybe<ToothPathologyToothWear>;
};

export type ToothPathologyApical = {
  __typename?: 'ToothPathologyApical';
  surfaces: Array<Maybe<ToothSurface>>;
  values: ToothPathologyApicalValues;
};

export type ToothPathologyApicalInput = {
  surfaces: Array<InputMaybe<ToothSurface>>;
  values: ToothPathologyApicalValuesInput;
};

export type ToothPathologyApicalValues = {
  __typename?: 'ToothPathologyApicalValues';
  presence?: Maybe<ToothPresence>;
  rootsAffected?: Maybe<Array<ToothRootSurface>>;
};

export type ToothPathologyApicalValuesInput = {
  presence?: InputMaybe<ToothPresence>;
  rootsAffected?: InputMaybe<Array<ToothRootSurface>>;
};

export type ToothPathologyDecay = {
  __typename?: 'ToothPathologyDecay';
  surfaces: Array<ToothSurface>;
  values: ToothPathologyDecayValues;
};

export type ToothPathologyDecayInput = {
  surfaces: Array<InputMaybe<ToothSurface>>;
  values: ToothPathologyDecayValuesInput;
};

export type ToothPathologyDecayValues = {
  __typename?: 'ToothPathologyDecayValues';
  cavitation?: Maybe<ToothDecayCavitation>;
  level?: Maybe<ToothDecayLevel>;
  pulp?: Maybe<ToothDecayPulp>;
  stage?: Maybe<ToothDecayStage>;
  type?: Maybe<ToothDecayType>;
};

export type ToothPathologyDecayValuesInput = {
  cavitation?: InputMaybe<ToothDecayCavitation>;
  level?: InputMaybe<ToothDecayLevel>;
  pulp?: InputMaybe<ToothDecayPulp>;
  stage?: InputMaybe<ToothDecayStage>;
  type: ToothDecayType;
};

export type ToothPathologyDevelopmentDisorder = {
  __typename?: 'ToothPathologyDevelopmentDisorder';
  surfaces: Array<Maybe<ToothSurface>>;
  values: ToothPathologyDevelopmentDisorderValues;
};

export type ToothPathologyDevelopmentDisorderInput = {
  surfaces: Array<InputMaybe<ToothSurface>>;
  values: ToothPathologyDevelopmentDisorderValuesInput;
};

export type ToothPathologyDevelopmentDisorderValues = {
  __typename?: 'ToothPathologyDevelopmentDisorderValues';
  presence?: Maybe<ToothPresence>;
};

export type ToothPathologyDevelopmentDisorderValuesInput = {
  presence?: InputMaybe<ToothPresence>;
};

export type ToothPathologyDiscoloration = {
  __typename?: 'ToothPathologyDiscoloration';
  surfaces: Array<Maybe<ToothSurface>>;
  values: ToothPathologyDiscolorationValues;
};

export type ToothPathologyDiscolorationInput = {
  surfaces: Array<InputMaybe<ToothSurface>>;
  values: ToothPathologyDiscolorationValuesInput;
};

export type ToothPathologyDiscolorationValues = {
  __typename?: 'ToothPathologyDiscolorationValues';
  type?: Maybe<ToothDiscolorationType>;
};

export type ToothPathologyDiscolorationValuesInput = {
  type?: InputMaybe<ToothDiscolorationType>;
};

export type ToothPathologyFracture = {
  __typename?: 'ToothPathologyFracture';
  positions: Array<ToothFracturePosition>;
  pulpInvolvement?: Maybe<ToothPresence>;
  type: ToothFractureType;
};

export type ToothPathologyFractureInput = {
  positions: Array<ToothFracturePosition>;
  pulpInvolvement?: InputMaybe<ToothPresence>;
  type: ToothFractureType;
};

export type ToothPathologyInput = {
  apical?: InputMaybe<ToothPathologyApicalInput>;
  decays?: InputMaybe<Array<InputMaybe<ToothPathologyDecayInput>>>;
  developmentDisorder?: InputMaybe<ToothPathologyDevelopmentDisorderInput>;
  discoloration?: InputMaybe<ToothPathologyDiscolorationInput>;
  fractures?: InputMaybe<Array<ToothPathologyFractureInput>>;
  rootDecay?: InputMaybe<ToothPathologyRootDecayInput>;
  toothWear?: InputMaybe<ToothPathologyToothWearInput>;
};

export type ToothPathologyRootDecay = {
  __typename?: 'ToothPathologyRootDecay';
  surfaces: Array<Maybe<ToothSurface>>;
  values: ToothPathologyRootDecayValues;
};

export type ToothPathologyRootDecayInput = {
  surfaces: Array<InputMaybe<ToothSurface>>;
  values: ToothPathologyRootDecayValuesInput;
};

export type ToothPathologyRootDecayValues = {
  __typename?: 'ToothPathologyRootDecayValues';
  lesionType?: Maybe<ToothLesionType>;
  presence?: Maybe<ToothPresence>;
};

export type ToothPathologyRootDecayValuesInput = {
  lesionType?: InputMaybe<ToothLesionType>;
  presence?: InputMaybe<ToothPresence>;
};

export type ToothPathologyToothWear = {
  __typename?: 'ToothPathologyToothWear';
  abrasion?: Maybe<ToothPathologyToothWearAbrasion>;
  erosion?: Maybe<ToothPathologyToothWearErosion>;
};

export type ToothPathologyToothWearAbrasion = {
  __typename?: 'ToothPathologyToothWearAbrasion';
  zones: Array<ToothToothWearZone>;
};

export type ToothPathologyToothWearAbrasionInput = {
  zones: Array<ToothToothWearZone>;
};

export type ToothPathologyToothWearErosion = {
  __typename?: 'ToothPathologyToothWearErosion';
  surfaces: Array<ToothSurface>;
};

export type ToothPathologyToothWearErosionInput = {
  surfaces: Array<ToothSurface>;
};

export type ToothPathologyToothWearInput = {
  abrasion?: InputMaybe<ToothPathologyToothWearAbrasionInput>;
  erosion?: InputMaybe<ToothPathologyToothWearErosionInput>;
};

export type ToothPeriodontal = {
  __typename?: 'ToothPeriodontal';
  buccal: ToothPeriodontalItem;
  distoBuccal: ToothPeriodontalItem;
  distoLingual: ToothPeriodontalItem;
  distoPalatal: ToothPeriodontalItem;
  furcation?: Maybe<ToothFurcation>;
  lingual: ToothPeriodontalItem;
  mesioBuccal: ToothPeriodontalItem;
  mesioLingual: ToothPeriodontalItem;
  mesioPalatal: ToothPeriodontalItem;
  mobility?: Maybe<ToothMobility>;
  palatal: ToothPeriodontalItem;
};

export type ToothPeriodontalInput = {
  buccal: ToothPeriodontalItemInput;
  distoBuccal: ToothPeriodontalItemInput;
  distoLingual: ToothPeriodontalItemInput;
  distoPalatal: ToothPeriodontalItemInput;
  furcation?: InputMaybe<ToothFurcation>;
  lingual: ToothPeriodontalItemInput;
  mesioBuccal: ToothPeriodontalItemInput;
  mesioLingual: ToothPeriodontalItemInput;
  mesioPalatal: ToothPeriodontalItemInput;
  mobility?: InputMaybe<ToothMobility>;
  palatal: ToothPeriodontalItemInput;
};

export type ToothPeriodontalItem = {
  __typename?: 'ToothPeriodontalItem';
  bleeding?: Maybe<Scalars['Boolean']>;
  depth?: Maybe<Scalars['Int']>;
  margin?: Maybe<Scalars['Int']>;
  plaque?: Maybe<Scalars['Boolean']>;
  pus?: Maybe<Scalars['Boolean']>;
  tartar?: Maybe<Scalars['Boolean']>;
};

export type ToothPeriodontalItemInput = {
  bleeding?: InputMaybe<Scalars['Boolean']>;
  depth?: InputMaybe<Scalars['Int']>;
  margin?: InputMaybe<Scalars['Int']>;
  plaque?: InputMaybe<Scalars['Boolean']>;
  pus?: InputMaybe<Scalars['Boolean']>;
  tartar?: InputMaybe<Scalars['Boolean']>;
};

export enum ToothPresence {
  No = 'NO',
  Yes = 'YES'
}

export type ToothRestoration = {
  __typename?: 'ToothRestoration';
  createdAt?: Maybe<Scalars['DateTime']>;
  crownBase?: Maybe<ToothRestorationCrownBase>;
  crownType?: Maybe<ToothRestorationCrownType>;
  detail?: Maybe<ToothRestorationDetail>;
  fillings?: Maybe<Array<ToothRestorationFilling>>;
  implantType?: Maybe<ToothRestorationImplantType>;
  material?: Maybe<ToothRestorationMaterial>;
  quality?: Maybe<ToothRestorationQuality>;
  surfaces?: Maybe<Array<ToothSurface>>;
  type?: Maybe<ToothRestorationType>;
};

export enum ToothRestorationCrownBase {
  Implant = 'IMPLANT',
  Natural = 'NATURAL'
}

export enum ToothRestorationCrownType {
  Abutment = 'ABUTMENT',
  Pontic = 'PONTIC',
  SingleCrown = 'SINGLE_CROWN'
}

export enum ToothRestorationDetail {
  Flush = 'FLUSH',
  Overhang = 'OVERHANG',
  Shortfall = 'SHORTFALL'
}

export type ToothRestorationFilling = {
  __typename?: 'ToothRestorationFilling';
  surfaces: Array<ToothSurface>;
  values: ToothRestorationFillingValues;
};

export type ToothRestorationFillingInput = {
  surfaces: Array<ToothSurface>;
  values: ToothRestorationFillingValuesInput;
};

export type ToothRestorationFillingValues = {
  __typename?: 'ToothRestorationFillingValues';
  detail?: Maybe<ToothRestorationDetail>;
  material?: Maybe<ToothRestorationMaterial>;
  quality?: Maybe<ToothRestorationQuality>;
};

export type ToothRestorationFillingValuesInput = {
  detail?: InputMaybe<ToothRestorationDetail>;
  material?: InputMaybe<ToothRestorationMaterial>;
  quality?: InputMaybe<ToothRestorationQuality>;
};

export enum ToothRestorationImplantType {
  BoneLevel = 'BONE_LEVEL',
  TissueLevel = 'TISSUE_LEVEL'
}

export type ToothRestorationInput = {
  crownBase?: InputMaybe<ToothRestorationCrownBase>;
  crownType?: InputMaybe<ToothRestorationCrownType>;
  detail?: InputMaybe<ToothRestorationDetail>;
  fillings?: InputMaybe<Array<ToothRestorationFillingInput>>;
  implantType?: InputMaybe<ToothRestorationImplantType>;
  material?: InputMaybe<ToothRestorationMaterial>;
  quality?: InputMaybe<ToothRestorationQuality>;
  surfaces?: InputMaybe<Array<ToothSurface>>;
  type?: InputMaybe<ToothRestorationType>;
};

export enum ToothRestorationMaterial {
  Amalgam = 'AMALGAM',
  Ceramic = 'CERAMIC',
  Composite = 'COMPOSITE',
  Gold = 'GOLD',
  NonPreciousMaterial = 'NON_PRECIOUS_MATERIAL',
  Temporary = 'TEMPORARY'
}

export enum ToothRestorationQuality {
  Insufficient = 'INSUFFICIENT',
  Sufficient = 'SUFFICIENT',
  Uncertain = 'UNCERTAIN'
}

export enum ToothRestorationType {
  Crown = 'CROWN',
  Filling = 'FILLING',
  Inlay = 'INLAY',
  Onlay = 'ONLAY',
  PartialCrown = 'PARTIAL_CROWN',
  Veneer = 'VENEER'
}

export enum ToothRootSurface {
  Buccal = 'BUCCAL',
  Distal = 'DISTAL',
  Mesial = 'MESIAL'
}

export enum ToothSide {
  Left = 'LEFT',
  Right = 'RIGHT'
}

export enum ToothState {
  Crown = 'CROWN',
  Implant = 'IMPLANT',
  Missing = 'MISSING',
  Normal = 'NORMAL',
  SingleCrown = 'SINGLE_CROWN',
  ToBeExtracted = 'TO_BE_EXTRACTED'
}

export enum ToothSurface {
  Buccal = 'BUCCAL',
  BuccalCusp = 'BUCCAL_CUSP',
  BuccalRestoration = 'BUCCAL_RESTORATION',
  BuccalSurface = 'BUCCAL_SURFACE',
  CervicalBuccal = 'CERVICAL_BUCCAL',
  CervicalLingual = 'CERVICAL_LINGUAL',
  CervicalPalatal = 'CERVICAL_PALATAL',
  Class_4Distal = 'CLASS_4_DISTAL',
  Class_4Mesial = 'CLASS_4_MESIAL',
  Crown = 'CROWN',
  Distal = 'DISTAL',
  DistoBuccalCusp = 'DISTO_BUCCAL_CUSP',
  DistoLingualCusp = 'DISTO_LINGUAL_CUSP',
  DistoPalatalCusp = 'DISTO_PALATAL_CUSP',
  Incisal = 'INCISAL',
  Lingual = 'LINGUAL',
  LingualCusp = 'LINGUAL_CUSP',
  LingualSurface = 'LINGUAL_SURFACE',
  Mesial = 'MESIAL',
  MesioBuccalCusp = 'MESIO_BUCCAL_CUSP',
  MesioLingualCusp = 'MESIO_LINGUAL_CUSP',
  MesioPalatalCusp = 'MESIO_PALATAL_CUSP',
  Occlusal = 'OCCLUSAL',
  Palatal = 'PALATAL',
  PalatalCusp = 'PALATAL_CUSP',
  PalatalSurface = 'PALATAL_SURFACE'
}

export enum ToothToothWearZone {
  Buccal = 'BUCCAL',
  Lingual = 'LINGUAL',
  Palatal = 'PALATAL'
}

export enum ToothType {
  Canine = 'CANINE',
  Incisor = 'INCISOR',
  Molar = 'MOLAR',
  Premolar = 'PREMOLAR'
}

export type ToothUpdateBulkWhereUniqueInput = {
  ids: Array<Scalars['UUID']>;
};

export type ToothWhereInput = {
  id: Scalars['UUID'];
};

export type ToothWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type TransactionOrder = {
  __typename?: 'TransactionOrder';
  id?: Maybe<Scalars['String']>;
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  issueDate?: Maybe<Scalars['DateTime']>;
  items?: Maybe<Array<Maybe<TransactionOrderItem>>>;
  paymentMethod?: Maybe<OrderPaymentMethod>;
  status?: Maybe<Scalars['String']>;
  totalPrice?: Maybe<TransactionPrice>;
};

export type TransactionOrderItem = {
  __typename?: 'TransactionOrderItem';
  price?: Maybe<TransactionPrice>;
  priceVat?: Maybe<TransactionPrice>;
  priceWithoutVat?: Maybe<TransactionPrice>;
  quantity?: Maybe<Scalars['Int']>;
  title?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type TransactionPrice = {
  __typename?: 'TransactionPrice';
  currency?: Maybe<Scalars['String']>;
  decimals?: Maybe<Scalars['Int']>;
  formattedPrice?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Decimal']>;
  priceWithVat?: Maybe<Scalars['Decimal']>;
  priceWithVatRaw?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
  vatRate?: Maybe<Scalars['Int']>;
};

export type Translation = {
  __typename?: 'Translation';
  key?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type TransmiseDocument = {
  __typename?: 'TransmiseDocument';
  date?: Maybe<Scalars['DateTime']>;
  diagnosis?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  workplace?: Maybe<Scalars['String']>;
};

export type TransmiseListResult = {
  __typename?: 'TransmiseListResult';
  data?: Maybe<Array<Maybe<TransmiseDocument>>>;
  meta?: Maybe<PageInfo>;
};

export type TransmiseListWhereInput = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
  doctorId?: InputMaybe<Scalars['UUID']>;
  userId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type UnassignLaboratoryResultMiseInput = {
  laboratoryResultMiseId: Scalars['UUID'];
};

export type UpdateCareClaimInput = {
  canDelete?: InputMaybe<Scalars['Boolean']>;
  medicalProcedureId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateDocumentationFolderInput = {
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateGroupInput = {
  name: Scalars['String'];
};

export type UpdateHealthPlanWorkplaceInput = {
  settings?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdateInsuranceReportInput = {
  birthNumber?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Int']>;
  diagnosis?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  documentId?: InputMaybe<Scalars['UUID']>;
  extra?: InputMaybe<Scalars['JSON']>;
  insuranceId?: InputMaybe<Scalars['UUID']>;
  note?: InputMaybe<Scalars['String']>;
  operationId?: InputMaybe<Scalars['UUID']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  points?: InputMaybe<Scalars['Int']>;
  reportedAt?: InputMaybe<Scalars['DateTime']>;
  state?: InputMaybe<InsuranceReportState>;
  stateError?: InputMaybe<InsuranceReportStateError>;
};

export type UpdateIplpTemplateInput = {
  dosage?: InputMaybe<Scalars['String']>;
  manual?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateIplpWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type UpdateLaboratoryRequisitionTemplate = {
  data?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateLaboratoryWorkplaceInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
};

export type UpdateMeInput = {
  address?: InputMaybe<AddressInput>;
  birthDate?: InputMaybe<Scalars['Date']>;
  birthPlace?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  emso?: InputMaybe<Scalars['String']>;
  fatherLastName?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Gender>;
  insurance?: InputMaybe<InsuranceMetaInput>;
  insuranceCompanyTermItemId?: InputMaybe<Scalars['UUID']>;
  insuranceNumber?: InputMaybe<Scalars['String']>;
  jmbg?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  motherLastName?: InputMaybe<Scalars['String']>;
  nationalityOther?: InputMaybe<Scalars['String']>;
  nationalityTermItemId?: InputMaybe<Scalars['UUID']>;
  pesel?: InputMaybe<Scalars['String']>;
  salutation?: InputMaybe<Scalars['String']>;
  salutationAfter?: InputMaybe<Scalars['String']>;
  salutationBefore?: InputMaybe<Scalars['String']>;
  taj?: InputMaybe<Scalars['String']>;
};

export type UpdateMedicalExaminationInput = {
  completedAt?: InputMaybe<Scalars['DateTime']>;
  type?: InputMaybe<MedicalExaminationType>;
};

export type UpdateMedicalHistoryTypeInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateNoteInput = {
  id: Scalars['UUID'];
  text: Scalars['String'];
};

export type UpdatePhraseInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PhraseType>;
  value?: InputMaybe<Scalars['String']>;
};

export type UpdateServiceScheduleInput = {
  dateFrom: Scalars['Date'];
  dateTo: Scalars['Date'];
};

export type UpdateServiceScheduleItemInput = {
  canBook?: InputMaybe<Scalars['Boolean']>;
  canBookOnSite?: InputMaybe<Scalars['Boolean']>;
  canBookOnline?: InputMaybe<Scalars['Boolean']>;
  canOrderImmediate?: InputMaybe<Scalars['Boolean']>;
  date?: InputMaybe<Scalars['Date']>;
  interval?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<CreatePriceInput>;
  repeatInterval?: InputMaybe<RepeatIntervalEnum>;
  repeatTo?: InputMaybe<Scalars['Date']>;
  timeFrom: Scalars['Time'];
  timeTo: Scalars['Time'];
  updateFuture: Scalars['Boolean'];
};

export type UpdateToothInput = {
  endodontic?: InputMaybe<ToothEndodonticInput>;
  medicalExaminationId: Scalars['UUID'];
  missing?: InputMaybe<Scalars['Boolean']>;
  pathology?: InputMaybe<ToothPathologyInput>;
  periodontal?: InputMaybe<ToothPeriodontalInput>;
  restoration?: InputMaybe<ToothRestorationInput>;
  toBeExtracted?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateUserConsentInput = {
  value: UserConsentValue;
};

export type UpdateUserMedicationLastedDataInput = {
  data: Scalars['JSON'];
};

export type UpdateUserMedicationLastedWhereInput = {
  id: Scalars['UUID'];
};

export type UpdateWorkplaceInput = {
  insuranceCompanies?: InputMaybe<Array<WorkplaceInsuranceCompaniesInput>>;
  name?: InputMaybe<Scalars['String']>;
  parentWorkplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateWorkplaceMedicalProcedureInput = {
  insuranceCompanyCodes?: InputMaybe<Array<Scalars['String']>>;
  points?: InputMaybe<Scalars['Int']>;
};

export type UpdateWorkplaceMemberInput = {
  id?: InputMaybe<Scalars['UUID']>;
  isSpecialist?: InputMaybe<Scalars['Boolean']>;
  memberSearchableOutside?: InputMaybe<Scalars['Boolean']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UpdateWorkplaceMembersInput = {
  workplaceMembers?: InputMaybe<Array<InputMaybe<UpdateWorkplaceMemberInput>>>;
};

export type User = {
  __typename?: 'User';
  approved?: Maybe<Scalars['Boolean']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  avatarFile?: Maybe<File>;
  avatarUrl?: Maybe<Scalars['String']>;
  badge?: Maybe<Badge>;
  bankidResult?: Maybe<Scalars['JSONObject']>;
  certificates?: Maybe<Array<Maybe<Certificate>>>;
  consentProvider?: Maybe<Scalars['Boolean']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  csszResult?: Maybe<Scalars['JSONObject']>;
  dentition?: Maybe<Dentition>;
  details?: Maybe<UserDetails>;
  email?: Maybe<Scalars['String']>;
  events?: Maybe<Array<Maybe<Event>>>;
  expiredSubscriptions?: Maybe<Array<Maybe<UserSubscription>>>;
  firstLogin?: Maybe<Scalars['Boolean']>;
  formattedGender?: Maybe<Scalars['String']>;
  formattedPhoneNumber?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasMeddi?: Maybe<Scalars['Boolean']>;
  healthCard?: Maybe<HealthCard>;
  id: Scalars['ID'];
  ingestionUrl?: Maybe<Scalars['String']>;
  insuranceCardBackThumbnailUrl?: Maybe<Scalars['String']>;
  insuranceCardBackUrl?: Maybe<Scalars['String']>;
  insuranceCardFrontThumbnailUrl?: Maybe<Scalars['String']>;
  insuranceCardFrontUrl?: Maybe<Scalars['String']>;
  invitations?: Maybe<Array<Maybe<UserInvitation>>>;
  isChild?: Maybe<Scalars['Boolean']>;
  isDoctor?: Maybe<Scalars['Boolean']>;
  isPatient?: Maybe<Scalars['Boolean']>;
  lastActivityAt?: Maybe<Scalars['DateTime']>;
  localCitizenship?: Maybe<Scalars['Boolean']>;
  medicalExaminations?: Maybe<Array<MedicalExamination>>;
  memberOf?: Maybe<Array<Maybe<Badge>>>;
  memberOfDoctor?: Maybe<Array<Maybe<Badge>>>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  metaTranslation?: Maybe<Array<Maybe<MetaTranslation>>>;
  nickname?: Maybe<Scalars['String']>;
  note?: Maybe<Scalars['String']>;
  originalId?: Maybe<Scalars['UUID']>;
  originalUpdated: Scalars['Boolean'];
  originalUser?: Maybe<User>;
  parents?: Maybe<Array<Maybe<User>>>;
  partner?: Maybe<Scalars['String']>;
  partnerIdentifier?: Maybe<Scalars['String']>;
  partnerTag?: Maybe<UserPartnerTag>;
  phoneNumber?: Maybe<Scalars['String']>;
  profile?: Maybe<Profile>;
  profileImageUrl?: Maybe<Scalars['String']>;
  rootWorkplace?: Maybe<Workplace>;
  rootWorkplaceMemberStatus?: Maybe<Scalars['String']>;
  termItems?: Maybe<Array<Maybe<TermItem>>>;
  userConsent?: Maybe<UserConsent>;
  userNumber?: Maybe<UserNumber>;
  userRating?: Maybe<UserRating>;
  userRelations?: Maybe<Array<Maybe<UserRelation>>>;
  vzpRegisteredDoctorsResult?: Maybe<Scalars['JSONObject']>;
  vzpResult?: Maybe<Scalars['JSONObject']>;
  workplace?: Maybe<Workplace>;
  workplaceMember?: Maybe<WorkplaceMember>;
  workplaceMembers?: Maybe<Array<Maybe<WorkplaceMember>>>;
  workplacePatient?: Maybe<User>;
};


export type UserEventsArgs = {
  metaKey?: InputMaybe<Scalars['String']>;
  metaKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
};


export type UserMetaArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
};


export type UserMetaTranslationArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type UserUserNumberArgs = {
  by?: InputMaybe<UserNumberBy>;
};


export type UserUserRelationsArgs = {
  type?: InputMaybe<UserRelationType>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type UserWorkplaceMemberArgs = {
  workplaceId?: InputMaybe<Scalars['UUID']>;
};


export type UserWorkplacePatientArgs = {
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UserConsent = {
  __typename?: 'UserConsent';
  canceledAt?: Maybe<Scalars['DateTime']>;
  confirmedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  documentationFile?: Maybe<DocumentationFile>;
  extra?: Maybe<Scalars['JSON']>;
  file?: Maybe<File>;
  fileId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  name: Scalars['String'];
  type: UserConsentType;
  userId: Scalars['UUID'];
  value: UserConsentValue;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export enum UserConsentType {
  InformedConsent = 'INFORMED_CONSENT'
}

export enum UserConsentValue {
  Canceled = 'CANCELED',
  Confirmed = 'CONFIRMED',
  Sent = 'SENT'
}

export type UserConsentsResult = {
  __typename?: 'UserConsentsResult';
  data?: Maybe<Array<Maybe<UserConsent>>>;
  meta?: Maybe<PageInfo>;
};

export type UserConsentsWhereInput = {
  id?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<UserConsentType>;
  userId?: InputMaybe<Scalars['UUID']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UserDekurz = {
  __typename?: 'UserDekurz';
  content?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userDekurzItems?: Maybe<Array<Maybe<UserDekurzItem>>>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type UserDekurzItem = {
  __typename?: 'UserDekurzItem';
  id: Scalars['UUID'];
  medicalReport?: Maybe<MedicalReport>;
  medicalReportId?: Maybe<Scalars['UUID']>;
  type?: Maybe<UserDekurzItemType>;
  userDekurz?: Maybe<UserDekurz>;
  userDekurzId?: Maybe<Scalars['UUID']>;
};

export enum UserDekurzItemType {
  MedicalReport = 'MEDICAL_REPORT'
}

export type UserDekurzesResult = {
  __typename?: 'UserDekurzesResult';
  data?: Maybe<Array<Maybe<UserDekurz>>>;
  meta?: Maybe<PageInfo>;
};

export type UserDetails = {
  __typename?: 'UserDetails';
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  salutationAfter?: Maybe<Scalars['String']>;
  salutationBefore?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserFilterInput = {
  data: Scalars['JSONObject'];
  key: Scalars['String'];
};

export type UserHealthCategoriesResult = {
  __typename?: 'UserHealthCategoriesResult';
  data?: Maybe<Array<Maybe<UserHealthCategory>>>;
  meta?: Maybe<PageInfo>;
};

export type UserHealthCategory = {
  __typename?: 'UserHealthCategory';
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type UserHealthCategoryPermission = {
  __typename?: 'UserHealthCategoryPermission';
  healthCategory?: Maybe<UserHealthCategory>;
  healthCategoryId?: Maybe<Scalars['UUID']>;
  id?: Maybe<Scalars['UUID']>;
  permission?: Maybe<TermItem>;
  permissionId?: Maybe<Scalars['UUID']>;
};

export type UserHealthCategoryPermissionInput = {
  healthCategoryId?: InputMaybe<Scalars['UUID']>;
  permissionId?: InputMaybe<Scalars['UUID']>;
  userId?: InputMaybe<Scalars['UUID']>;
};

export type UserHealthCategoryPermissionsResult = {
  __typename?: 'UserHealthCategoryPermissionsResult';
  data?: Maybe<Array<Maybe<UserHealthCategoryPermission>>>;
  meta?: Maybe<PageInfo>;
};

export type UserInvitation = {
  __typename?: 'UserInvitation';
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  declinedAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<UserInvitationStatus>;
  used?: Maybe<Scalars['Boolean']>;
};

export enum UserInvitationStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type UserMedicationLasted = {
  __typename?: 'UserMedicationLasted';
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  data: Scalars['JSON'];
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userId: Scalars['UUID'];
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type UserMedicationLastedResult = {
  __typename?: 'UserMedicationLastedResult';
  data: Array<UserMedicationLasted>;
  meta?: Maybe<PageInfo>;
};

export type UserMedicationLastedWhereInput = {
  userId: Scalars['UUID'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type UserMetaTranslationInput = {
  key?: InputMaybe<Scalars['String']>;
  language?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['UUID']>;
  value?: InputMaybe<Scalars['String']>;
};

export type UserNotice = {
  __typename?: 'UserNotice';
  activeCasesCount?: Maybe<Scalars['Int']>;
  futureEventsCount?: Maybe<Scalars['Int']>;
  openQuestionnairesCount?: Maybe<Scalars['Int']>;
  unreadCaseEntries?: Maybe<Scalars['Int']>;
  unreadEducationMaterialsCount?: Maybe<Scalars['Int']>;
  unreadNotifications?: Maybe<Scalars['Int']>;
  unreadPrescriptions?: Maybe<Scalars['Int']>;
};

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  sending: Scalars['Boolean'];
  typeTermItem?: Maybe<TermItem>;
  typeTermItemId: Scalars['UUID'];
  user?: Maybe<User>;
  userId: Scalars['UUID'];
};

export type UserNotificationSettingsResult = {
  __typename?: 'UserNotificationSettingsResult';
  data?: Maybe<Array<Maybe<UserNotificationSetting>>>;
  meta?: Maybe<PageInfo>;
};

export type UserNotificationSettingsWhereInput = {
  userId?: InputMaybe<Scalars['UUID']>;
};

export type UserNumber = {
  __typename?: 'UserNumber';
  birthNumber?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  partnerId?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['UUID']>;
};

export enum UserNumberBy {
  BirthNumber = 'BIRTH_NUMBER',
  Number = 'NUMBER'
}

export type UserPartnerTag = {
  __typename?: 'UserPartnerTag';
  title?: Maybe<Scalars['String']>;
  tooltip?: Maybe<Scalars['String']>;
};

export type UserRating = {
  __typename?: 'UserRating';
  avgStar?: Maybe<Scalars['Float']>;
};

export type UserRelation = {
  __typename?: 'UserRelation';
  id?: Maybe<Scalars['Int']>;
  relationUser?: Maybe<User>;
  relationUserId?: Maybe<Scalars['UUID']>;
  type?: Maybe<Scalars['Int']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export enum UserRelationType {
  PatientDoctor = 'PATIENT_DOCTOR'
}

export type UserSubscription = {
  __typename?: 'UserSubscription';
  activeFrom: Scalars['DateTime'];
  activeTo?: Maybe<Scalars['DateTime']>;
  availability?: Maybe<UserSubscriptionAvailability>;
  canAddMember?: Maybe<Scalars['Boolean']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  isOwner?: Maybe<Scalars['Boolean']>;
  members?: Maybe<Array<Maybe<UserSubscriptionMember>>>;
  price?: Maybe<Price>;
  redeemCode?: Maybe<Scalars['String']>;
  subscription?: Maybe<Subscription>;
  subscriptionPeriod?: Maybe<SubscriptionPeriod>;
};

export type UserSubscriptionAvailability = {
  __typename?: 'UserSubscriptionAvailability';
  addAdultMember?: Maybe<Scalars['Boolean']>;
  addChildMember?: Maybe<Scalars['Boolean']>;
  addMember?: Maybe<Scalars['Boolean']>;
  canCreateAdultFamilyMember?: Maybe<Scalars['Boolean']>;
  canCreateChildFamilyMember?: Maybe<Scalars['Boolean']>;
  canCreateFamilyMember?: Maybe<Scalars['Boolean']>;
  canUpdatePaymentMethod?: Maybe<Scalars['Boolean']>;
  manage?: Maybe<Scalars['Boolean']>;
};

export type UserSubscriptionCancelInput = {
  id: Scalars['UUID'];
};

export type UserSubscriptionMember = {
  __typename?: 'UserSubscriptionMember';
  id: Scalars['ID'];
  isOwner?: Maybe<Scalars['Boolean']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['UUID']>;
  userSubscription?: Maybe<UserSubscription>;
  userSubscriptionId?: Maybe<Scalars['UUID']>;
};

export type UserSubscriptionsResult = {
  __typename?: 'UserSubscriptionsResult';
  data?: Maybe<Array<Maybe<UserSubscription>>>;
  meta?: Maybe<PageInfo>;
};

export type UsersResult = {
  __typename?: 'UsersResult';
  data?: Maybe<Array<Maybe<User>>>;
  meta?: Maybe<PageInfo>;
};

export type Wizard = {
  __typename?: 'Wizard';
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  settings?: Maybe<Scalars['JSONObject']>;
  wizardItems?: Maybe<Array<Maybe<WizardItem>>>;
};

export type WizardItem = {
  __typename?: 'WizardItem';
  childWizardItems?: Maybe<Array<Maybe<WizardItem>>>;
  id: Scalars['UUID'];
  key?: Maybe<Scalars['String']>;
  parentWizardItem?: Maybe<WizardItem>;
  parentWizardItemId?: Maybe<Scalars['UUID']>;
  rank?: Maybe<Scalars['Int']>;
  settings?: Maybe<Scalars['JSONObject']>;
  wizard?: Maybe<Wizard>;
  wizardId?: Maybe<Scalars['UUID']>;
};

export type WizardItemsResult = {
  __typename?: 'WizardItemsResult';
  data?: Maybe<Array<Maybe<WizardItem>>>;
  meta?: Maybe<PageInfo>;
};

export type WizardResult = {
  __typename?: 'WizardResult';
  createdAt: Scalars['DateTime'];
  hidden: Scalars['Boolean'];
  id: Scalars['UUID'];
  user?: Maybe<User>;
  userId: Scalars['UUID'];
  wizard?: Maybe<Wizard>;
  wizardId: Scalars['UUID'];
  wizardResultItems: Array<WizardResultItem>;
  workplace?: Maybe<Workplace>;
  workplaceId?: Maybe<Scalars['UUID']>;
};


export type WizardResultWizardResultItemsArgs = {
  pagination?: InputMaybe<PaginationInput>;
  where?: InputMaybe<WizardResultItemsWhereInput>;
};

export type WizardResultInput = {
  addToPatientECard?: InputMaybe<Scalars['Boolean']>;
  caseId?: InputMaybe<Scalars['UUID']>;
  electronicSignature?: InputMaybe<ElectronicSignatureInput>;
  items?: InputMaybe<Array<InputMaybe<WizardResultItemInput>>>;
  userId: Scalars['UUID'];
  wizardId?: InputMaybe<Scalars['UUID']>;
  wizardKey?: InputMaybe<Scalars['String']>;
};

export type WizardResultItem = {
  __typename?: 'WizardResultItem';
  createdAt: Scalars['DateTime'];
  formattedValue?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  key: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['JSONObject']>;
  wizardResult: WizardResult;
  wizardResultId: Scalars['UUID'];
};

export type WizardResultItemInput = {
  data?: InputMaybe<Scalars['JSONObject']>;
  wizardItemId: Scalars['UUID'];
};

export type WizardResultItemsResult = {
  __typename?: 'WizardResultItemsResult';
  data?: Maybe<Array<Maybe<WizardResultItem>>>;
  meta?: Maybe<PageInfo>;
};

export type WizardResultItemsWhereInput = {
  showSystemKeys?: InputMaybe<Scalars['Boolean']>;
  userId?: InputMaybe<Scalars['UUID']>;
  wizardKey?: InputMaybe<Scalars['String']>;
  wizardResultId?: InputMaybe<Scalars['UUID']>;
};

export type WizardResultWhereInput = {
  id: Scalars['UUID'];
};

export type WizardResultsResult = {
  __typename?: 'WizardResultsResult';
  data?: Maybe<Array<Maybe<WizardResult>>>;
  meta?: Maybe<PageInfo>;
  settings?: Maybe<Scalars['JSONObject']>;
};

export type WizardResultsWhereInput = {
  userId?: InputMaybe<Scalars['UUID']>;
  wizardId?: InputMaybe<Scalars['UUID']>;
  wizardKey?: InputMaybe<Scalars['String']>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type WizardsResult = {
  __typename?: 'WizardsResult';
  data?: Maybe<Array<Maybe<Wizard>>>;
  meta?: Maybe<PageInfo>;
};

export type Workplace = {
  __typename?: 'Workplace';
  address?: Maybe<Address>;
  approved?: Maybe<Scalars['Boolean']>;
  billingAddress?: Maybe<Address>;
  calendarEmailNotification?: Maybe<Scalars['Boolean']>;
  caseDoctorDescription?: Maybe<Scalars['String']>;
  codeName?: Maybe<Scalars['String']>;
  createCaseTarget?: Maybe<CreateCaseTarget>;
  defaultDoctor?: Maybe<User>;
  defaultDoctorId?: Maybe<Scalars['UUID']>;
  defaultInvitation?: Maybe<Scalars['Boolean']>;
  doctorDisplayName?: Maybe<Scalars['String']>;
  firstSetup?: Maybe<Scalars['Boolean']>;
  fullName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  internalName?: Maybe<Scalars['String']>;
  invitationCode?: Maybe<Scalars['String']>;
  letterHeadPDF?: Maybe<File>;
  letterHeadPDFUrl?: Maybe<Scalars['String']>;
  logo?: Maybe<File>;
  logoUrl?: Maybe<Scalars['String']>;
  memberSearchableOutside?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  metaSuklCode?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onlineOrderTarget?: Maybe<OnlineOrderTarget>;
  parentWorkplace?: Maybe<Workplace>;
  parentWorkplaceId?: Maybe<Scalars['UUID']>;
  partnerId?: Maybe<Scalars['String']>;
  patientDisplayName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  privateAmbulance?: Maybe<Scalars['Boolean']>;
  rootBilling?: Maybe<Scalars['Boolean']>;
  rootPatient?: Maybe<Scalars['Boolean']>;
  rootWorkplace?: Maybe<Workplace>;
  rootWorkplaceId?: Maybe<Scalars['UUID']>;
  termItems?: Maybe<Array<Maybe<TermItem>>>;
  type?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  workplaceMembers?: Maybe<Array<Maybe<WorkplaceMember>>>;
  workplaceSearchableOutside?: Maybe<Scalars['Boolean']>;
};


export type WorkplaceMetaArgs = {
  key?: InputMaybe<Scalars['String']>;
  strict?: InputMaybe<Scalars['Boolean']>;
};

export type WorkplaceAddressWhereInput = {
  type: AddressType;
  workplaceId: Scalars['UUID'];
};

export type WorkplaceCalendarWhereInput = {
  type?: InputMaybe<CalendarType>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type WorkplaceCaseType = {
  __typename?: 'WorkplaceCaseType';
  canSearchDoctor?: Maybe<Scalars['Boolean']>;
  canSelectTransport?: Maybe<Scalars['Boolean']>;
  canSendToAmbulance?: Maybe<Scalars['Boolean']>;
  caseType?: Maybe<CaseType>;
  caseTypeId?: Maybe<Scalars['UUID']>;
  id: Scalars['UUID'];
  labelTranslations?: Maybe<Array<Maybe<Translation>>>;
  workplace?: Maybe<Workplace>;
  workplaceDefaultCaseType?: Maybe<Scalars['Boolean']>;
  workplaceId?: Maybe<Scalars['UUID']>;
};

export type WorkplaceCaseTypesDoctorWhereInput = {
  bookable?: InputMaybe<Scalars['Boolean']>;
  caseTypeTypes?: InputMaybe<Array<InputMaybe<CaseTypeType>>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type WorkplaceCaseTypesResult = {
  __typename?: 'WorkplaceCaseTypesResult';
  data?: Maybe<Array<Maybe<WorkplaceCaseType>>>;
  meta?: Maybe<PageInfo>;
};

export type WorkplaceCertificate = {
  __typename?: 'WorkplaceCertificate';
  certificate?: Maybe<Certificate>;
  description?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  type: WorkplaceCertificateType;
};

export enum WorkplaceCertificateType {
  Commercial = 'COMMERCIAL',
  P1WorkplaceTls = 'P1_WORKPLACE_TLS',
  P1WorkplaceWss = 'P1_WORKPLACE_WSS',
  Sukl = 'SUKL'
}

export type WorkplaceCertificatesResult = {
  __typename?: 'WorkplaceCertificatesResult';
  data?: Maybe<Array<Maybe<WorkplaceCertificate>>>;
  meta?: Maybe<PageInfo>;
};

export type WorkplaceCertificatesWhereInput = {
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type WorkplaceCustomCalendarWhereInput = {
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type WorkplaceEventsWhereInput = {
  calendarIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  cancelledEvent?: InputMaybe<Scalars['Boolean']>;
  cancelledEventByDoctor?: InputMaybe<Scalars['Boolean']>;
  cancelledEventByPatient?: InputMaybe<Scalars['Boolean']>;
  end?: InputMaybe<Scalars['DateTime']>;
  fulltext?: InputMaybe<Scalars['String']>;
  future?: InputMaybe<Scalars['Boolean']>;
  start?: InputMaybe<Scalars['DateTime']>;
  types?: InputMaybe<Array<InputMaybe<EventType>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type WorkplaceGroupsWhereInput = {
  fulltext?: InputMaybe<Scalars['String']>;
};

export type WorkplaceInsuranceBatchsWhereInput = {
  exportFileId?: InputMaybe<Scalars['UUID']>;
  periodMonth?: InputMaybe<Scalars['Int']>;
  periodYear?: InputMaybe<Scalars['Int']>;
  workplaceId: Scalars['UUID'];
};

export type WorkplaceInsuranceCompaniesInput = {
  code: Scalars['String'];
  name: Scalars['String'];
  numberCode: Scalars['String'];
};

export type WorkplaceInsuranceExportsWhereInput = {
  periodMonth?: InputMaybe<Scalars['Int']>;
  periodYear?: InputMaybe<Scalars['Int']>;
  workplaceId: Scalars['UUID'];
};

export type WorkplaceMedicalProcedure = {
  __typename?: 'WorkplaceMedicalProcedure';
  createdAt: Scalars['DateTime'];
  id: Scalars['UUID'];
  insuranceCompanyCodes?: Maybe<Array<Scalars['String']>>;
  medicalProcedure: MedicalProcedure;
  medicalProcedureId: Scalars['UUID'];
  points?: Maybe<Scalars['Int']>;
  workplace: Workplace;
  workplaceId: Scalars['UUID'];
};

export type WorkplaceMedicalProcedureResult = {
  __typename?: 'WorkplaceMedicalProcedureResult';
  data?: Maybe<Array<WorkplaceMedicalProcedure>>;
  meta?: Maybe<PageInfo>;
};

export type WorkplaceMedicalProcedureWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type WorkplaceMedicalProceduresWhereInput = {
  fulltext?: InputMaybe<Scalars['String']>;
  medicalProcedureIds?: InputMaybe<Array<Scalars['UUID']>>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
};

export type WorkplaceMember = {
  __typename?: 'WorkplaceMember';
  archivedAt?: Maybe<Scalars['DateTime']>;
  archivedBy?: Maybe<User>;
  archivedById?: Maybe<Scalars['UUID']>;
  archivedReason?: Maybe<TermItem>;
  canCreateCase?: Maybe<Scalars['Boolean']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['UUID']>;
  dateOfDeath?: Maybe<Scalars['Date']>;
  hasShiftNow?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isSpecialist?: Maybe<Scalars['Boolean']>;
  memberSearchableOutside?: Maybe<Scalars['Boolean']>;
  meta?: Maybe<Array<Maybe<Meta>>>;
  role?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  user: User;
  userId: Scalars['ID'];
  userRelation?: Maybe<UserRelation>;
  workplace: Workplace;
  workplaceId: Scalars['ID'];
  workplaceMemberRoles?: Maybe<Array<Maybe<WorkplaceMemberRole>>>;
};


export type WorkplaceMemberMetaArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  useOriginalId?: InputMaybe<Scalars['Boolean']>;
};


export type WorkplaceMemberUserRelationArgs = {
  type?: InputMaybe<UserRelationType>;
};

export type WorkplaceMemberRole = {
  __typename?: 'WorkplaceMemberRole';
  id: Scalars['ID'];
  role?: Maybe<AclRole>;
  roleId: Scalars['ID'];
  workplaceMember?: Maybe<WorkplaceMember>;
  workplaceMemberId: Scalars['ID'];
};

export type WorkplaceMembersResult = {
  __typename?: 'WorkplaceMembersResult';
  data?: Maybe<Array<Maybe<WorkplaceMember>>>;
  meta?: Maybe<PageInfo>;
};

export enum WorkplacePatientStatus {
  Accepted = 'ACCEPTED',
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  ArchivedByPatient = 'ARCHIVED_BY_PATIENT',
  ArchivedByWorkplace = 'ARCHIVED_BY_WORKPLACE',
  Declined = 'DECLINED',
  HealthPlanActive = 'HEALTH_PLAN_ACTIVE',
  HealthPlanCreated = 'HEALTH_PLAN_CREATED',
  HealthPlanNotPaid = 'HEALTH_PLAN_NOT_PAID',
  Pending = 'PENDING',
  Virtual = 'VIRTUAL'
}

export type WorkplacePatientsWhereInput = {
  doctor?: InputMaybe<Scalars['String']>;
  doctorId?: InputMaybe<Scalars['UUID']>;
  fulltext?: InputMaybe<Scalars['String']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  healthPlanIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  insuranceCompanyIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  insuranceCompanyName?: InputMaybe<Scalars['String']>;
  insuranceType?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  patientIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
  status?: InputMaybe<WorkplacePatientStatus>;
  workplaceId?: InputMaybe<Scalars['UUID']>;
  workplaceIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>>>;
};

export type WorkplacePreset = {
  __typename?: 'WorkplacePreset';
  id?: Maybe<Scalars['UUID']>;
  memberType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum WorkplacePresetMemberType {
  Child = 'CHILD',
  Patient = 'PATIENT'
}

export enum WorkplacePresetType {
  Pediatr = 'PEDIATR',
  Praktik = 'PRAKTIK',
  Terapeut = 'TERAPEUT',
  Zubar = 'ZUBAR'
}

export type WorkplacePresetsResult = {
  __typename?: 'WorkplacePresetsResult';
  data: Array<Maybe<WorkplacePreset>>;
  meta: PageInfo;
};

export type WorkplacePresetsWhereInput = {
  name?: InputMaybe<Scalars['String']>;
};

export enum WorkplaceType {
  Main = 'MAIN',
  Normal = 'NORMAL'
}

export type WorkplaceWhereUniqueInput = {
  id: Scalars['UUID'];
};

export type WorkplacesResult = {
  __typename?: 'WorkplacesResult';
  data: Array<Workplace>;
  meta?: Maybe<PageInfo>;
};

export type WorkplaceAclRoleWhereInput = {
  excludeRoleKeys?: InputMaybe<Array<InputMaybe<AclRoleKey>>>;
};

export type AvailableDoctorsQueryVariables = Exact<{
  pattern: Scalars['String'];
  nurse: Scalars['Boolean'];
  workplaceId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type AvailableDoctorsQuery = { __typename?: 'Query', availableDoctors?: { __typename?: 'AvailableDoctorsResult', meta?: { __typename?: 'PageInfo', page?: number, totalPages?: number, hasNextPage?: boolean }, data?: Array<{ __typename?: 'AvailableDoctor', id: any, salutationBefore?: string, firstName?: string, lastName?: string, salutationAfter?: string, city?: string, clkId?: string }> } };

export type TermItemsQueryVariables = Exact<{
  termType?: InputMaybe<Scalars['String']>;
  fullText?: InputMaybe<Scalars['String']>;
  filter?: InputMaybe<TermItemsFilter>;
  take?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type TermItemsQuery = { __typename?: 'Query', termItems?: { __typename?: 'TermItemsResult', data?: Array<{ __typename?: 'TermItem', id: string, termId?: string, name?: string, value?: string, value2?: string, value3?: string, data?: any }> } };

export type FilterCaseContactsQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  caseTypeCode?: InputMaybe<Scalars['String']>;
  roleKeys?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type FilterCaseContactsQuery = { __typename?: 'Query', filterCaseContacts?: { __typename?: 'CaseContactsResult', meta?: { __typename?: 'PageInfo', page?: number, totalPages?: number }, data?: Array<{ __typename?: 'CaseContact', userId?: string, workplaceMemberId?: string, workplaceId?: string, textRow1?: string, textRow2?: string, textRow3?: string, type?: CaseContactType, iconUrl?: string, workplaceMemberUserRelation?: { __typename?: 'UserRelation', id?: number, userId?: any, user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string } } } }> } };

export type CaseCreateUsersQueryVariables = Exact<{
  userIds: Array<Scalars['UUID']> | Scalars['UUID'];
}>;


export type CaseCreateUsersQuery = { __typename?: 'Query', users?: { __typename?: 'UsersResult', data?: Array<{ __typename?: 'User', id: string, profileImageUrl?: string, isChild?: boolean, profile?: { __typename?: 'Profile', firstName?: string, lastName?: string, fullName?: string } }> } };

export type FamilyMembersAvailableForCaseCreateQueryVariables = Exact<{ [key: string]: never; }>;


export type FamilyMembersAvailableForCaseCreateQuery = { __typename?: 'Query', familyMembersAvailableForCaseCreate?: { __typename?: 'UsersResult', data?: Array<{ __typename?: 'User', id: string, profileImageUrl?: string, isChild?: boolean, profile?: { __typename?: 'Profile', firstName?: string, lastName?: string, fullName?: string } }> } };

export type DashboardMessagesQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardMessagesQuery = { __typename?: 'Query', dashboardMessages?: Array<{ __typename?: 'Message', id: any, content?: any, type?: string, sender?: { __typename?: 'MessageMember', user?: { __typename?: 'User', profileImageUrl?: string, profile?: { __typename?: 'Profile', fullName?: string } } } }> };

export type ReadDashboardMessageMutationVariables = Exact<{
  input?: InputMaybe<ReadDashboardMessageInput>;
}>;


export type ReadDashboardMessageMutation = { __typename?: 'Mutation', readDashboardMessage?: { __typename?: 'Message', id: any } };

export type DocumentationFilesQueryVariables = Exact<{
  fileIds?: InputMaybe<Array<InputMaybe<Scalars['UUID']>> | InputMaybe<Scalars['UUID']>>;
  userId?: InputMaybe<Scalars['UUID']>;
}>;


export type DocumentationFilesQuery = { __typename?: 'Query', documentationFiles?: { __typename?: 'DocumentationFilesResult', meta?: { __typename?: 'PageInfo', page?: number, totalPages?: number }, data: Array<{ __typename?: 'DocumentationFile', id: any, name?: string, extension?: string, displayName?: string, folderId?: any, hasThumb?: boolean, userId?: any, thumbUrl?: string, avResult?: string, createdAt?: any, fileGroupId?: string, groupFilesCount?: number, file?: { __typename?: 'File', id: any, name?: string, extension?: string }, createdBy?: { __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string } }, workplace?: { __typename?: 'Workplace', id: string, name?: string }, fileTransfers?: { __typename?: 'Meta', value?: any }, groupFiles?: Array<{ __typename?: 'DocumentationFile', id: any, name?: string, displayName?: string, createdAt?: any, thumbUrl?: string, userId?: any, folderId?: any, avResult?: string, file?: { __typename?: 'File', id: any, name?: string, extension?: string } }> }> } };

export type CreateDrMaxPrescriptionReservationMutationVariables = Exact<{
  input?: InputMaybe<CreateDrMaxPrescriptionReservationInput>;
}>;


export type CreateDrMaxPrescriptionReservationMutation = { __typename?: 'Mutation', createDrMaxPrescriptionReservation?: { __typename?: 'DrMaxPrescriptionReservation', incrementId?: string } };

export type GetDrMaxPickupPlacesQueryVariables = Exact<{
  prescriptionId?: InputMaybe<Scalars['UUID']>;
  search?: InputMaybe<Scalars['String']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetDrMaxPickupPlacesQuery = { __typename?: 'Query', drmaxPickupPlaces?: { __typename?: 'DrMaxPickupPlacesResult', meta?: { __typename?: 'PageInfo', count?: number, page?: number, limit?: number, totalPages?: number }, data?: Array<{ __typename?: 'DrMaxPickupPlace', id?: any, name?: string, isOpen?: boolean, distanceFormatted?: string, productsInStock?: Array<{ __typename?: 'DrMaxProductsInStock', name?: string, inStock?: boolean }>, openingHours?: Array<{ __typename?: 'DrMaxOpeningHourItem', date?: any, open?: boolean, nonstop?: boolean, hours?: Array<{ __typename?: 'DrMaxOpeningHour', to?: any, from?: any, note?: string, open?: boolean }> }> }> } };

export type GetDrMaxPrescriptionMedicamentsQueryVariables = Exact<{
  prescriptionId: Scalars['UUID'];
  drmaxPickupPlaceId?: InputMaybe<Scalars['UUID']>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type GetDrMaxPrescriptionMedicamentsQuery = { __typename?: 'Query', drmaxPrescriptionMedicaments?: { __typename?: 'DrMaxPrescriptionMedicamentsResult', meta?: { __typename?: 'PageInfo', count?: number, page?: number, limit?: number, totalPages?: number }, data?: Array<{ __typename?: 'DrMaxPrescriptionMedicament', name?: string, formattedApproximatePrice?: string, inStock?: boolean }> } };

export type GetPrescriptionQueryVariables = Exact<{
  prescriptionId: Scalars['UUID'];
}>;


export type GetPrescriptionQuery = { __typename?: 'Query', prescription?: { __typename?: 'Prescription', drMaxPickupPlace?: { __typename?: 'DrMaxPickupPlace', openingHours?: Array<{ __typename?: 'DrMaxOpeningHourItem', date?: any, open?: boolean, nonstop?: boolean, hours?: Array<{ __typename?: 'DrMaxOpeningHour', to?: any, from?: any, note?: string, open?: boolean }> }> } } };

export type FamilyMemberRelationMutationVariables = Exact<{
  input?: InputMaybe<FamilyMemberRelationInput>;
}>;


export type FamilyMemberRelationMutation = { __typename?: 'Mutation', familyMemberRelation?: { __typename?: 'FamilyMember', userId: any } };

export type GetFamilyMemberShareListQueryVariables = Exact<{
  childId: Scalars['UUID'];
}>;


export type GetFamilyMemberShareListQuery = { __typename?: 'Query', familyMemberShareList?: { __typename?: 'FamilyMembersResult', meta?: { __typename?: 'PageInfo', count?: number }, data?: Array<{ __typename?: 'FamilyMember', userId: any, role: FamilyMemberRole, user: { __typename?: 'User', profileImageUrl?: string, profile?: { __typename?: 'Profile', fullName?: string } } }> } };

export type GetFamilyMembersQueryVariables = Exact<{
  pagination?: InputMaybe<PaginationInput>;
  role?: InputMaybe<FamilyMemberRole>;
}>;


export type GetFamilyMembersQuery = { __typename?: 'Query', familyMembers?: { __typename?: 'FamilyMembersResult', data?: Array<{ __typename?: 'FamilyMember', userId: any, role: FamilyMemberRole, user: { __typename?: 'User', profileImageUrl?: string, profile?: { __typename?: 'Profile', fullName?: string } } }> } };

export type FamilyMemberUserDataQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type FamilyMemberUserDataQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, isPatient?: boolean, profile?: { __typename?: 'Profile', fullName?: string, birthDate?: string, formattedBirthNumber?: string, address?: { __typename?: 'Address', formattedFullAddress?: string }, insuranceCompanyTermItem?: { __typename?: 'TermItem', value?: string, value2?: string } }, meta?: Array<{ __typename?: 'Meta', key?: string, value?: any }> } };

export type UpdateUserConsentMutationVariables = Exact<{
  where?: InputMaybe<UserConsentsWhereInput>;
  data?: InputMaybe<UpdateUserConsentInput>;
}>;


export type UpdateUserConsentMutation = { __typename?: 'Mutation', updateUserConsent?: { __typename?: 'UserConsent', id: any } };

export type UserConsentsQueryVariables = Exact<{
  where?: InputMaybe<UserConsentsWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type UserConsentsQuery = { __typename?: 'Query', userConsents?: { __typename?: 'UserConsentsResult', meta?: { __typename?: 'PageInfo', page?: number, totalPages?: number }, data?: Array<{ __typename?: 'UserConsent', id: any, type: UserConsentType, userId: any, name: string, createdAt: any, confirmedAt?: any, canceledAt?: any, value: UserConsentValue, workplace?: { __typename?: 'Workplace', name?: string, address?: { __typename?: 'Address', fullAddress?: string } }, createdBy?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string } }, documentationFile?: { __typename?: 'DocumentationFile', id: any, userId?: any, folderId?: any, name?: string, file?: { __typename?: 'File', id: any, extension?: string } } }> } };

export type MeasurementHistoryQueryVariables = Exact<{
  where?: InputMaybe<WizardResultsWhereInput>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type MeasurementHistoryQuery = { __typename?: 'Query', wizardResults?: { __typename?: 'WizardResultsResult', settings?: any, meta?: { __typename?: 'PageInfo', page?: number, totalPages?: number }, data?: Array<{ __typename?: 'WizardResult', id: any, createdAt: any, wizardResultItems: Array<{ __typename?: 'WizardResultItem', id: any, key: string, value?: any, formattedValue?: string, label?: string }> }> } };

export type RemoveMeasurementHistoryItemMutationVariables = Exact<{
  input: DeleteWizardResultInput;
}>;


export type RemoveMeasurementHistoryItemMutation = { __typename?: 'Mutation', deleteWizardResult?: { __typename?: 'MutationResult', status?: boolean } };

export type ReactivateExpiredSubscriptionMutationVariables = Exact<{
  input?: InputMaybe<ReactivateSubscriptionInput>;
}>;


export type ReactivateExpiredSubscriptionMutation = { __typename?: 'Mutation', reactivateExpiredSubscription?: { __typename?: 'SubscriptionOrder', redirectUrl?: string } };

export type SubscriptionPaymentMethodQueryVariables = Exact<{
  input?: InputMaybe<PaySubscriptionInput>;
}>;


export type SubscriptionPaymentMethodQuery = { __typename?: 'Query', subscriptionPaymentMethods?: Array<{ __typename?: 'PaymentMethod', title?: string, icon?: string, type?: string }> };

export type TryChargeExpiredSubscriptionMutationVariables = Exact<{
  input?: InputMaybe<ChargeSubscriptionInput>;
}>;


export type TryChargeExpiredSubscriptionMutation = { __typename?: 'Mutation', tryChargeExpiredSubscription?: { __typename?: 'ChargeStatus', success?: boolean, message?: string } };

export type UserExpiredSubscriptionsQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type UserExpiredSubscriptionsQuery = { __typename?: 'Query', user?: { __typename?: 'User', expiredSubscriptions?: Array<{ __typename?: 'UserSubscription', id: string, subscription?: { __typename?: 'Subscription', id: string }, subscriptionPeriod?: { __typename?: 'SubscriptionPeriod', id: string } }> } };

export type UserSubscriptionCancelMutationVariables = Exact<{
  input?: InputMaybe<UserSubscriptionCancelInput>;
}>;


export type UserSubscriptionCancelMutation = { __typename?: 'Mutation', userSubscriptionCancel?: { __typename?: 'MutationResult', status?: boolean } };

export type FamilyMemberInvitationDetailQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type FamilyMemberInvitationDetailQuery = { __typename?: 'Query', user?: { __typename?: 'User', profile?: { __typename?: 'Profile', fullName?: string, birthDate?: string, birthNumber?: string, address?: { __typename?: 'Address', formattedFullAddress?: string }, insuranceCompanyTermItem?: { __typename?: 'TermItem', value?: string, value2?: string } } } };

export type FamilyMembersQueryVariables = Exact<{ [key: string]: never; }>;


export type FamilyMembersQuery = { __typename?: 'Query', familyMembers?: { __typename?: 'FamilyMembersResult', data?: Array<{ __typename?: 'FamilyMember', id: number, role: FamilyMemberRole, user: { __typename?: 'User', id: string, profileImageUrl?: string, email?: string, profile?: { __typename?: 'Profile', firstName?: string } } }> } };

export type FamilyMemberQueryVariables = Exact<{
  id?: InputMaybe<Scalars['Int']>;
}>;


export type FamilyMemberQuery = { __typename?: 'Query', familyMember?: { __typename?: 'FamilyMember', canBeDeleted: boolean, canBeShared: boolean } };

export type SimpleUserQueryVariables = Exact<{
  id?: InputMaybe<Scalars['UUID']>;
}>;


export type SimpleUserQuery = { __typename?: 'Query', user?: { __typename?: 'User', profileImageUrl?: string, profile?: { __typename?: 'Profile', firstName?: string } } };

export type FullUserInfoQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type FullUserInfoQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, email?: string, phoneNumber?: string, formattedPhoneNumber?: string, isDoctor?: boolean, isChild?: boolean, partnerIdentifier?: string, partner?: string, csszResult?: any, vzpResult?: any, meta?: Array<{ __typename?: 'Meta', key?: string, value?: any }>, memberOf?: Array<{ __typename?: 'Badge', title?: string, theme?: string }>, parents?: Array<{ __typename?: 'User', id: string, profile?: { __typename?: 'Profile', fullName?: string, firstName?: string, lastName?: string } }>, badge?: { __typename?: 'Badge', title?: string, theme?: string }, avatarFile?: { __typename?: 'File', createdAt?: any }, profile?: { __typename?: 'Profile', age?: string, birthNumber?: string, formattedBirthNumber?: string, birthDate?: string, insuranceNumber?: string, gender?: string, formattedGender?: string, timezone?: string, fullName?: string, firstName?: string, lastName?: string, nationalityOther?: string, nationalityTermItem?: { __typename?: 'TermItem', id: string, name?: string, value?: string }, insuranceCompanyTermItem?: { __typename?: 'TermItem', name?: string, value?: string, value2?: string }, address?: { __typename?: 'Address', fullAddress?: string, shortAddress?: string, formattedFullAddress?: string, formattedShortAddress?: string, street?: string, postCode?: string, descriptiveNumber?: string, guideNumber?: string, city?: string, province?: string, street2?: string, floor?: string, district?: string, accommodationZone?: string, country?: string, region?: string, apartmentNumber?: string } }, rootWorkplace?: { __typename?: 'Workplace', name?: string, address?: { __typename?: 'Address', fullAddress?: string } }, workplace?: { __typename?: 'Workplace', name?: string, address?: { __typename?: 'Address', fullAddress?: string } }, invitations?: Array<{ __typename?: 'UserInvitation', code?: string, used?: boolean }> } };

export type CreateRatingMutationVariables = Exact<{
  input?: InputMaybe<CreateRatingInput>;
}>;


export type CreateRatingMutation = { __typename?: 'Mutation', createRating?: { __typename?: 'Rating', id: any } };

export type ActivateRedeemCodeMutationVariables = Exact<{
  input?: InputMaybe<ActivateUserSubscriptionByRedeemCode>;
}>;


export type ActivateRedeemCodeMutation = { __typename?: 'Mutation', activateUserSubscriptionByRedeemCode?: { __typename?: 'UserSubscription', id: string } };

export type MeddiAccountTransactionsQueryVariables = Exact<{
  where?: InputMaybe<MeddiAccountTransactionsWhereInput>;
  pagination?: InputMaybe<PaginationInput>;
}>;


export type MeddiAccountTransactionsQuery = { __typename?: 'Query', meddiAccountTransactions?: { __typename?: 'MeddiAccountTransactionResult', data?: Array<{ __typename?: 'MeddiTransaction', id?: any, type?: string, amount?: number, orderId?: any, order?: { __typename?: 'TransactionOrder', id?: string, issueDate?: any, status?: string, items?: Array<{ __typename?: 'TransactionOrderItem', title?: string, unit?: string, quantity?: number }> } }>, meta?: { __typename?: 'PageInfo', count?: number, page?: number, limit?: number, totalPages?: number } } };

export type MeddiAccountsQueryVariables = Exact<{
  where?: InputMaybe<MeddiAccountsWhereInput>;
}>;


export type MeddiAccountsQuery = { __typename?: 'Query', meddiAccounts?: { __typename?: 'MeddiAccountResult', data?: Array<{ __typename?: 'MeddiAccount', balance?: number, type?: MeddiAccountType }> } };

export type UserOrdersQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['UUID']>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
}>;


export type UserOrdersQuery = { __typename?: 'Query', orders?: { __typename?: 'OrdersResult', meta?: { __typename?: 'PageInfo', count?: number, page?: number, limit?: number, totalPages?: number }, data?: Array<{ __typename?: 'Order', id?: any, issueDate?: any, name?: string, paymentMethod?: OrderPaymentMethod, status?: OrderStatus, price?: { __typename?: 'TransactionPrice', formattedPrice?: string }, invoices?: Array<{ __typename?: 'Invoice', id?: any, url?: string, number?: string }>, orderLogs?: Array<{ __typename?: 'OrderLog', type?: string, value?: string }> }> } };

export type WizardPreviewFileQueryVariables = Exact<{
  fileId?: InputMaybe<Scalars['UUID']>;
}>;


export type WizardPreviewFileQuery = { __typename?: 'Query', documentationFiles?: { __typename?: 'DocumentationFilesResult', data: Array<{ __typename?: 'DocumentationFile', id: any, name?: string, userId?: any, folderId?: any, file?: { __typename?: 'File', id: any, extension?: string } }> } };

export type SubmitWizardMutationVariables = Exact<{
  input: WizardResultInput;
}>;


export type SubmitWizardMutation = { __typename?: 'Mutation', submitWizard?: { __typename?: 'SubmitWizardResult', id?: any, jobResult?: { __typename?: 'JobResult', jobId: any } } };

export type WorkplacesQueryVariables = Exact<{
  fulltext?: InputMaybe<Scalars['String']>;
  patientId?: InputMaybe<Scalars['UUID']>;
  type?: InputMaybe<Scalars['String']>;
  take?: InputMaybe<Scalars['Int']>;
  skip?: InputMaybe<Scalars['Int']>;
}>;


export type WorkplacesQuery = { __typename?: 'Query', workplaces?: { __typename?: 'WorkplacesResult', meta?: { __typename?: 'PageInfo', page?: number, totalPages?: number }, data: Array<{ __typename?: 'Workplace', id: string, name?: string }> } };


export const AvailableDoctorsDocument = `
    query AvailableDoctors($pattern: String!, $nurse: Boolean!, $workplaceId: UUID, $pagination: PaginationInput) {
  availableDoctors(
    pattern: $pattern
    nurse: $nurse
    workplaceId: $workplaceId
    pagination: $pagination
  ) {
    meta {
      page
      totalPages
      hasNextPage
    }
    data {
      id
      salutationBefore
      firstName
      lastName
      salutationAfter
      city
      clkId
    }
  }
}
    `;
export const TermItemsDocument = `
    query TermItems($termType: String, $fullText: String, $filter: TermItemsFilter, $take: Int, $pagination: PaginationInput) {
  termItems(
    termType: $termType
    fulltext: $fullText
    filter: $filter
    take: $take
    pagination: $pagination
  ) {
    data {
      id
      termId
      name
      value
      value2
      value3
      data
    }
  }
}
    `;
export const FilterCaseContactsDocument = `
    query FilterCaseContacts($fulltext: String, $caseTypeCode: String, $roleKeys: [String], $take: Int = 20, $skip: Int) {
  filterCaseContacts(
    fulltext: $fulltext
    caseTypeCode: $caseTypeCode
    roleKeys: $roleKeys
    pagination: {take: $take, skip: $skip}
  ) {
    meta {
      page
      totalPages
    }
    data {
      userId
      workplaceMemberId
      workplaceId
      textRow1
      textRow2
      textRow3
      type
      iconUrl
      workplaceMemberUserRelation(type: PATIENT_DOCTOR) {
        id
        userId
        user {
          profile {
            fullName
          }
        }
      }
    }
  }
}
    `;
export const CaseCreateUsersDocument = `
    query CaseCreateUsers($userIds: [UUID!]!) {
  users(take: 999, ids: $userIds) {
    data {
      id
      profileImageUrl
      profile {
        firstName
        lastName
        fullName
      }
      isChild
    }
  }
}
    `;
export const FamilyMembersAvailableForCaseCreateDocument = `
    query FamilyMembersAvailableForCaseCreate {
  familyMembersAvailableForCaseCreate {
    data {
      id
      profileImageUrl
      profile {
        firstName
        lastName
        fullName
      }
      isChild
    }
  }
}
    `;
export const DashboardMessagesDocument = `
    query DashboardMessages {
  dashboardMessages {
    id
    content
    type
    sender {
      user {
        profile {
          fullName
        }
        profileImageUrl
      }
    }
  }
}
    `;
export const ReadDashboardMessageDocument = `
    mutation ReadDashboardMessage($input: ReadDashboardMessageInput) {
  readDashboardMessage(input: $input) {
    id
  }
}
    `;
export const DocumentationFilesDocument = `
    query DocumentationFiles($fileIds: [UUID], $userId: UUID) {
  documentationFiles(fileIds: $fileIds, userId: $userId) {
    meta {
      page
      totalPages
    }
    data {
      id
      name
      extension
      displayName
      folderId
      hasThumb
      userId
      thumbUrl
      avResult
      createdAt
      file {
        id
        name
        extension
      }
      createdBy {
        id
        profile {
          fullName
        }
      }
      workplace {
        id
        name
      }
      fileTransfers {
        value
      }
      fileGroupId
      groupFiles {
        id
        name
        displayName
        createdAt
        thumbUrl
        userId
        folderId
        file {
          id
          name
          extension
        }
        avResult
      }
      groupFilesCount
    }
  }
}
    `;
export const CreateDrMaxPrescriptionReservationDocument = `
    mutation createDrMaxPrescriptionReservation($input: CreateDrMaxPrescriptionReservationInput) {
  createDrMaxPrescriptionReservation(input: $input) {
    incrementId
  }
}
    `;
export const GetDrMaxPickupPlacesDocument = `
    query getDrMaxPickupPlaces($prescriptionId: UUID, $search: String, $pagination: PaginationInput) {
  drmaxPickupPlaces(
    search: $search
    prescriptionId: $prescriptionId
    pagination: $pagination
  ) {
    meta {
      count
      page
      limit
      totalPages
    }
    data {
      id
      name
      isOpen
      productsInStock {
        name
        inStock
      }
      distanceFormatted
      openingHours {
        date
        open
        nonstop
        hours {
          to
          from
          note
          open
        }
      }
    }
  }
}
    `;
export const GetDrMaxPrescriptionMedicamentsDocument = `
    query getDrMaxPrescriptionMedicaments($prescriptionId: UUID!, $drmaxPickupPlaceId: UUID, $pagination: PaginationInput) {
  drmaxPrescriptionMedicaments(
    prescriptionId: $prescriptionId
    pagination: $pagination
  ) {
    meta {
      count
      page
      limit
      totalPages
    }
    data {
      name
      formattedApproximatePrice(drmaxPickupPlaceId: $drmaxPickupPlaceId)
      inStock(drmaxPickupPlaceId: $drmaxPickupPlaceId)
    }
  }
}
    `;
export const GetPrescriptionDocument = `
    query getPrescription($prescriptionId: UUID!) {
  prescription(id: $prescriptionId) {
    drMaxPickupPlace {
      openingHours {
        date
        open
        nonstop
        hours {
          to
          from
          note
          open
        }
      }
    }
  }
}
    `;
export const FamilyMemberRelationDocument = `
    mutation familyMemberRelation($input: FamilyMemberRelationInput) {
  familyMemberRelation(input: $input) {
    userId
  }
}
    `;
export const GetFamilyMemberShareListDocument = `
    query getFamilyMemberShareList($childId: UUID!) {
  familyMemberShareList(childId: $childId) {
    meta {
      count
    }
    data {
      userId
      user {
        profileImageUrl
        profile {
          fullName
        }
      }
      role
    }
  }
}
    `;
export const GetFamilyMembersDocument = `
    query getFamilyMembers($pagination: PaginationInput, $role: FamilyMemberRole) {
  familyMembers(pagination: $pagination, role: $role) {
    data {
      userId
      user {
        profileImageUrl
        profile {
          fullName
        }
      }
      role
    }
  }
}
    `;
export const FamilyMemberUserDataDocument = `
    query familyMemberUserData($id: UUID) {
  user(id: $id) {
    id
    isPatient
    profile {
      fullName
      birthDate
      formattedBirthNumber
      address {
        formattedFullAddress
      }
      insuranceCompanyTermItem {
        value
        value2
      }
    }
    meta {
      key
      value
    }
  }
}
    `;
export const UpdateUserConsentDocument = `
    mutation UpdateUserConsent($where: UserConsentsWhereInput, $data: UpdateUserConsentInput) {
  updateUserConsent(where: $where, data: $data) {
    id
  }
}
    `;
export const UserConsentsDocument = `
    query UserConsents($where: UserConsentsWhereInput, $take: Int = 20, $skip: Int) {
  userConsents(where: $where, pagination: {skip: $skip, take: $take}) {
    meta {
      page
      totalPages
    }
    data {
      id
      type
      userId
      name
      workplace {
        name
        address {
          fullAddress
        }
      }
      createdBy {
        profile {
          fullName
        }
      }
      createdAt
      confirmedAt
      canceledAt
      value
      documentationFile {
        id
        userId
        folderId
        name
        file {
          id
          extension
        }
      }
    }
  }
}
    `;
export const MeasurementHistoryDocument = `
    query MeasurementHistory($where: WizardResultsWhereInput, $take: Int = 20, $skip: Int) {
  wizardResults(where: $where, pagination: {skip: $skip, take: $take}) {
    meta {
      page
      totalPages
    }
    data {
      id
      createdAt
      wizardResultItems(
        where: {showSystemKeys: false}
        pagination: {order: {how: ASC, key: "key"}}
      ) {
        id
        key
        value
        formattedValue
        label
      }
    }
    settings
  }
}
    `;
export const RemoveMeasurementHistoryItemDocument = `
    mutation RemoveMeasurementHistoryItem($input: DeleteWizardResultInput!) {
  deleteWizardResult(input: $input) {
    status
  }
}
    `;
export const ReactivateExpiredSubscriptionDocument = `
    mutation reactivateExpiredSubscription($input: ReactivateSubscriptionInput) {
  reactivateExpiredSubscription(input: $input) {
    redirectUrl
  }
}
    `;
export const SubscriptionPaymentMethodDocument = `
    query subscriptionPaymentMethod($input: PaySubscriptionInput) {
  subscriptionPaymentMethods(subscriptionOrder: $input) {
    title
    icon
    type
  }
}
    `;
export const TryChargeExpiredSubscriptionDocument = `
    mutation tryChargeExpiredSubscription($input: ChargeSubscriptionInput) {
  tryChargeExpiredSubscription(input: $input) {
    success
    message
  }
}
    `;
export const UserExpiredSubscriptionsDocument = `
    query userExpiredSubscriptions($id: UUID) {
  user(id: $id) {
    expiredSubscriptions {
      id
      subscription {
        id
      }
      subscriptionPeriod {
        id
      }
    }
  }
}
    `;
export const UserSubscriptionCancelDocument = `
    mutation UserSubscriptionCancel($input: UserSubscriptionCancelInput) {
  userSubscriptionCancel(input: $input) {
    status
  }
}
    `;
export const FamilyMemberInvitationDetailDocument = `
    query familyMemberInvitationDetail($id: UUID) {
  user(id: $id) {
    profile {
      fullName
      birthDate
      birthNumber
      address {
        formattedFullAddress
      }
      insuranceCompanyTermItem {
        value
        value2
      }
    }
  }
}
    `;
export const FamilyMembersDocument = `
    query familyMembers {
  familyMembers(pagination: {take: 999}) {
    data {
      id
      user {
        id
        profileImageUrl
        profile {
          firstName
        }
        email
      }
      role
    }
  }
}
    `;
export const FamilyMemberDocument = `
    query familyMember($id: Int) {
  familyMember(where: {id: $id}) {
    canBeDeleted
    canBeShared
  }
}
    `;
export const SimpleUserDocument = `
    query simpleUser($id: UUID) {
  user(id: $id) {
    profileImageUrl
    profile {
      firstName
    }
  }
}
    `;
export const FullUserInfoDocument = `
    query fullUserInfo($id: UUID!) {
  user(id: $id) {
    id
    email
    phoneNumber
    formattedPhoneNumber
    isDoctor
    isChild
    partnerIdentifier
    partner
    meta {
      key
      value
    }
    memberOf {
      title
      theme
    }
    parents {
      id
      profile {
        fullName
        firstName
        lastName
      }
    }
    csszResult
    vzpResult
    badge {
      title
      theme
    }
    avatarFile {
      createdAt
    }
    profile {
      age
      birthNumber
      formattedBirthNumber
      birthDate
      insuranceNumber
      gender
      formattedGender
      timezone
      fullName
      firstName
      lastName
      nationalityTermItem {
        id
        name
        value
      }
      nationalityOther
      insuranceCompanyTermItem {
        name
        value
        value2
      }
      address {
        fullAddress
        shortAddress
        formattedFullAddress
        formattedShortAddress
        street
        postCode
        descriptiveNumber
        guideNumber
        city
        province
        street2
        floor
        district
        accommodationZone
        country
        region
        apartmentNumber
      }
    }
    rootWorkplace {
      name
      address {
        fullAddress
      }
    }
    workplace {
      name
      address {
        fullAddress
      }
    }
    invitations {
      code
      used
    }
  }
}
    `;
export const CreateRatingDocument = `
    mutation CreateRating($input: CreateRatingInput) {
  createRating(input: $input) {
    id
  }
}
    `;
export const ActivateRedeemCodeDocument = `
    mutation ActivateRedeemCode($input: ActivateUserSubscriptionByRedeemCode) {
  activateUserSubscriptionByRedeemCode(input: $input) {
    id
  }
}
    `;
export const MeddiAccountTransactionsDocument = `
    query MeddiAccountTransactions($where: MeddiAccountTransactionsWhereInput, $pagination: PaginationInput) {
  meddiAccountTransactions(where: $where, pagination: $pagination) {
    data {
      id
      type
      amount
      orderId
      order {
        id
        issueDate
        status
        items {
          title
          unit
          quantity
        }
      }
    }
    meta {
      count
      page
      limit
      totalPages
    }
  }
}
    `;
export const MeddiAccountsDocument = `
    query MeddiAccounts($where: MeddiAccountsWhereInput) {
  meddiAccounts(where: $where) {
    data {
      balance
      type
    }
  }
}
    `;
export const UserOrdersDocument = `
    query userOrders($userId: UUID, $skip: Int, $take: Int = 20) {
  orders(
    filter: {orderMembers: [$userId]}
    pagination: {skip: $skip, take: $take}
  ) {
    meta {
      count
      page
      limit
      totalPages
    }
    data {
      id
      issueDate
      name
      price {
        formattedPrice
      }
      paymentMethod
      invoices {
        id
        url
        number
      }
      orderLogs {
        type
        value
      }
      status
    }
  }
}
    `;
export const WizardPreviewFileDocument = `
    query WizardPreviewFile($fileId: UUID) {
  documentationFiles(fileIds: [$fileId]) {
    data {
      id
      name
      userId
      folderId
      file {
        id
        extension
      }
    }
  }
}
    `;
export const SubmitWizardDocument = `
    mutation SubmitWizard($input: WizardResultInput!) {
  submitWizard(input: $input) {
    id
    jobResult {
      jobId
    }
  }
}
    `;
export const WorkplacesDocument = `
    query Workplaces($fulltext: String, $patientId: UUID, $type: String, $take: Int = 20, $skip: Int) {
  workplaces(
    fulltext: $fulltext
    patientId: $patientId
    type: $type
    pagination: {take: $take, skip: $skip}
  ) {
    meta {
      page
      totalPages
    }
    data {
      id
      name
    }
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    AvailableDoctors: build.query<AvailableDoctorsQuery, AvailableDoctorsQueryVariables>({
      query: (variables) => ({ document: AvailableDoctorsDocument, variables })
    }),
    TermItems: build.query<TermItemsQuery, TermItemsQueryVariables | void>({
      query: (variables) => ({ document: TermItemsDocument, variables })
    }),
    FilterCaseContacts: build.query<FilterCaseContactsQuery, FilterCaseContactsQueryVariables | void>({
      query: (variables) => ({ document: FilterCaseContactsDocument, variables })
    }),
    CaseCreateUsers: build.query<CaseCreateUsersQuery, CaseCreateUsersQueryVariables>({
      query: (variables) => ({ document: CaseCreateUsersDocument, variables })
    }),
    FamilyMembersAvailableForCaseCreate: build.query<FamilyMembersAvailableForCaseCreateQuery, FamilyMembersAvailableForCaseCreateQueryVariables | void>({
      query: (variables) => ({ document: FamilyMembersAvailableForCaseCreateDocument, variables })
    }),
    DashboardMessages: build.query<DashboardMessagesQuery, DashboardMessagesQueryVariables | void>({
      query: (variables) => ({ document: DashboardMessagesDocument, variables })
    }),
    ReadDashboardMessage: build.mutation<ReadDashboardMessageMutation, ReadDashboardMessageMutationVariables | void>({
      query: (variables) => ({ document: ReadDashboardMessageDocument, variables })
    }),
    DocumentationFiles: build.query<DocumentationFilesQuery, DocumentationFilesQueryVariables | void>({
      query: (variables) => ({ document: DocumentationFilesDocument, variables })
    }),
    createDrMaxPrescriptionReservation: build.mutation<CreateDrMaxPrescriptionReservationMutation, CreateDrMaxPrescriptionReservationMutationVariables | void>({
      query: (variables) => ({ document: CreateDrMaxPrescriptionReservationDocument, variables })
    }),
    getDrMaxPickupPlaces: build.query<GetDrMaxPickupPlacesQuery, GetDrMaxPickupPlacesQueryVariables | void>({
      query: (variables) => ({ document: GetDrMaxPickupPlacesDocument, variables })
    }),
    getDrMaxPrescriptionMedicaments: build.query<GetDrMaxPrescriptionMedicamentsQuery, GetDrMaxPrescriptionMedicamentsQueryVariables>({
      query: (variables) => ({ document: GetDrMaxPrescriptionMedicamentsDocument, variables })
    }),
    getPrescription: build.query<GetPrescriptionQuery, GetPrescriptionQueryVariables>({
      query: (variables) => ({ document: GetPrescriptionDocument, variables })
    }),
    familyMemberRelation: build.mutation<FamilyMemberRelationMutation, FamilyMemberRelationMutationVariables | void>({
      query: (variables) => ({ document: FamilyMemberRelationDocument, variables })
    }),
    getFamilyMemberShareList: build.query<GetFamilyMemberShareListQuery, GetFamilyMemberShareListQueryVariables>({
      query: (variables) => ({ document: GetFamilyMemberShareListDocument, variables })
    }),
    getFamilyMembers: build.query<GetFamilyMembersQuery, GetFamilyMembersQueryVariables | void>({
      query: (variables) => ({ document: GetFamilyMembersDocument, variables })
    }),
    familyMemberUserData: build.query<FamilyMemberUserDataQuery, FamilyMemberUserDataQueryVariables | void>({
      query: (variables) => ({ document: FamilyMemberUserDataDocument, variables })
    }),
    UpdateUserConsent: build.mutation<UpdateUserConsentMutation, UpdateUserConsentMutationVariables | void>({
      query: (variables) => ({ document: UpdateUserConsentDocument, variables })
    }),
    UserConsents: build.query<UserConsentsQuery, UserConsentsQueryVariables | void>({
      query: (variables) => ({ document: UserConsentsDocument, variables })
    }),
    MeasurementHistory: build.query<MeasurementHistoryQuery, MeasurementHistoryQueryVariables | void>({
      query: (variables) => ({ document: MeasurementHistoryDocument, variables })
    }),
    RemoveMeasurementHistoryItem: build.mutation<RemoveMeasurementHistoryItemMutation, RemoveMeasurementHistoryItemMutationVariables>({
      query: (variables) => ({ document: RemoveMeasurementHistoryItemDocument, variables })
    }),
    reactivateExpiredSubscription: build.mutation<ReactivateExpiredSubscriptionMutation, ReactivateExpiredSubscriptionMutationVariables | void>({
      query: (variables) => ({ document: ReactivateExpiredSubscriptionDocument, variables })
    }),
    subscriptionPaymentMethod: build.query<SubscriptionPaymentMethodQuery, SubscriptionPaymentMethodQueryVariables | void>({
      query: (variables) => ({ document: SubscriptionPaymentMethodDocument, variables })
    }),
    tryChargeExpiredSubscription: build.mutation<TryChargeExpiredSubscriptionMutation, TryChargeExpiredSubscriptionMutationVariables | void>({
      query: (variables) => ({ document: TryChargeExpiredSubscriptionDocument, variables })
    }),
    userExpiredSubscriptions: build.query<UserExpiredSubscriptionsQuery, UserExpiredSubscriptionsQueryVariables | void>({
      query: (variables) => ({ document: UserExpiredSubscriptionsDocument, variables })
    }),
    UserSubscriptionCancel: build.mutation<UserSubscriptionCancelMutation, UserSubscriptionCancelMutationVariables | void>({
      query: (variables) => ({ document: UserSubscriptionCancelDocument, variables })
    }),
    familyMemberInvitationDetail: build.query<FamilyMemberInvitationDetailQuery, FamilyMemberInvitationDetailQueryVariables | void>({
      query: (variables) => ({ document: FamilyMemberInvitationDetailDocument, variables })
    }),
    familyMembers: build.query<FamilyMembersQuery, FamilyMembersQueryVariables | void>({
      query: (variables) => ({ document: FamilyMembersDocument, variables })
    }),
    familyMember: build.query<FamilyMemberQuery, FamilyMemberQueryVariables | void>({
      query: (variables) => ({ document: FamilyMemberDocument, variables })
    }),
    simpleUser: build.query<SimpleUserQuery, SimpleUserQueryVariables | void>({
      query: (variables) => ({ document: SimpleUserDocument, variables })
    }),
    fullUserInfo: build.query<FullUserInfoQuery, FullUserInfoQueryVariables>({
      query: (variables) => ({ document: FullUserInfoDocument, variables })
    }),
    CreateRating: build.mutation<CreateRatingMutation, CreateRatingMutationVariables | void>({
      query: (variables) => ({ document: CreateRatingDocument, variables })
    }),
    ActivateRedeemCode: build.mutation<ActivateRedeemCodeMutation, ActivateRedeemCodeMutationVariables | void>({
      query: (variables) => ({ document: ActivateRedeemCodeDocument, variables })
    }),
    MeddiAccountTransactions: build.query<MeddiAccountTransactionsQuery, MeddiAccountTransactionsQueryVariables | void>({
      query: (variables) => ({ document: MeddiAccountTransactionsDocument, variables })
    }),
    MeddiAccounts: build.query<MeddiAccountsQuery, MeddiAccountsQueryVariables | void>({
      query: (variables) => ({ document: MeddiAccountsDocument, variables })
    }),
    userOrders: build.query<UserOrdersQuery, UserOrdersQueryVariables | void>({
      query: (variables) => ({ document: UserOrdersDocument, variables })
    }),
    WizardPreviewFile: build.query<WizardPreviewFileQuery, WizardPreviewFileQueryVariables | void>({
      query: (variables) => ({ document: WizardPreviewFileDocument, variables })
    }),
    SubmitWizard: build.mutation<SubmitWizardMutation, SubmitWizardMutationVariables>({
      query: (variables) => ({ document: SubmitWizardDocument, variables })
    }),
    Workplaces: build.query<WorkplacesQuery, WorkplacesQueryVariables | void>({
      query: (variables) => ({ document: WorkplacesDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useAvailableDoctorsQuery, useLazyAvailableDoctorsQuery, useTermItemsQuery, useLazyTermItemsQuery, useFilterCaseContactsQuery, useLazyFilterCaseContactsQuery, useCaseCreateUsersQuery, useLazyCaseCreateUsersQuery, useFamilyMembersAvailableForCaseCreateQuery, useLazyFamilyMembersAvailableForCaseCreateQuery, useDashboardMessagesQuery, useLazyDashboardMessagesQuery, useReadDashboardMessageMutation, useDocumentationFilesQuery, useLazyDocumentationFilesQuery, useCreateDrMaxPrescriptionReservationMutation, useGetDrMaxPickupPlacesQuery, useLazyGetDrMaxPickupPlacesQuery, useGetDrMaxPrescriptionMedicamentsQuery, useLazyGetDrMaxPrescriptionMedicamentsQuery, useGetPrescriptionQuery, useLazyGetPrescriptionQuery, useFamilyMemberRelationMutation, useGetFamilyMemberShareListQuery, useLazyGetFamilyMemberShareListQuery, useGetFamilyMembersQuery, useLazyGetFamilyMembersQuery, useFamilyMemberUserDataQuery, useLazyFamilyMemberUserDataQuery, useUpdateUserConsentMutation, useUserConsentsQuery, useLazyUserConsentsQuery, useMeasurementHistoryQuery, useLazyMeasurementHistoryQuery, useRemoveMeasurementHistoryItemMutation, useReactivateExpiredSubscriptionMutation, useSubscriptionPaymentMethodQuery, useLazySubscriptionPaymentMethodQuery, useTryChargeExpiredSubscriptionMutation, useUserExpiredSubscriptionsQuery, useLazyUserExpiredSubscriptionsQuery, useUserSubscriptionCancelMutation, useFamilyMemberInvitationDetailQuery, useLazyFamilyMemberInvitationDetailQuery, useFamilyMembersQuery, useLazyFamilyMembersQuery, useFamilyMemberQuery, useLazyFamilyMemberQuery, useSimpleUserQuery, useLazySimpleUserQuery, useFullUserInfoQuery, useLazyFullUserInfoQuery, useCreateRatingMutation, useActivateRedeemCodeMutation, useMeddiAccountTransactionsQuery, useLazyMeddiAccountTransactionsQuery, useMeddiAccountsQuery, useLazyMeddiAccountsQuery, useUserOrdersQuery, useLazyUserOrdersQuery, useWizardPreviewFileQuery, useLazyWizardPreviewFileQuery, useSubmitWizardMutation, useWorkplacesQuery, useLazyWorkplacesQuery } = injectedRtkApi;

